const arr = [
    { port_code: 'ABW000', port_ch: '阿鲁巴' },
    { port_code: 'ABW003', port_ch: '奥拉涅斯塔德（阿鲁巴）' },
    { port_code: 'ABW006', port_ch: '圣尼古拉斯湾（阿鲁巴）' },
    { port_code: 'AFG000', port_ch: '阿富汗' },
    { port_code: 'AFG001', port_ch: '喀布尔（阿富汗）' },
    { port_code: 'AFG002', port_ch: '坎大哈（阿富汗）' },
    { port_code: 'AGO000', port_ch: '安哥拉' },
    { port_code: 'AGO003', port_ch: '安布里什（安哥拉）' },
    { port_code: 'AGO006', port_ch: '安布里泽特（安哥拉）' },
    { port_code: 'AGO009', port_ch: '木格拉（安哥拉）' },
    { port_code: 'AGO012', port_ch: '卡宾达（安哥拉）' },
    { port_code: 'AGO015', port_ch: '洛比托（安哥拉）' },
    { port_code: 'AGO018', port_ch: '罗安达（安哥拉）' },
    { port_code: 'AGO021', port_ch: '木萨米迪什（安哥拉）' },
    { port_code: 'AGO024', port_ch: '松贝（新里东杜）（安哥拉）' },
    { port_code: 'AGO026', port_ch: '纳米贝（安哥拉）' },
    { port_code: 'AGO027', port_ch: '亚历山大港（安哥拉）' },
    { port_code: 'AGO030', port_ch: '安博因港（安哥拉）' },
    { port_code: 'AGO033', port_ch: '萨拉萨尔港（安哥拉）' },
    { port_code: 'AIA000', port_ch: '安圭拉' },
    { port_code: 'AIA003', port_ch: '路德湾（安圭拉）' },
    { port_code: 'ALA000', port_ch: '阿兰群岛（波罗的海中芬兰所属群岛）' },
    { port_code: 'ALB000', port_ch: '阿尔巴尼亚' },
    { port_code: 'ALB003', port_ch: '都拉斯（阿尔巴尼亚）' },
    { port_code: 'ALB006', port_ch: '萨兰达（阿尔巴尼亚）' },
    { port_code: 'ALB009', port_ch: '圣吉尼（阿尔巴尼亚）' },
    { port_code: 'ALB012', port_ch: '发罗拉（阿尔巴尼亚）' },
    { port_code: 'AND000', port_ch: '安道尔' },
    { port_code: 'AND001', port_ch: '安道尔（安道尔）' },
    { port_code: 'ARE000', port_ch: '阿联酋' },
    { port_code: 'ARE003', port_ch: '阿布埃尔布霍希（阿联酋）' },
    { port_code: 'ARE006', port_ch: '阿布扎比（阿联酋）' },
    { port_code: 'ARE009', port_ch: '阿治曼（阿联酋）' },
    { port_code: 'ARE015', port_ch: '达斯岛（阿联酋）' },
    { port_code: 'ARE018', port_ch: '迪拜（阿联酋）' },
    { port_code: 'ARE021', port_ch: '法特油码头（阿联酋）' },
    { port_code: 'ARE024', port_ch: '富查伊拉（阿联酋）' },
    { port_code: 'ARE027', port_ch: '阿里山（阿联酋）' },
    { port_code: 'ARE030', port_ch: '杰贝尔丹那（阿联酋）' },
    { port_code: 'ARE033', port_ch: '豪尔费坎（阿联酋）' },
    { port_code: 'ARE036', port_ch: '沙奎港（阿联酋）' },
    { port_code: 'ARE039', port_ch: '扎伊德港（阿联酋）' },
    { port_code: 'ARE042', port_ch: '穆巴腊岛（阿联酋）' },
    { port_code: 'ARE045', port_ch: '哈伊马角（阿联酋）' },
    { port_code: 'ARE051', port_ch: '乌姆盖万（阿联酋）' },
    { port_code: 'ARE054', port_ch: '拉希德港（阿联酋）' },
    { port_code: 'ARE901', port_ch: '沙迦（阿联酋）' },
    { port_code: 'ARG000', port_ch: '阿根廷' },
    { port_code: 'ARG001', port_ch: '皮拖（阿根廷）' },
    { port_code: 'ARG002', port_ch: '白奥哥港（阿根廷）' },
    { port_code: 'ARG003', port_ch: '布兰卡港（阿根廷）' },
    { port_code: 'ARG006', port_ch: '布宜诺斯艾利斯（阿根廷）' },
    { port_code: 'ARG008', port_ch: '奥利维亚（阿根廷）' },
    { port_code: 'ARG009', port_ch: '坎帕纳（阿根廷）' },
    { port_code: 'ARG012', port_ch: '里瓦达维亚海军准将城（阿根廷）' },
    { port_code: 'ARG015', port_ch: '康塞普西翁（阿根廷）' },
    { port_code: 'ARG018', port_ch: '迪亚曼泰（阿根廷）' },
    { port_code: 'ARG021', port_ch: '伊比奎（阿根廷）' },
    { port_code: 'ARG024', port_ch: '拉普拉塔（阿根廷）' },
    { port_code: 'ARG027', port_ch: '马德普拉塔（阿根廷）' },
    { port_code: 'ARG030', port_ch: '内科切阿（阿根廷）' },
    { port_code: 'ARG033', port_ch: '阿塞维多港（阿根廷）' },
    { port_code: 'ARG036', port_ch: '德塞阿多港（阿根廷）' },
    { port_code: 'ARG039', port_ch: '马德林港（阿根廷）' },
    { port_code: 'ARG042', port_ch: '科罗拉多角（阿根廷）' },
    { port_code: 'ARG045', port_ch: '蓬塔基利亚（阿根廷）' },
    { port_code: 'ARG048', port_ch: '克肯（阿根廷）' },
    { port_code: 'ARG051', port_ch: '拉马约（阿根廷）' },
    { port_code: 'ARG054', port_ch: '雷卡拉达（阿根廷）' },
    { port_code: 'ARG057', port_ch: '里奥加耶戈斯（阿根廷）' },
    { port_code: 'ARG060', port_ch: '里奥格兰德（阿根廷）' },
    { port_code: 'ARG063', port_ch: '罗萨里奥（阿根廷）' },
    { port_code: 'ARG066', port_ch: '圣安东尼奥（阿根廷）' },
    { port_code: 'ARG069', port_ch: '圣弗尔南多（阿根廷）' },
    { port_code: 'ARG072', port_ch: '圣洛伦索（阿根廷）' },
    { port_code: 'ARG074', port_ch: '圣胡利安（阿根廷）' },
    { port_code: 'ARG075', port_ch: '圣尼古拉斯（阿根廷）' },
    { port_code: 'ARG078', port_ch: '圣佩德罗（阿根廷）' },
    { port_code: 'ARG081', port_ch: '圣塞瓦斯蒂安（阿根廷）' },
    { port_code: 'ARG084', port_ch: '圣克鲁斯（阿根廷）' },
    { port_code: 'ARG087', port_ch: '圣菲（阿根廷）' },
    { port_code: 'ARG090', port_ch: '乌斯怀亚（阿根廷）' },
    { port_code: 'ARG093', port_ch: '孔斯蒂图西翁镇（阿根廷）' },
    { port_code: 'ARG096', port_ch: '萨拉特（阿根廷）' },
    { port_code: 'ARM000', port_ch: '亚美尼亚' },
    { port_code: 'ASM000', port_ch: '美属萨摩亚' },
    { port_code: 'ASM003', port_ch: '帕果帕果（美属萨摩亚）' },
    { port_code: 'ASM004', port_ch: '图图伊拉（美属萨摩亚）' },
    { port_code: 'ATA000', port_ch: '南极洲' },
    { port_code: 'ATF000', port_ch: '法属南部领土' },
    { port_code: 'ATG000', port_ch: '安提瓜和巴布达' },
    { port_code: 'ATG003', port_ch: '圣约翰斯（安提瓜和巴布达）' },
    { port_code: 'AUS000', port_ch: '澳大利亚' },
    { port_code: 'AUS003', port_ch: '阿伯特湾（澳大利亚）' },
    { port_code: 'AUS004', port_ch: '调查岛（阿根廷）' },
    { port_code: 'AUS006', port_ch: '阿德莱德（澳大利亚）' },
    { port_code: 'AUS009', port_ch: '奥尔巴尼（澳大利亚）' },
    { port_code: 'AUS012', port_ch: '阿德罗森（澳大利亚）' },
    { port_code: 'AUS015', port_ch: '巴拉斯特黑德（澳大利亚）' },
    { port_code: 'AUS018', port_ch: '巴罗岛（澳大利亚）' },
    { port_code: 'AUS021', port_ch: '搏尤替角（澳大利亚）' },
    { port_code: 'AUS024', port_ch: '贝尔贝（澳大利亚）' },
    { port_code: 'AUS027', port_ch: '植物学湾（澳大利亚）' },
    { port_code: 'AUS030', port_ch: '鲍恩（澳大利亚）' },
    { port_code: 'AUS033', port_ch: '布里斯班（澳大利亚）' },
    { port_code: 'AUS036', port_ch: '布鲁姆（澳大利亚）' },
    { port_code: 'AUS039', port_ch: '班伯里（澳大利亚）' },
    { port_code: 'AUS042', port_ch: '班达伯格（澳大利亚）' },
    { port_code: 'AUS045', port_ch: '伯尼（澳大利亚）' },
    { port_code: 'AUS048', port_ch: '巴瑟尔顿（澳大利亚）' },
    { port_code: 'AUS051', port_ch: '凯恩斯（澳大利亚）' },
    { port_code: 'AUS054', port_ch: '库维恩角（澳大利亚）' },
    { port_code: 'AUS057', port_ch: '拉姆贝特角（澳大利亚）' },
    { port_code: 'AUS060', port_ch: '卡那封（澳大利亚）' },
    { port_code: 'AUS063', port_ch: '喀斯喀特湾（澳大利亚）' },
    { port_code: 'AUS066', port_ch: '科夫斯港（澳大利亚）' },
    { port_code: 'AUS069', port_ch: '库克敦（澳大利亚）' },
    { port_code: 'AUS072', port_ch: '丹皮尔（澳大利亚）' },
    { port_code: 'AUS075', port_ch: '达尔文（澳大利亚）' },
    { port_code: 'AUS078', port_ch: '德比（澳大利亚）' },
    { port_code: 'AUS081', port_ch: '德文波特（澳大利亚）' },
    { port_code: 'AUS084', port_ch: '伊登（澳大利亚）' },
    { port_code: 'AUS087', port_ch: '伊迪斯堡（澳大利亚）' },
    { port_code: 'AUS090', port_ch: '埃斯佩兰斯（澳大利亚）' },
    { port_code: 'AUS093', port_ch: '弗里曼特尔（澳大利亚）' },
    { port_code: 'AUS096', port_ch: '吉朗（澳大利亚）' },
    { port_code: 'AUS099', port_ch: '杰拉尔顿（澳大利亚）' },
    { port_code: 'AUS102', port_ch: '格拉德斯通（澳大利亚）' },
    { port_code: 'AUS105', port_ch: '戈弗（澳大利亚）' },
    { port_code: 'AUS108', port_ch: '格拉夫顿（澳大利亚）' },
    { port_code: 'AUS111', port_ch: '格鲁特岛（澳大利亚）' },
    { port_code: 'AUS114', port_ch: '海波因特（澳大利亚）' },
    { port_code: 'AUS117', port_ch: '霍巴特（澳大利亚）' },
    { port_code: 'AUS120', port_ch: '因尼斯费尔（澳大利亚）' },
    { port_code: 'AUS123', port_ch: '金斯科特（澳大利亚）' },
    { port_code: 'AUS126', port_ch: '金斯敦（澳大利亚）' },
    { port_code: 'AUS129', port_ch: '奎纳纳（澳大利亚）' },
    { port_code: 'AUS132', port_ch: '朗塞斯顿（澳大利亚）' },
    { port_code: 'AUS135', port_ch: '户辛达（澳大利亚）' },
    { port_code: 'AUS138', port_ch: '麦凯（澳大利亚）' },
    { port_code: 'AUS141', port_ch: '麦克坦（澳大利亚）' },
    { port_code: 'AUS144', port_ch: '马里伯勒（澳大利亚）' },
    { port_code: 'AUS147', port_ch: '墨尔本（澳大利亚）' },
    { port_code: 'AUS150', port_ch: '莫里扬港（澳大利亚）' },
    { port_code: 'AUS153', port_ch: '纽卡斯尔（澳大利亚）' },
    { port_code: 'AUS156', port_ch: '帕斯（澳大利亚）' },
    { port_code: 'AUS159', port_ch: '阿德莱德港（澳大利亚）' },
    { port_code: 'AUS162', port_ch: '艾尔弗雷德港（澳大利亚）' },
    { port_code: 'AUS165', port_ch: '阿尔马港（澳大利亚）' },
    { port_code: 'AUS168', port_ch: '奥古斯塔港（澳大利亚）' },
    { port_code: 'AUS171', port_ch: '吉利港（澳大利亚）' },
    { port_code: 'AUS174', port_ch: '黑德兰港（澳大利亚）' },
    { port_code: 'AUS177', port_ch: '会翁港（澳大利亚）' },
    { port_code: 'AUS180', port_ch: '杰克逊港（澳大利亚）' },
    { port_code: 'AUS183', port_ch: '肯布拉港（澳大利亚）' },
    { port_code: 'AUS186', port_ch: '拉塔港（澳大利亚）' },
    { port_code: 'AUS189', port_ch: '林肯港（澳大利亚）' },
    { port_code: 'AUS192', port_ch: '麦夸里港（澳大利亚）' },
    { port_code: 'AUS195', port_ch: '皮里港（澳大利亚）' },
    { port_code: 'AUS198', port_ch: '斯坦瓦克港（澳大利亚）' },
    { port_code: 'AUS201', port_ch: '沃尔科特港（澳大利亚）' },
    { port_code: 'AUS204', port_ch: '波特兰（澳大利亚）' },
    { port_code: 'AUS207', port_ch: '拉皮德湾（澳大利亚）' },
    { port_code: 'AUS210', port_ch: '里司登（澳大利亚）' },
    { port_code: 'AUS213', port_ch: '罗克汉普顿（澳大利亚）' },
    { port_code: 'AUS216', port_ch: '斯坦利（澳大利亚）' },
    { port_code: 'AUS219', port_ch: '斯坦豪斯湾（澳大利亚）' },
    { port_code: 'AUS222', port_ch: '斯特拉恩（澳大利亚）' },
    { port_code: 'AUS225', port_ch: '悉尼（澳大利亚）' },
    { port_code: 'AUS228', port_ch: '泰弗纳德（澳大利亚）' },
    { port_code: 'AUS231', port_ch: '星期四岛（澳大利亚）' },
    { port_code: 'AUS234', port_ch: '汤斯维尔（澳大利亚）' },
    { port_code: 'AUS237', port_ch: '尤兰根（澳大利亚）' },
    { port_code: 'AUS240', port_ch: '乌塞勒斯卢普（澳大利亚）' },
    { port_code: 'AUS243', port_ch: '沃拉鲁（澳大利亚）' },
    { port_code: 'AUS246', port_ch: '韦帕（澳大利亚）' },
    { port_code: 'AUS249', port_ch: '西港（澳大利亚）' },
    { port_code: 'AUS252', port_ch: '怀阿拉（澳大利亚）' },
    { port_code: 'AUS255', port_ch: '温德姆（澳大利亚）' },
    { port_code: 'AUS258', port_ch: '杨巴（澳大利亚）' },
    { port_code: 'AUS261', port_ch: '扬皮桑德（澳大利亚）' },
    { port_code: 'AUS903', port_ch: '菲利普港（澳大利亚）' },
    { port_code: 'AUS904', port_ch: '堪培拉（澳大利亚）' },
    { port_code: 'AUS905', port_ch: '克拉伦斯河（澳大利亚）' },
    { port_code: 'AUS908', port_ch: '穆里兰港（澳大利亚）' },
    { port_code: 'AUS909', port_ch: '朴次伊（澳大利亚）' },
    { port_code: 'AUS911', port_ch: '圣诞岛（澳大利亚）' },
    { port_code: 'AUS913', port_ch: '翁斯洛（澳大利亚）' },
    { port_code: 'AUT000', port_ch: '奥地利' },
    { port_code: 'AUT001', port_ch: '林茨（奥地利）' },
    { port_code: 'AUT901', port_ch: '维也纳（奥地利）' },
    { port_code: 'AZE000', port_ch: '阿塞拜疆' },
    { port_code: 'AZE901', port_ch: '巴库（阿塞拜疆）' },
    { port_code: 'BDI000', port_ch: '布隆迪' },
    { port_code: 'BEL000', port_ch: '比利时' },
    { port_code: 'BEL003', port_ch: '安特卫普（比利时）' },
    { port_code: 'BEL006', port_ch: '布鲁日（比利时）' },
    { port_code: 'BEL009', port_ch: '布鲁塞尔（比利时）' },
    { port_code: 'BEL012', port_ch: '根特（比利时）' },
    { port_code: 'BEL015', port_ch: '海米克瑟姆（比利时）' },
    { port_code: 'BEL018', port_ch: '列日（比利时）' },
    { port_code: 'BEL021', port_ch: '尼乌波特（比利时）' },
    { port_code: 'BEL024', port_ch: '奥斯坦德（比利时）' },
    { port_code: 'BEL027', port_ch: '泽布吕赫/泽布腊赫（比利时）' },
    { port_code: 'BEN000', port_ch: '贝宁' },
    { port_code: 'BEN003', port_ch: '科托努（贝宁）' },
    { port_code: 'BEN006', port_ch: '波多诺伏（贝宁）' },
    { port_code: 'BES000', port_ch: '博内尔岛、圣尤斯特歇斯岛和萨巴岛' },
    {
        port_code: 'BES003',
        port_ch: '克拉伦代克（博内尔岛、圣尤斯特歇斯岛和萨巴岛）'
    },
    { port_code: 'BES004', port_ch: '萨巴（博内尔岛、圣尤斯特歇斯岛和萨巴岛）' },
    { port_code: 'BFA000', port_ch: '布基纳法索' },
    { port_code: 'BGD000', port_ch: '孟加拉' },
    { port_code: 'BGD001', port_ch: '达卡（孟加拉）' },
    { port_code: 'BGD003', port_ch: '贾尔纳（孟加拉）' },
    { port_code: 'BGD006', port_ch: '吉大港（孟加拉）' },
    { port_code: 'BGD009', port_ch: '库尔纳（孟加拉）' },
    { port_code: 'BGD012', port_ch: '蒙拉（孟加拉）' },
    { port_code: 'BGR000', port_ch: '保加利亚' },
    { port_code: 'BGR003', port_ch: '巴尔奇克（保加利亚）' },
    { port_code: 'BGR006', port_ch: '布尔加斯（保加利亚）' },
    { port_code: 'BGR009', port_ch: '卡瓦尔纳（保加利亚）' },
    { port_code: 'BGR012', port_ch: '米丘林（保加利亚）' },
    { port_code: 'BGR015', port_ch: '纳塞巴尔（保加利亚）' },
    { port_code: 'BGR017', port_ch: '索佐波尔（保加利亚）' },
    { port_code: 'BGR018', port_ch: '瓦尔纳（保加利亚）' },
    { port_code: 'BHR000', port_ch: '巴林' },
    { port_code: 'BHR003', port_ch: '奥巴杰蒂（巴林）' },
    { port_code: 'BHR004', port_ch: '巴林（巴林）' },
    { port_code: 'BHR005', port_ch: '麦纳麦（巴林）' },
    { port_code: 'BHR006', port_ch: '米纳苏尔曼（巴林）' },
    { port_code: 'BHR009', port_ch: '锡特拉（巴林）' },
    { port_code: 'BHS000', port_ch: '巴哈马' },
    { port_code: 'BHS003', port_ch: '弗里波特（巴哈马）' },
    { port_code: 'BHS006', port_ch: '小圣萨尔瓦多岛（巴哈马）' },
    { port_code: 'BHS009', port_ch: '拿骚（巴哈马）' },
    { port_code: 'BHS012', port_ch: '南里登角（巴哈马）' },
    { port_code: 'BIH000', port_ch: '波斯尼亚和黑塞哥维那' },
    { port_code: 'BLM000', port_ch: '加勒比海圣巴特岛' },
    { port_code: 'BLR000', port_ch: '白俄罗斯' },
    { port_code: 'BLZ000', port_ch: '伯利兹' },
    { port_code: 'BLZ001', port_ch: '贝尔莫潘（伯利兹）' },
    { port_code: 'BLZ003', port_ch: '伯利兹城（伯利兹）' },
    { port_code: 'BMU000', port_ch: '百慕大' },
    { port_code: 'BMU003', port_ch: '哈密尔顿（百慕大）' },
    { port_code: 'BMU006', port_ch: '圣乔治（百慕大）' },
    { port_code: 'BOL000', port_ch: '玻利维亚' },
    { port_code: 'BRA000', port_ch: '巴西' },
    { port_code: 'BRA003', port_ch: '安格拉-杜斯雷斯（巴西）' },
    { port_code: 'BRA006', port_ch: '阿拉卡茹（巴西）' },
    { port_code: 'BRA009', port_ch: '阿拉卡蒂（巴西）' },
    { port_code: 'BRA012', port_ch: '阿拉图（巴西）' },
    { port_code: 'BRA015', port_ch: '阿里亚布兰卡（巴西）' },
    { port_code: 'BRA018', port_ch: '巴拉奥特菲（巴西）' },
    { port_code: 'BRA021', port_ch: '贝伦（巴西）' },
    { port_code: 'BRA024', port_ch: '卡贝德卢（巴西）' },
    { port_code: 'BRA027', port_ch: '弗洛里亚诺波利斯（巴西）' },
    { port_code: 'BRA030', port_ch: '福塔莱萨（巴西）' },
    { port_code: 'BRA033', port_ch: '伊列乌斯（巴西）' },
    { port_code: 'BRA036', port_ch: '因比图巴（巴西）' },
    { port_code: 'BRA039', port_ch: '伊塔雅伊（巴西）' },
    { port_code: 'BRA042', port_ch: '伊塔基（巴西）' },
    { port_code: 'BRA045', port_ch: '若昂佩索阿（巴西）' },
    { port_code: 'BRA048', port_ch: '马卡帕（巴西）' },
    { port_code: 'BRA051', port_ch: '马塞约（巴西）' },
    { port_code: 'BRA054', port_ch: '马瑙斯（巴西）' },
    { port_code: 'BRA057', port_ch: '纳塔尔（巴西）' },
    { port_code: 'BRA060', port_ch: '尼泰罗伊（巴西）' },
    { port_code: 'BRA063', port_ch: '巴拉那瓜（巴西）' },
    { port_code: 'BRA066', port_ch: '巴纳伊巴（巴西）' },
    { port_code: 'BRA069', port_ch: '佩洛塔斯（巴西）' },
    { port_code: 'BRA072', port_ch: '乌布角（巴西）' },
    { port_code: 'BRA075', port_ch: '阿雷格里港（巴西）' },
    { port_code: 'BRA078', port_ch: '波图塞尔（巴西）' },
    { port_code: 'BRA081', port_ch: '累西腓（巴西）' },
    { port_code: 'BRA084', port_ch: '里约热内卢（巴西）' },
    { port_code: 'BRA087', port_ch: '里奥格兰德（巴西）' },
    { port_code: 'BRA090', port_ch: '萨尔瓦多（巴西）' },
    { port_code: 'BRA093', port_ch: '圣安娜（巴西）' },
    { port_code: 'BRA096', port_ch: '圣塔伦（巴西）' },
    { port_code: 'BRA099', port_ch: '桑托斯（巴西）' },
    { port_code: 'BRA102', port_ch: '南圣弗兰西斯科（巴西）' },
    { port_code: 'BRA105', port_ch: '圣路易斯（巴西）' },
    { port_code: 'BRA108', port_ch: '圣保罗（巴西）' },
    { port_code: 'BRA111', port_ch: '圣塞巴斯蒂昂（巴西）' },
    { port_code: 'BRA114', port_ch: '塞佩提巴（巴西）' },
    { port_code: 'BRA117', port_ch: '特拉曼达伊（巴西）' },
    { port_code: 'BRA120', port_ch: '特龙贝塔斯（巴西）' },
    { port_code: 'BRA123', port_ch: '图巴朗（巴西）' },
    { port_code: 'BRA126', port_ch: '维多利亚（巴西）' },
    { port_code: 'BRA127', port_ch: '安托尼纳（巴西）' },
    { port_code: 'BRA128', port_ch: '福塔雷扎（巴西）' },
    { port_code: 'BRA129', port_ch: '海纳（巴西）' },
    { port_code: 'BRA130', port_ch: '里亚桥（巴西）' },
    { port_code: 'BRA132', port_ch: '萨尔塔卡瓦略（巴西）' },
    { port_code: 'BRB000', port_ch: '巴巴多斯' },
    { port_code: 'BRB003', port_ch: '布里奇敦（巴巴多斯）' },
    { port_code: 'BRN000', port_ch: '文莱' },
    { port_code: 'BRN001', port_ch: '文莱（文莱）' },
    { port_code: 'BRN003', port_ch: '斯里巴加湾港（文莱）' },
    { port_code: 'BRN006', port_ch: '白拉奕（文莱）' },
    { port_code: 'BRN008', port_ch: '麻拉（文莱）' },
    { port_code: 'BRN009', port_ch: '穆阿拉港（文莱）' },
    { port_code: 'BRN012', port_ch: '诗里亚（文莱）' },
    { port_code: 'BRN015', port_ch: '丹戎沙利隆（文莱）' },
    { port_code: 'BTN000', port_ch: '不丹' },
    { port_code: 'BVT000', port_ch: '布维岛' },
    { port_code: 'BWA000', port_ch: '博茨瓦纳' },
    { port_code: 'CAF000', port_ch: '中非' },
    { port_code: 'CAN000', port_ch: '加拿大' },
    { port_code: 'CAN003', port_ch: '阿克拉维克（加拿大）' },
    { port_code: 'CAN006', port_ch: '阿默斯特（加拿大）' },
    { port_code: 'CAN009', port_ch: '阿默斯特堡 ，阿默斯特港（加拿大）' },
    { port_code: 'CAN012', port_ch: '安纳波利斯（加拿大）' },
    { port_code: 'CAN015', port_ch: '阿真舍（加拿大）' },
    { port_code: 'CAN018', port_ch: '阿里沙特（加拿大）' },
    { port_code: 'CAN021', port_ch: '巴德克（加拿大）' },
    { port_code: 'CAN024', port_ch: '巴戈特维尔（加拿大）' },
    { port_code: 'CAN027', port_ch: '贝科莫（加拿大）' },
    { port_code: 'CAN030', port_ch: '巴斯克湾（加拿大）' },
    { port_code: 'CAN033', port_ch: '巴瑟斯特（加拿大）' },
    { port_code: 'CAN036', port_ch: '贝罗伯茨（加拿大）' },
    { port_code: 'CAN039', port_ch: '比弗港（加拿大）' },
    { port_code: 'CAN045', port_ch: '贝拉顿（加拿大）' },
    { port_code: 'CAN048', port_ch: '博特伍德（加拿大）' },
    { port_code: 'CAN051', port_ch: '布里奇沃特（加拿大）' },
    { port_code: 'CAN054', port_ch: '布罗克维尔（加拿大）' },
    { port_code: 'CAN057', port_ch: '巴克图什（加拿大）' },
    { port_code: 'CAN060', port_ch: '伯吉奥（加拿大）' },
    { port_code: 'CAN063', port_ch: '布林（加拿大）' },
    { port_code: 'CAN066', port_ch: '坎贝尔顿（加拿大）' },
    { port_code: 'CAN069', port_ch: '坎索港（加拿大）' },
    { port_code: 'CAN072', port_ch: '卡拉凯特（加拿大）' },
    { port_code: 'CAN075', port_ch: '卡尔顿（加拿大）' },
    { port_code: 'CAN078', port_ch: '夏洛特敦（加拿大）' },
    { port_code: 'CAN084', port_ch: '查塔姆（加拿大）' },
    { port_code: 'CAN087', port_ch: '彻梅纳斯（加拿大）' },
    { port_code: 'CAN090', port_ch: '谢蒂坎普（加拿大）' },
    { port_code: 'CAN093', port_ch: '希库提米（加拿大）' },
    { port_code: 'CAN096', port_ch: '丘吉尔（加拿大）' },
    { port_code: 'CAN099', port_ch: '克拉伦维尔（加拿大）' },
    { port_code: 'CAN102', port_ch: '科堡（加拿大）' },
    { port_code: 'CAN105', port_ch: '科灵伍德（加拿大）' },
    { port_code: 'CAN108', port_ch: '卡姆拜钱斯（加拿大）' },
    { port_code: 'CAN111', port_ch: '科纳－布鲁特（加拿大）' },
    { port_code: 'CAN114', port_ch: '科莫克斯（加拿大）' },
    { port_code: 'CAN117', port_ch: '孔特勒科尔（加拿大）' },
    { port_code: 'CAN120', port_ch: '康沃尔（加拿大）' },
    { port_code: 'CAN123', port_ch: '康特里港（加拿大）' },
    { port_code: 'CAN126', port_ch: '科威恰湾（加拿大）' },
    { port_code: 'CAN129', port_ch: '克罗夫顿（加拿大）' },
    { port_code: 'CAN132', port_ch: '达尔豪西（加拿大）' },
    { port_code: 'CAN135', port_ch: '迪格比（加拿大）' },
    { port_code: 'CAN138', port_ch: '丁沃尔（加拿大）' },
    { port_code: 'CAN141', port_ch: '多米诺（加拿大）' },
    { port_code: 'CAN144', port_ch: '埃斯奎莫尔特（加拿大）' },
    { port_code: 'CAN147', port_ch: '福雷斯特维尔（加拿大）' },
    { port_code: 'CAN150', port_ch: '弗罗比舍湾（加拿大）' },
    { port_code: 'CAN153', port_ch: '加斯佩（加拿大）' },
    { port_code: 'CAN156', port_ch: '乔治敦（加拿大）' },
    { port_code: 'CAN159', port_ch: '戈德里奇（加拿大）' },
    { port_code: 'CAN162', port_ch: '戈尔德里弗（加拿大）' },
    { port_code: 'CAN165', port_ch: '古斯湾（加拿大）' },
    { port_code: 'CAN168', port_ch: '格兰德班克（加拿大）' },
    { port_code: 'CAN171', port_ch: '哈利法克斯（加拿大）' },
    { port_code: 'CAN174', port_ch: '哈密尔顿（加拿大）' },
    { port_code: 'CAN177', port_ch: '汉茨波特（加拿大）' },
    { port_code: 'CAN180', port_ch: '格雷斯港（加拿大）' },
    { port_code: 'CAN183', port_ch: '哈麦克（加拿大）' },
    { port_code: 'CAN186', port_ch: '哈佛圣皮埃尔（加拿大）' },
    { port_code: 'CAN189', port_ch: '哈茨康滕特（加拿大）' },
    { port_code: 'CAN192', port_ch: '霍利鲁德（加拿大）' },
    { port_code: 'CAN195', port_ch: '约纳（加拿大）' },
    { port_code: 'CAN198', port_ch: '艾萨克斯港（加拿大）' },
    { port_code: 'CAN201', port_ch: '金斯顿（加拿大）' },
    { port_code: 'CAN204', port_ch: '基提马特（加拿大）' },
    { port_code: 'CAN207', port_ch: '拉阿沃（加拿大）' },
    { port_code: 'CAN210', port_ch: '利明顿（加拿大）' },
    { port_code: 'CAN213', port_ch: '利斯科姆（加拿大）' },
    { port_code: 'CAN216', port_ch: '小窄峡（加拿大）' },
    { port_code: 'CAN219', port_ch: '利物浦（加拿大）' },
    { port_code: 'CAN222', port_ch: '洛克波特（加拿大）' },
    { port_code: 'CAN225', port_ch: '洛蒙德（加拿大）' },
    { port_code: 'CAN228', port_ch: '路易斯堡（加拿大）' },
    { port_code: 'CAN231', port_ch: '卢嫩堡（加拿大）' },
    { port_code: 'CAN234', port_ch: '马塔讷（加拿大）' },
    { port_code: 'CAN237', port_ch: '梅泰根（加拿大）' },
    { port_code: 'CAN240', port_ch: '米奇皮科滕（加拿大）' },
    { port_code: 'CAN243', port_ch: '米德兰（加拿大）' },
    { port_code: 'CAN246', port_ch: '蒙路易（加拿大）' },
    { port_code: 'CAN249', port_ch: '蒙塔古（加拿大）' },
    { port_code: 'CAN252', port_ch: '蒙特利尔（加拿大）' },
    { port_code: 'CAN255', port_ch: '纳奈莫（加拿大）' },
    { port_code: 'CAN258', port_ch: '纳尼斯维克（加拿大）' },
    { port_code: 'CAN261', port_ch: '新格拉斯哥（加拿大）' },
    { port_code: 'CAN264', port_ch: '新里士满（加拿大）' },
    { port_code: 'CAN267', port_ch: '新威斯敏斯特（加拿大）' },
    { port_code: 'CAN270', port_ch: '纽卡斯尔（加拿大）' },
    { port_code: 'CAN273', port_ch: '北锡德尼（加拿大）' },
    { port_code: 'CAN276', port_ch: '奥克维尔（加拿大）' },
    { port_code: 'CAN279', port_ch: '福尔斯海（加拿大）' },
    { port_code: 'CAN282', port_ch: '奥沙瓦（加拿大）' },
    { port_code: 'CAN285', port_ch: '欧文桑德（加拿大）' },
    { port_code: 'CAN288', port_ch: '帕斯博勒（加拿大）' },
    { port_code: 'CAN291', port_ch: '帕里桑德（加拿大）' },
    { port_code: 'CAN294', port_ch: '帕斯佩比亚克（加拿大）' },
    { port_code: 'CAN297', port_ch: '皮克图（加拿大）' },
    { port_code: 'CAN300', port_ch: '图佩尔角（加拿大）' },
    { port_code: 'CAN303', port_ch: '黑角（加拿大）' },
    { port_code: 'CAN306', port_ch: '艾伯尼港（加拿大）' },
    { port_code: 'CAN309', port_ch: '艾尔弗雷德港（加拿大）' },
    { port_code: 'CAN312', port_ch: '艾利斯港（加拿大）' },
    { port_code: 'CAN315', port_ch: '奥克斯巴凯斯港（加拿大）' },
    { port_code: 'CAN318', port_ch: '卡捷港（加拿大）' },
    { port_code: 'CAN321', port_ch: '科尔本港（加拿大）' },
    { port_code: 'CAN324', port_ch: '克雷迪特港（加拿大）' },
    { port_code: 'CAN327', port_ch: '达尔胡西港（加拿大）' },
    { port_code: 'CAN330', port_ch: '霍克斯伯里港（加拿大）' },
    { port_code: 'CAN333', port_ch: '霍普辛普森港（加拿大）' },
    { port_code: 'CAN336', port_ch: '霍普港（加拿大）' },
    { port_code: 'CAN339', port_ch: '梅德韦港（加拿大）' },
    { port_code: 'CAN342', port_ch: '穆尔格拉维港（加拿大）' },
    { port_code: 'CAN345', port_ch: '威莱尔港（加拿大）' },
    { port_code: 'CAN348', port_ch: '鲍威尔（加拿大）' },
    { port_code: 'CAN351', port_ch: '普雷斯科特（加拿大）' },
    { port_code: 'CAN354', port_ch: '鲁珀特港（加拿大）' },
    { port_code: 'CAN357', port_ch: '帕格沃希（加拿大）' },
    { port_code: 'CAN360', port_ch: '魁北克（加拿大）' },
    { port_code: 'CAN363', port_ch: '里奇巴克托（加拿大）' },
    { port_code: 'CAN366', port_ch: '里穆斯基（加拿大）' },
    { port_code: 'CAN369', port_ch: '里维耶尔-迪卢（加拿大）' },
    { port_code: 'CAN372', port_ch: '罗伯茨湾（加拿大）' },
    { port_code: 'CAN378', port_ch: '萨尔尼亚（加拿大）' },
    { port_code: 'CAN381', port_ch: '苏圣马丽（加拿大）' },
    { port_code: 'CAN384', port_ch: '七岛（塞提尔）（加拿大）' },
    { port_code: 'CAN387', port_ch: '谢迪艾克（加拿大）' },
    { port_code: 'CAN390', port_ch: '希特港（加拿大）' },
    { port_code: 'CAN393', port_ch: '谢尔本（加拿大）' },
    { port_code: 'CAN396', port_ch: '希布洛克（加拿大）' },
    { port_code: 'CAN399', port_ch: '希普港（加拿大）' },
    { port_code: 'CAN402', port_ch: '希皮根（加拿大）' },
    { port_code: 'CAN405', port_ch: '索雷尔（加拿大）' },
    { port_code: 'CAN408', port_ch: '苏里斯（加拿大）' },
    { port_code: 'CAN411', port_ch: '斯普林代尔（加拿大）' },
    { port_code: 'CAN414', port_ch: '斯阔米什（加拿大）' },
    { port_code: 'CAN417', port_ch: '圣安德鲁斯（加拿大）' },
    { port_code: 'CAN420', port_ch: '圣凯瑟琳斯（加拿大）' },
    { port_code: 'CAN422', port_ch: '圣约翰（加拿大）' },
    { port_code: 'CAN423', port_ch: '圣约翰斯（加拿大）' },
    { port_code: 'CAN426', port_ch: '圣劳伦斯（加拿大）' },
    { port_code: 'CAN429', port_ch: '斯蒂芬维尔（加拿大）' },
    { port_code: 'CAN432', port_ch: '斯图尔特（加拿大）' },
    { port_code: 'CAN435', port_ch: '萨默塞德（加拿大）' },
    { port_code: 'CAN438', port_ch: '悉尼（加拿大）' },
    { port_code: 'CAN441', port_ch: '塔杜萨克（加拿大）' },
    { port_code: 'CAN444', port_ch: '塔西斯（加拿大）' },
    { port_code: 'CAN447', port_ch: '索罗尔德（加拿大）' },
    { port_code: 'CAN450', port_ch: '三河城（加拿大）' },
    { port_code: 'CAN453', port_ch: '桑德贝（加拿大）' },
    { port_code: 'CAN456', port_ch: '多伦多（加拿大）' },
    { port_code: 'CAN459', port_ch: '特威林盖特（加拿大）' },
    { port_code: 'CAN462', port_ch: '瓦利菲尔德（加拿大）' },
    { port_code: 'CAN465', port_ch: '温哥华（加拿大）' },
    { port_code: 'CAN468', port_ch: '维多利亚（加拿大）' },
    { port_code: 'CAN471', port_ch: '瓦巴纳（加拿大）' },
    { port_code: 'CAN474', port_ch: '沃尔顿（加拿大）' },
    { port_code: 'CAN477', port_ch: '瓦特逊岛（加拿大）' },
    { port_code: 'CAN478', port_ch: 'CAP DE LA MADELEINE（加拿大）' },
    { port_code: 'CAN479', port_ch: 'CLARKE CITY（加拿大）' },
    { port_code: 'CAN480', port_ch: '威兰（加拿大）' },
    { port_code: 'CAN483', port_ch: '韦默思（加拿大）' },
    { port_code: 'CAN485', port_ch: '卡提尔港（加拿大）' },
    { port_code: 'CAN486', port_ch: '温泽尔（加拿大）' },
    { port_code: 'CAN489', port_ch: '伍德菲伯（加拿大）' },
    { port_code: 'CAN490', port_ch: '纳尔逊（加拿大）' },
    { port_code: 'CAN491', port_ch: '南纳尔逊（加拿大）' },
    { port_code: 'CAN492', port_ch: '雅茅思（加拿大）' },
    { port_code: 'CAN494', port_ch: '图克托亚克图克（加拿大）' },
    { port_code: 'CAN495', port_ch: '渥太华（加拿大）' },
    { port_code: 'CAN497', port_ch: '斜堡（加拿大）' },
    { port_code: 'CAN504', port_ch: '波珀斯港（加拿大）' },
    { port_code: 'CAN507', port_ch: '布朗斯维尔（加拿大）' },
    { port_code: 'CAN510', port_ch: '莱塞斯库明（加拿大）' },
    { port_code: 'CAN514', port_ch: '米耳丘陵（加拿大）' },
    { port_code: 'CAN517', port_ch: '恰塔姆（加拿大）' },
    { port_code: 'CCK000', port_ch: '科科斯（基林）群岛' },
    { port_code: 'CEU000', port_ch: '休达' },
    { port_code: 'CEU003', port_ch: '休达（休达）' },
    { port_code: 'CHE000', port_ch: '瑞士' },
    { port_code: 'CHE901', port_ch: '苏黎世（瑞士）' },
    { port_code: 'CHE902', port_ch: '洛桑（瑞士）' },
    { port_code: 'CHE903', port_ch: '巴塞尔（瑞士）' },
    { port_code: 'CHL000', port_ch: '智利' },
    { port_code: 'CHL003', port_ch: '安库德（智利）' },
    { port_code: 'CHL006', port_ch: '安托法加斯塔（智利）' },
    { port_code: 'CHL009', port_ch: '阿里卡（智利）' },
    { port_code: 'CHL012', port_ch: '卡博内格罗（智利）' },
    { port_code: 'CHL015', port_ch: '卡尔德拉（智利）' },
    { port_code: 'CHL018', port_ch: '卡尔德里拉（智利）' },
    { port_code: 'CHL024', port_ch: '克拉伦西亚（智利）' },
    { port_code: 'CHL027', port_ch: '帕蒂略斯（智利）' },
    { port_code: 'CHL030', port_ch: '卡斯特罗（智利）' },
    { port_code: 'CHL033', port_ch: '查卡布科（智利）' },
    { port_code: 'CHL036', port_ch: '查尼亚拉尔（智利）' },
    { port_code: 'CHL039', port_ch: '科金博（智利）' },
    { port_code: 'CHL042', port_ch: '科罗内尔（智利）' },
    { port_code: 'CHL045', port_ch: '科拉尔（智利）' },
    { port_code: 'CHL048', port_ch: '克鲁斯格兰德（智利）' },
    { port_code: 'CHL051', port_ch: '复活节岛（智利）' },
    { port_code: 'CHL054', port_ch: '格雷戈里乌（智利）' },
    { port_code: 'CHL057', port_ch: '瓜亚坎（智利）' },
    { port_code: 'CHL060', port_ch: '瓦斯科（智利）' },
    { port_code: 'CHL063', port_ch: '伊基克（智利）' },
    { port_code: 'CHL066', port_ch: '拉塞雷纳（智利）' },
    { port_code: 'CHL069', port_ch: '利尔奎（智利）' },
    { port_code: 'CHL072', port_ch: '洛塔（智利）' },
    { port_code: 'CHL075', port_ch: '梅希约内斯（智利）' },
    { port_code: 'CHL078', port_ch: '彭科（智利）' },
    { port_code: 'CHL081', port_ch: '博里奥斯港（智利）' },
    { port_code: 'CHL084', port_ch: '蒙特港（智利）' },
    { port_code: 'CHL087', port_ch: '纳塔莱斯港（智利）' },
    { port_code: 'CHL090', port_ch: '克永港（智利）' },
    { port_code: 'CHL093', port_ch: '奎姆什（智利）' },
    { port_code: 'CHL096', port_ch: '蓬塔阿雷纳斯（智利）' },
    { port_code: 'CHL099', port_ch: '金特罗（智利）' },
    { port_code: 'CHL102', port_ch: '圣安东尼奥（智利）' },
    { port_code: 'CHL105', port_ch: '圣维森特（智利）' },
    { port_code: 'CHL108', port_ch: '塔尔卡瓦诺（智利）' },
    { port_code: 'CHL111', port_ch: '塔尔塔尔（智利）' },
    { port_code: 'CHL114', port_ch: '托科皮亚（智利）' },
    { port_code: 'CHL117', port_ch: '托梅（智利）' },
    { port_code: 'CHL120', port_ch: '瓦尔迪维亚（智利）' },
    { port_code: 'CHL123', port_ch: '瓦尔帕莱索（智利）' },
    { port_code: 'CHL901', port_ch: '圣地亚哥（智利）' },
    { port_code: 'CHL902', port_ch: 'BARQUJTO（智利）' },
    { port_code: 'CHN000', port_ch: '中国境内' },
    { port_code: 'CHN030', port_ch: '南通（中国）' },
    { port_code: 'CHN033', port_ch: '泰州（中国）' },
    { port_code: 'CHN036', port_ch: '扬州（中国）' },
    { port_code: 'CHN039', port_ch: '南京（中国）' },
    { port_code: 'CHN041', port_ch: '镇江（中国）' },
    { port_code: 'CHN042', port_ch: '常州（中国）' },
    { port_code: 'CHN043', port_ch: '高港（中国）' },
    { port_code: 'CHN045', port_ch: '江阴（中国）' },
    { port_code: 'CHN046', port_ch: '苏州（中国）' },
    { port_code: 'CHN047', port_ch: '张家港（中国）' },
    { port_code: 'CHN050', port_ch: '常熟（中国）' },
    { port_code: 'CHN053', port_ch: '太仓（中国）' },
    { port_code: 'CHN056', port_ch: '南京禄口国际机场（中国）' },
    { port_code: 'CHN059', port_ch: '盐城机场（中国）' },
    { port_code: 'CHN101', port_ch: '丹东（中国）' },
    { port_code: 'CHN113', port_ch: '大连（中国）' },
    { port_code: 'CHN114', port_ch: '大连新港（中国）' },
    { port_code: 'CHN119', port_ch: '营口（中国）' },
    { port_code: 'CHN122', port_ch: '锦州（中国）' },
    { port_code: 'CHN124', port_ch: '葫芦岛（中国）' },
    { port_code: 'CHN126', port_ch: '沈阳桃仙国际机场口岸（中国）' },
    { port_code: 'CHN128', port_ch: '大连周水子国际机场（中国）' },
    { port_code: 'CHN130', port_ch: '长春大房身机场（中国）' },
    { port_code: 'CHN132', port_ch: '延吉朝阳川机场（中国）' },
    { port_code: 'CHN134', port_ch: '哈尔滨太平国际机场（中国）' },
    { port_code: 'CHN136', port_ch: '佳木斯东郊机场（中国）' },
    { port_code: 'CHN138', port_ch: '牡丹江海浪机场（中国）' },
    { port_code: 'CHN140', port_ch: '齐齐哈尔三家子机场（中国）' },
    { port_code: 'CHN151', port_ch: '秦皇岛（中国）' },
    { port_code: 'CHN153', port_ch: '唐山（中国）' },
    { port_code: 'CHN154', port_ch: '京唐港（中国）' },
    { port_code: 'CHN156', port_ch: '曹妃甸（中国）' },
    { port_code: 'CHN159', port_ch: '石家庄正定机场（中国）' },
    { port_code: 'CHN181', port_ch: '天津（中国）' },
    { port_code: 'CHN184', port_ch: '天津滨海国际机场（中国）' },
    { port_code: 'CHN185', port_ch: '天津新港（中国）' },
    { port_code: 'CHN188', port_ch: '首都国际机场（中国）' },
    { port_code: 'CHN190', port_ch: '太原太武宿机场（中国）' },
    { port_code: 'CHN192', port_ch: '呼和浩特白塔机场（中国）' },
    { port_code: 'CHN194', port_ch: '海拉尔东山机场（中国）' },
    { port_code: 'CHN213', port_ch: '黄骅（中国）' },
    { port_code: 'CHN216', port_ch: '东营（中国）' },
    { port_code: 'CHN219', port_ch: '莱州（中国）' },
    { port_code: 'CHN222', port_ch: '龙口（中国）' },
    { port_code: 'CHN225', port_ch: '蓬莱（中国）' },
    { port_code: 'CHN231', port_ch: '烟台（中国）' },
    { port_code: 'CHN240', port_ch: '威海（中国）' },
    { port_code: 'CHN249', port_ch: '石岛（中国）' },
    { port_code: 'CHN260', port_ch: '黄岛（中国）' },
    { port_code: 'CHN261', port_ch: '青岛（中国）' },
    { port_code: 'CHN273', port_ch: '日照（中国）' },
    { port_code: 'CHN276', port_ch: '岚山（中国）' },
    { port_code: 'CHN278', port_ch: '济南遥墙机场（中国）' },
    { port_code: 'CHN280', port_ch: '青岛流亭机场（中国）' },
    { port_code: 'CHN282', port_ch: '威海机场（中国）' },
    { port_code: 'CHN284', port_ch: '烟台莱山机场（中国）' },
    { port_code: 'CHN286', port_ch: '郑州新郑国际机场（中国）' },
    { port_code: 'CHN288', port_ch: '洛阳北郊机场（中国）' },
    { port_code: 'CHN290', port_ch: '武汉天河机场（中国）' },
    { port_code: 'CHN292', port_ch: '宜昌三峡机场（中国）' },
    { port_code: 'CHN294', port_ch: '长沙黄花国际机场（中国）' },
    { port_code: 'CHN296', port_ch: '张家界荷花机场（中国）' },
    { port_code: 'CHN301', port_ch: '连云港（中国）' },
    { port_code: 'CHN331', port_ch: '上海（中国）' },
    { port_code: 'CHN333', port_ch: '宝山马头（中国）' },
    { port_code: 'CHN336', port_ch: '外高桥（中国）' },
    { port_code: 'CHN339', port_ch: '吴淞（中国）' },
    { port_code: 'CHN340', port_ch: '上海浦东国际机场（中国）' },
    { port_code: 'CHN341', port_ch: '上海虹桥国际机场（中国）' },
    { port_code: 'CHN342', port_ch: '洋山（中国）' },
    { port_code: 'CHN345', port_ch: '嘉兴（中国）' },
    { port_code: 'CHN351', port_ch: '乍浦（中国）' },
    { port_code: 'CHN358', port_ch: '镇海港（中国）' },
    { port_code: 'CHN359', port_ch: '梅山港（中国）' },
    { port_code: 'CHN360', port_ch: '宁波（中国）' },
    { port_code: 'CHN361', port_ch: '北仑港（中国）' },
    { port_code: 'CHN362', port_ch: '大榭港（中国）' },
    { port_code: 'CHN363', port_ch: '穿山港（中国）' },
    { port_code: 'CHN364', port_ch: '宁海港（中国）' },
    { port_code: 'CHN365', port_ch: '象山港（中国）' },
    { port_code: 'CHN366', port_ch: '舟山（中国）' },
    { port_code: 'CHN367', port_ch: '普陀港（中国）' },
    { port_code: 'CHN450', port_ch: '台州（中国）' },
    { port_code: 'CHN453', port_ch: '海门（中国）' },
    { port_code: 'CHN456', port_ch: '温岭港（中国）' },
    { port_code: 'CHN483', port_ch: '温州（中国）' },
    { port_code: 'CHN566', port_ch: '杭州萧山国际机场（中国）' },
    { port_code: 'CHN568', port_ch: '合肥骆岗机场（中国）' },
    { port_code: 'CHN570', port_ch: '黄山屯溪机场（中国）' },
    { port_code: 'CHN572', port_ch: '宁德（中国）' },
    { port_code: 'CHN575', port_ch: '城澳（中国）' },
    { port_code: 'CHN578', port_ch: '福州（中国）' },
    { port_code: 'CHN579', port_ch: '马尾（中国）' },
    { port_code: 'CHN582', port_ch: '松下（中国）' },
    { port_code: 'CHN585', port_ch: '莆田（中国）' },
    { port_code: 'CHN611', port_ch: '秀屿（中国）' },
    { port_code: 'CHN638', port_ch: '泉州（中国）' },
    { port_code: 'CHN674', port_ch: '厦门（中国）' },
    { port_code: 'CHN677', port_ch: '漳州（中国）' },
    { port_code: 'CHN679', port_ch: '福州长乐国际机场（中国）' },
    { port_code: 'CHN681', port_ch: '武夷山机场（中国）' },
    { port_code: 'CHN683', port_ch: '厦门高崎国际机场（中国）' },
    { port_code: 'CHN685', port_ch: '南昌昌北机场（中国）' },
    { port_code: 'CHN686', port_ch: '东山（中国）' },
    { port_code: 'CHN704', port_ch: '潮州（中国）' },
    { port_code: 'CHN710', port_ch: '汕头（中国）' },
    { port_code: 'CHN713', port_ch: '广澳（中国）' },
    { port_code: 'CHN716', port_ch: '潮阳（中国）' },
    { port_code: 'CHN725', port_ch: '汕尾（中国）' },
    { port_code: 'CHN728', port_ch: '惠州（中国）' },
    { port_code: 'CHN731', port_ch: '深圳（中国）' },
    { port_code: 'CHN734', port_ch: '东角头（中国）' },
    { port_code: 'CHN737', port_ch: '盐田（中国）' },
    { port_code: 'CHN740', port_ch: '蛇口（中国）' },
    { port_code: 'CHN743', port_ch: '赤湾（中国）' },
    { port_code: 'CHN746', port_ch: '妈湾（中国）' },
    { port_code: 'CHN748', port_ch: '东莞（中国）' },
    { port_code: 'CHN750', port_ch: '黄埔（中国）' },
    { port_code: 'CHN751', port_ch: '虎门（中国）' },
    { port_code: 'CHN752', port_ch: '广州（中国）' },
    { port_code: 'CHN753', port_ch: '阳江（中国）' },
    { port_code: 'CHN754', port_ch: '南沙（中国）' },
    { port_code: 'CHN755', port_ch: '茂名（中国）' },
    { port_code: 'CHN756', port_ch: '珠海（中国）' },
    { port_code: 'CHN758', port_ch: '中山（中国）' },
    { port_code: 'CHN761', port_ch: '九州（中国）' },
    { port_code: 'CHN764', port_ch: '江门（中国）' },
    { port_code: 'CHN767', port_ch: '北津（中国）' },
    { port_code: 'CHN768', port_ch: '广海（中国）' },
    { port_code: 'CHN770', port_ch: '斗门(中国）' },
    { port_code: 'CHN785', port_ch: '湛江（中国）' },
    { port_code: 'CHN793', port_ch: '广州白云国际机场（中国）' },
    { port_code: 'CHN795', port_ch: '梅州机场（中国）' },
    { port_code: 'CHN797', port_ch: '汕头机场（中国）' },
    { port_code: 'CHN799', port_ch: '深圳宝安国际机场（中国）' },
    { port_code: 'CHN801', port_ch: '湛江机场（中国）' },
    { port_code: 'CHN851', port_ch: '北海（中国）' },
    { port_code: 'CHN866', port_ch: '石头埠（中国）' },
    { port_code: 'CHN867', port_ch: '钦州（中国）' },
    { port_code: 'CHN875', port_ch: '企沙（中国）' },
    { port_code: 'CHN878', port_ch: '防城港（中国）' },
    { port_code: 'CHN881', port_ch: '江山（中国）' },
    { port_code: 'CHN883', port_ch: '南宁吴圩机场（中国）' },
    { port_code: 'CHN885', port_ch: '北海福成机场（中国）' },
    { port_code: 'CHN887', port_ch: '桂林两江国际机场（中国）' },
    { port_code: 'CHN901', port_ch: '海口（中国）' },
    { port_code: 'CHN904', port_ch: '海口新港（中国）' },
    { port_code: 'CHN913', port_ch: '清澜（中国）' },
    { port_code: 'CHN919', port_ch: '三亚（中国）' },
    { port_code: 'CHN920', port_ch: '榆林（中国）' },
    { port_code: 'CHN922', port_ch: '八所（中国）' },
    { port_code: 'CHN925', port_ch: '洋浦（中国）' },
    { port_code: 'CHN928', port_ch: '海口美兰机场（中国）' },
    { port_code: 'CHN931', port_ch: '三亚凤凰机场（中国）' },
    { port_code: 'CHN934', port_ch: '重庆江北国际机场（中国）' },
    { port_code: 'CHN937', port_ch: '成都双流国际机场（中国）' },
    { port_code: 'CHN940', port_ch: '贵阳龙洞堡机场（中国）' },
    { port_code: 'CHN943', port_ch: '昆明巫家坝国际机场（中国）' },
    { port_code: 'CHN946', port_ch: '西双版纳嘎洒机场（中国）' },
    { port_code: 'CHN949', port_ch: '拉萨贡嘎机场（中国）' },
    { port_code: 'CHN952', port_ch: '西安咸阳国际机场（中国）' },
    { port_code: 'CHN955', port_ch: '兰州中川机场（中国）' },
    { port_code: 'CHN958', port_ch: '西宁曹家堡机场（中国）' },
    { port_code: 'CHN961', port_ch: '银川河东机场（中国）' },
    { port_code: 'CHN964', port_ch: '乌鲁木齐地窝堡国际机场（中国）' },
    { port_code: 'CHN967', port_ch: '喀什机场（中国）' },
    { port_code: 'CIV000', port_ch: '科特迪瓦' },
    { port_code: 'CIV003', port_ch: '阿比让（科特迪瓦）' },
    { port_code: 'CIV006', port_ch: '阿西尼（科特迪瓦）' },
    { port_code: 'CIV009', port_ch: '弗雷斯科（科特迪瓦）' },
    { port_code: 'CIV012', port_ch: '大巴萨姆（科特迪瓦）' },
    { port_code: 'CIV014', port_ch: '达布（科特迪瓦）' },
    { port_code: 'CIV015', port_ch: '圣佩德罗（科特迪瓦）' },
    { port_code: 'CIV018', port_ch: '萨桑德拉（科特迪瓦）' },
    { port_code: 'CIV021', port_ch: '塔布（科特迪瓦）' },
    { port_code: 'CIV022', port_ch: '布埃港（科特迪瓦）' },
    { port_code: 'CMR000', port_ch: '喀麦隆' },
    { port_code: 'CMR003', port_ch: '杜阿拉（喀麦隆）' },
    { port_code: 'CMR006', port_ch: '克里比（喀麦隆）' },
    { port_code: 'CMR009', port_ch: '提科（喀麦隆）' },
    { port_code: 'CMR012', port_ch: '维多利亚（喀麦隆）' },
    { port_code: 'CMR015', port_ch: '雅温得（喀麦隆）' },
    { port_code: 'COD000', port_ch: '刚果（金）' },
    { port_code: 'COD003', port_ch: '巴纳纳（刚果（金））' },
    { port_code: 'COD006', port_ch: '博马（刚果（金））' },
    { port_code: 'COD009', port_ch: '马塔迪（刚果（金））' },
    { port_code: 'COD901', port_ch: '金沙萨（刚果（金））' },
    { port_code: 'COG000', port_ch: '刚果（布）' },
    { port_code: 'COG003', port_ch: '哲诺油码头（刚果（布））' },
    { port_code: 'COG006', port_ch: '黑角（刚果（布））' },
    { port_code: 'COK000', port_ch: '库克群岛' },
    { port_code: 'COK003', port_ch: '阿鲁通加（库克群岛）' },
    { port_code: 'COK005', port_ch: '阿瓦鲁阿（库克群岛）' },
    { port_code: 'COK006', port_ch: '拉罗通加岛（库克群岛）' },
    { port_code: 'COL000', port_ch: '哥伦比亚' },
    { port_code: 'COL003', port_ch: '巴兰基利亚（哥伦比亚）' },
    { port_code: 'COL006', port_ch: '布韦那文图拉（哥伦比亚）' },
    { port_code: 'COL009', port_ch: '卡塔赫纳（哥伦比亚）' },
    { port_code: 'COL012', port_ch: '科韦尼亚斯（哥伦比亚）' },
    { port_code: 'COL015', port_ch: '波佐科罗拉多斯（哥伦比亚）' },
    { port_code: 'COL018', port_ch: '哥伦比亚港（哥伦比亚）' },
    { port_code: 'COL023', port_ch: '卡雷尼奥港（哥伦比亚）' },
    { port_code: 'COL024', port_ch: '圣玛尔塔（哥伦比亚）' },
    { port_code: 'COL027', port_ch: '图马科（哥伦比亚）' },
    { port_code: 'COL030', port_ch: '图尔博（哥伦比亚）' },
    { port_code: 'COL031', port_ch: '科维纳斯（哥伦比亚）' },
    { port_code: 'COM000', port_ch: '科摩罗' },
    { port_code: 'COM001', port_ch: '昂儒昂岛（科摩罗）' },
    { port_code: 'COM002', port_ch: '莫埃利岛（科摩罗）' },
    { port_code: 'COM003', port_ch: '藻德济（科摩罗）' },
    { port_code: 'COM006', port_ch: '丰博尼（科摩罗）' },
    { port_code: 'COM009', port_ch: '莫罗尼（科摩罗）' },
    { port_code: 'COM012', port_ch: '穆察穆杜（科摩罗）' },
    { port_code: 'CPV000', port_ch: '佛得角' },
    { port_code: 'CPV002', port_ch: '明德卢（佛得角）' },
    { port_code: 'CPV003', port_ch: '帕尔梅拉（佛得角）' },
    { port_code: 'CPV006', port_ch: '格兰德港（佛得角）' },
    { port_code: 'CPV009', port_ch: '普拉亚（佛得角）' },
    { port_code: 'CRI000', port_ch: '哥斯达黎加' },
    { port_code: 'CRI003', port_ch: '卡尔德拉（哥斯达黎加）' },
    { port_code: 'CRI006', port_ch: '戈尔菲托（哥斯达黎加）' },
    { port_code: 'CRI009', port_ch: '利蒙港（哥斯达黎加）' },
    { port_code: 'CRI012', port_ch: '彭塔雷纳斯（哥斯达黎加）' },
    { port_code: 'CRI015', port_ch: '克波斯（哥斯达黎加）' },
    { port_code: 'CUB000', port_ch: '古巴' },
    { port_code: 'CUB003', port_ch: '安蒂亚（古巴）' },
    { port_code: 'CUB006', port_ch: '翁达港（古巴）' },
    { port_code: 'CUB009', port_ch: '巴内斯（古巴）' },
    { port_code: 'CUB012', port_ch: '巴拉科阿（古巴）' },
    { port_code: 'CUB015', port_ch: '博卡格兰德（古巴）' },
    { port_code: 'CUB018', port_ch: '博克龙（古巴）' },
    { port_code: 'CUB021', port_ch: '卡瓦尼亚斯（古巴）' },
    { port_code: 'CUB024', port_ch: '凯巴连（古巴）' },
    { port_code: 'CUB027', port_ch: '凯马勒那（古巴）' },
    { port_code: 'CUB029', port_ch: '萨瓜塔那摩（古巴）' },
    { port_code: 'CUB030', port_ch: '卡德纳斯（古巴）' },
    { port_code: 'CUB033', port_ch: '卡西尔达（古巴）' },
    { port_code: 'CUB036', port_ch: '塞巴胡埃萨（古巴）' },
    { port_code: 'CUB039', port_ch: '西恩富戈斯（古巴）' },
    { port_code: 'CUB042', port_ch: '费尔顿（古巴）' },
    { port_code: 'CUB045', port_ch: '瓜亚瓦尔（古巴）' },
    { port_code: 'CUB048', port_ch: '哈瓦那（古巴）' },
    { port_code: 'CUB051', port_ch: '伊萨贝拉（古巴）' },
    { port_code: 'CUB054', port_ch: '胡卡罗（古巴）' },
    { port_code: 'CUB057', port_ch: '马纳蒂（古巴）' },
    { port_code: 'CUB060', port_ch: '马诺普拉（古巴）' },
    { port_code: 'CUB063', port_ch: '曼萨尼略（古巴）' },
    { port_code: 'CUB066', port_ch: '马里埃尔（古巴）' },
    { port_code: 'CUB069', port_ch: '马坦萨斯（古巴）' },
    { port_code: 'CUB072', port_ch: '梅迪亚卢纳（古巴）' },
    { port_code: 'CUB075', port_ch: '莫阿（古巴）' },
    { port_code: 'CUB078', port_ch: '尼卡罗（古巴）' },
    { port_code: 'CUB081', port_ch: '尼克罗（古巴）' },
    { port_code: 'CUB084', port_ch: '新赫罗纳（古巴）' },
    { port_code: 'CUB087', port_ch: '努埃维塔斯（古巴）' },
    { port_code: 'CUB090', port_ch: '帕洛阿尔托（古巴）' },
    { port_code: 'CUB093', port_ch: '帕斯特利洛（古巴）' },
    { port_code: 'CUB096', port_ch: '皮隆（古巴）' },
    { port_code: 'CUB099', port_ch: '普雷斯顿（古巴）' },
    { port_code: 'CUB102', port_ch: '帕德雷港（古巴）' },
    { port_code: 'CUB105', port_ch: '塔拉法港（古巴）' },
    { port_code: 'CUB108', port_ch: '大萨瓜（古巴）' },
    { port_code: 'CUB111', port_ch: '南圣克鲁斯（古巴）' },
    { port_code: 'CUB114', port_ch: '圣卡西亚（古巴）' },
    { port_code: 'CUB117', port_ch: '圣地亚哥（古巴）' },
    { port_code: 'CUB120', port_ch: '塔纳莫（古巴）' },
    { port_code: 'CUB123', port_ch: '图纳斯德萨萨（古巴）' },
    { port_code: 'CUB126', port_ch: '维塔（古巴）' },
    { port_code: 'CUB127', port_ch: 'DESEO（古巴）' },
    { port_code: 'CUW000', port_ch: '库腊索岛' },
    { port_code: 'CUW003', port_ch: '圣米歇尔湾（库腊索岛）' },
    { port_code: 'CXR000', port_ch: '圣诞岛' },
    { port_code: 'CYM000', port_ch: '开曼群岛' },
    { port_code: 'CYM003', port_ch: '乔治敦（开曼群岛）' },
    { port_code: 'CYP000', port_ch: '塞浦路斯' },
    { port_code: 'CYP003', port_ch: '阿克罗蒂里（塞浦路斯）' },
    { port_code: 'CYP006', port_ch: '泽凯利亚（塞浦路斯）' },
    { port_code: 'CYP009', port_ch: '法马古斯塔（塞浦路斯）' },
    { port_code: 'CYP010', port_ch: '吉兰丹（塞浦路斯）' },
    { port_code: 'CYP012', port_ch: '卡拉沃斯塔西（塞浦路斯）' },
    { port_code: 'CYP015', port_ch: '凯里尼亚（塞浦路斯）' },
    { port_code: 'CYP018', port_ch: '拉纳卡（塞浦路斯）' },
    { port_code: 'CYP021', port_ch: '腊基（塞浦路斯）' },
    { port_code: 'CYP024', port_ch: '利马索尔（塞浦路斯）' },
    { port_code: 'CYP027', port_ch: '莫尼安克雷奇（塞浦路斯）' },
    { port_code: 'CYP028', port_ch: '尼科西亚（塞浦路斯）' },
    { port_code: 'CYP030', port_ch: '莫尔富湾（塞浦路斯）' },
    { port_code: 'CYP033', port_ch: '帕福斯（塞浦路斯）' },
    { port_code: 'CYP036', port_ch: '瓦西利科湾（塞浦路斯）' },
    { port_code: 'CZE000', port_ch: '捷克' },
    { port_code: 'DEU000', port_ch: '德国' },
    { port_code: 'DEU003', port_ch: '阿尔托纳（德国）' },
    { port_code: 'DEU006', port_ch: '布莱克森（德国）' },
    { port_code: 'DEU009', port_ch: '波恩（德国）' },
    { port_code: 'DEU012', port_ch: '布腊克（德国）' },
    { port_code: 'DEU015', port_ch: '不来梅（德国）' },
    { port_code: 'DEU018', port_ch: '不来梅港（德国）' },
    { port_code: 'DEU021', port_ch: '布伦斯比特尔（德国）' },
    { port_code: 'DEU024', port_ch: '比瑟姆（德国）' },
    { port_code: 'DEU027', port_ch: '比茨费莱特（德国）' },
    { port_code: 'DEU030', port_ch: '科布伦茨（德国）' },
    { port_code: 'DEU033', port_ch: '科隆（德国）' },
    { port_code: 'DEU036', port_ch: '库克斯港（德国）' },
    { port_code: 'DEU039', port_ch: '杜伊斯堡（德国）' },
    { port_code: 'DEU042', port_ch: '杜塞尔多夫（德国）' },
    { port_code: 'DEU045', port_ch: '埃肯弗尔德（德国）' },
    { port_code: 'DEU048', port_ch: '埃尔斯费莱特（德国）' },
    { port_code: 'DEU051', port_ch: '埃姆登（德国）' },
    { port_code: 'DEU054', port_ch: '弗伦斯堡（德国）' },
    { port_code: 'DEU057', port_ch: '法兰克福（德国）' },
    { port_code: 'DEU060', port_ch: '格吕克施塔特（德国）' },
    { port_code: 'DEU063', port_ch: '汉堡（德国）' },
    { port_code: 'DEU066', port_ch: '海利根港（德国）' },
    { port_code: 'DEU069', port_ch: '霍尔特瑙（德国）' },
    { port_code: 'DEU072', port_ch: '胡苏姆（德国）' },
    { port_code: 'DEU075', port_ch: '伊策霍（德国）' },
    { port_code: 'DEU078', port_ch: '卡珀尔恩（德国）' },
    { port_code: 'DEU081', port_ch: '基尔（德国）' },
    { port_code: 'DEU084', port_ch: '克雷菲尔德（德国）' },
    { port_code: 'DEU087', port_ch: '拉伯（德国）' },
    { port_code: 'DEU090', port_ch: '累尔（德国）' },
    { port_code: 'DEU093', port_ch: '吕贝克（德国）' },
    { port_code: 'DEU096', port_ch: '路德维希港（德国）' },
    { port_code: 'DEU099', port_ch: '美因茨（德国）' },
    { port_code: 'DEU102', port_ch: '曼海姆（德国）' },
    { port_code: 'DEU105', port_ch: '诺伊豪斯（德国）' },
    { port_code: 'DEU108', port_ch: '诺伊斯（德国）' },
    { port_code: 'DEU111', port_ch: '诺伊施塔特（德国）' },
    { port_code: 'DEU114', port_ch: '诺登哈姆（德国）' },
    { port_code: 'DEU116', port_ch: '奥尔登堡（德国）' },
    { port_code: 'DEU117', port_ch: '奥尔特（德国）' },
    { port_code: 'DEU120', port_ch: '帕彭堡（德国）' },
    { port_code: 'DEU123', port_ch: '伦茨堡（德国）' },
    { port_code: 'DEU126', port_ch: '罗斯托克（德国）' },
    { port_code: 'DEU129', port_ch: '许劳（德国）' },
    { port_code: 'DEU132', port_ch: '施瓦苓郝廷（德国）' },
    { port_code: 'DEU135', port_ch: '施塔德（德国）' },
    { port_code: 'DEU138', port_ch: '施塔德桑德（德国）' },
    { port_code: 'DEU141', port_ch: '斯特拉尔松（德国）' },
    { port_code: 'DEU144', port_ch: '滕宁（德国）' },
    { port_code: 'DEU147', port_ch: '特罗弗明德（德国）' },
    { port_code: 'DEU150', port_ch: '弗格萨克（德国）' },
    { port_code: 'DEU153', port_ch: '瓦尔内明德（德国）' },
    { port_code: 'DEU156', port_ch: '威廉斯堡（德国）' },
    { port_code: 'DEU159', port_ch: '威廉港（德国）' },
    { port_code: 'DEU162', port_ch: '维斯马（德国）' },
    { port_code: 'DEU901', port_ch: '柏林（德国）' },
    { port_code: 'DEU904', port_ch: '慕尼黑（德国）' },
    { port_code: 'DJI000', port_ch: '吉布提' },
    { port_code: 'DJI003', port_ch: '吉布提（吉布提）' },
    { port_code: 'DJI004', port_ch: '奥博克（吉布提）' },
    { port_code: 'DJI005', port_ch: '塔朱拉（吉布提）' },
    { port_code: 'DMA000', port_ch: '多米尼克' },
    { port_code: 'DMA003', port_ch: '朴次茅斯（多米尼克）' },
    { port_code: 'DMA006', port_ch: '罗索（多米尼克）' },
    { port_code: 'DMA009', port_ch: 'DOMINICA（多米尼克）' },
    { port_code: 'DNK000', port_ch: '丹麦' },
    { port_code: 'DNK003', port_ch: '奥本罗（丹麦）' },
    { port_code: 'DNK006', port_ch: '奥尔堡（丹麦）' },
    { port_code: 'DNK009', port_ch: '奥胡斯（丹麦）' },
    { port_code: 'DNK012', port_ch: '埃勒斯克平（丹麦）' },
    { port_code: 'DNK015', port_ch: '阿灵厄（丹麦）' },
    { port_code: 'DNK018', port_ch: '阿森斯（丹麦）' },
    { port_code: 'DNK019', port_ch: '阿斯尼斯（丹麦）' },
    { port_code: 'DNK021', port_ch: '班霍尔姆（丹麦）' },
    { port_code: 'DNK024', port_ch: '博恩瑟（丹麦）' },
    { port_code: 'DNK027', port_ch: '哥本哈根（丹麦）' },
    { port_code: 'DNK030', port_ch: '埃伯尔措夫特（丹麦）' },
    { port_code: 'DNK033', port_ch: '埃尔西诺（丹麦）' },
    { port_code: 'DNK036', port_ch: '埃斯比约（丹麦）' },
    { port_code: 'DNK039', port_ch: '福堡（丹麦）' },
    { port_code: 'DNK041', port_ch: '恩舍尔兹维克（丹麦）' },
    { port_code: 'DNK042', port_ch: '法克瑟莱泽普拉斯（丹麦）' },
    { port_code: 'DNK045', port_ch: '腓特烈西亚（丹麦）' },
    { port_code: 'DNK048', port_ch: '腓特烈港（丹麦）' },
    { port_code: 'DNK051', port_ch: '腓特烈松（丹麦）' },
    { port_code: 'DNK054', port_ch: '腓特烈斯韦克（丹麦）' },
    { port_code: 'DNK057', port_ch: '格罗斯滕（丹麦）' },
    { port_code: 'DNK060', port_ch: '格雷诺（丹麦）' },
    { port_code: 'DNK063', port_ch: '基尔夫港（丹麦）' },
    { port_code: 'DNK064', port_ch: '吉尔夫哈文（丹麦）' },
    { port_code: 'DNK065', port_ch: '哈梅哈夫楠（丹麦）' },
    { port_code: 'DNK066', port_ch: '哈泽斯莱乌（丹麦）' },
    { port_code: 'DNK069', port_ch: '海松（丹麦）' },
    { port_code: 'DNK072', port_ch: '海斯勒（丹麦）' },
    { port_code: 'DNK074', port_ch: '沃斯托克岛（丹麦）' },
    { port_code: 'DNK075', port_ch: '希茨海尔斯（丹麦）' },
    { port_code: 'DNK076', port_ch: '谢累夫斯科尔（丹麦）' },
    { port_code: 'DNK078', port_ch: '霍布罗（丹麦）' },
    { port_code: 'DNK081', port_ch: '霍尔拜克（丹麦）' },
    { port_code: 'DNK084', port_ch: '霍森斯（丹麦）' },
    { port_code: 'DNK086', port_ch: '赫尔辛格（丹麦）' },
    { port_code: 'DNK087', port_ch: '凯隆堡（丹麦）' },
    { port_code: 'DNK090', port_ch: '卡勒拜克斯明讷（丹麦）' },
    { port_code: 'DNK093', port_ch: '凯特明讷（丹麦）' },
    { port_code: 'DNK096', port_ch: '克厄（丹麦）' },
    { port_code: 'DNK097', port_ch: '克拉克斯维克（丹麦）' },
    { port_code: 'DNK099', port_ch: '科灵（丹麦）' },
    { port_code: 'DNK102', port_ch: '科瑟（丹麦）' },
    { port_code: 'DNK105', port_ch: '金比（丹麦）' },
    { port_code: 'DNK108', port_ch: '莱姆维（丹麦）' },
    { port_code: 'DNK111', port_ch: '林斯奥得（丹麦）' },
    { port_code: 'DNK114', port_ch: '玛丽艾厄（丹麦）' },
    { port_code: 'DNK116', port_ch: '马斯内多韦尔凯特港（丹麦）' },
    { port_code: 'DNK117', port_ch: '马斯塔尔（丹麦）' },
    { port_code: 'DNK120', port_ch: '马斯讷松（丹麦）' },
    { port_code: 'DNK123', port_ch: '米泽尔法特（丹麦）' },
    { port_code: 'DNK126', port_ch: '奈斯特韦兹（丹麦）' },
    { port_code: 'DNK129', port_ch: '纳克斯考（丹麦）' },
    { port_code: 'DNK131', port_ch: '讷克塞（丹麦）' },
    { port_code: 'DNK132', port_ch: '内克瑟（丹麦）' },
    { port_code: 'DNK135', port_ch: '诺勒松比（丹麦）' },
    { port_code: 'DNK138', port_ch: '尼堡（丹麦）' },
    { port_code: 'DNK141', port_ch: '尼克宾（Fal.）（丹麦）' },
    { port_code: 'DNK144', port_ch: '尼克宾（Mors）（丹麦）' },
    { port_code: 'DNK147', port_ch: '尼克宾（Sja.）（丹麦）' },
    { port_code: 'DNK150', port_ch: '欧登塞（丹麦）' },
    { port_code: 'DNK153', port_ch: '奥勒霍兹（丹麦）' },
    { port_code: 'DNK156', port_ch: '兰讷斯（丹麦）' },
    { port_code: 'DNK159', port_ch: '勒兹比港（丹麦）' },
    { port_code: 'DNK162', port_ch: '勒兹维（丹麦）' },
    { port_code: 'DNK165', port_ch: '伦讷（丹麦）' },
    { port_code: 'DNK168', port_ch: '鲁兹克宾（丹麦）' },
    { port_code: 'DNK170', port_ch: '朴次茅斯（丹麦）' },
    { port_code: 'DNK171', port_ch: '萨克斯克宾（丹麦）' },
    { port_code: 'DNK174', port_ch: '斯凯尔克（丹麦）' },
    { port_code: 'DNK177', port_ch: '斯凯拜克（丹麦）' },
    { port_code: 'DNK180', port_ch: '斯卡恩（丹麦）' },
    { port_code: 'DNK183', port_ch: '斯基沃（丹麦）' },
    { port_code: 'DNK186', port_ch: '桑讷堡（丹麦）' },
    { port_code: 'DNK188', port_ch: '斯凯尔斯科尔（丹麦）' },
    { port_code: 'DNK189', port_ch: '斯泰厄（丹麦）' },
    { port_code: 'DNK195', port_ch: '斯楚厄（丹麦）' },
    { port_code: 'DNK198', port_ch: '斯图伯克宾（丹麦）' },
    { port_code: 'DNK201', port_ch: '斯图德斯特鲁普（丹麦）' },
    { port_code: 'DNK204', port_ch: '斯瓦讷克（丹麦）' },
    { port_code: 'DNK207', port_ch: '斯文堡（丹麦）' },
    { port_code: 'DNK209', port_ch: '特沃罗伊尔（丹麦）' },
    { port_code: 'DNK210', port_ch: '提斯特德（丹麦）' },
    { port_code: 'DNK213', port_ch: '图堡港（丹麦）' },
    { port_code: 'DNK214', port_ch: '吐伯堡（丹麦）' },
    { port_code: 'DNK215', port_ch: '托尔斯港（丹麦）' },
    { port_code: 'DNK216', port_ch: '瓦埃勒（丹麦）' },
    { port_code: 'DNK218', port_ch: '瓦古尔（丹麦）' },
    { port_code: 'DNK219', port_ch: '沃尔丁堡（丹麦）' },
    { port_code: 'DNK220', port_ch: '韦斯特马纳（丹麦）' },
    { port_code: 'DNK221', port_ch: 'ROSBYHAVN（丹麦）' },
    { port_code: 'DOM000', port_ch: '多米尼加共和国' },
    { port_code: 'DOM003', port_ch: '阿苏阿（多米尼加共和国）' },
    { port_code: 'DOM006', port_ch: '巴拉奥纳（多米尼加共和国）' },
    { port_code: 'DOM009', port_ch: '博卡奇卡（多米尼加共和国）' },
    { port_code: 'DOM012', port_ch: '卡沃罗霍（多米尼加共和国）' },
    { port_code: 'DOM015', port_ch: '拉罗马纳（多米尼加共和国）' },
    { port_code: 'DOM018', port_ch: '曼萨尼约（多米尼加共和国）' },
    { port_code: 'DOM021', port_ch: '帕伦克（多米尼加共和国）' },
    { port_code: 'DOM024', port_ch: '普拉塔港（多米尼加共和国）' },
    { port_code: 'DOM027', port_ch: '海纳（多米尼加共和国）' },
    { port_code: 'DOM030', port_ch: '萨马纳（多米尼加共和国）' },
    { port_code: 'DOM033', port_ch: '圣佩得罗德马科里斯（多米尼加共和国）' },
    { port_code: 'DOM036', port_ch: '桑切斯（多米尼加共和国）' },
    { port_code: 'DOM039', port_ch: '圣多明各（多米尼加共和国）' },
    { port_code: 'DZA000', port_ch: '阿尔及利亚' },
    { port_code: 'DZA002', port_ch: '阿尔及尔（阿尔及利亚）' },
    { port_code: 'DZA003', port_ch: '安纳巴（阿尔及利亚）' },
    { port_code: 'DZA006', port_ch: '阿尔泽（阿尔及利亚）' },
    { port_code: 'DZA009', port_ch: '贝贾亚（阿尔及利亚）' },
    { port_code: 'DZA012', port_ch: '贝尼萨夫（阿尔及利亚）' },
    { port_code: 'DZA013', port_ch: '布赖拉港（阿尔及利亚）' },
    { port_code: 'DZA014', port_ch: '圭敦港（阿尔及利亚）' },
    { port_code: 'DZA015', port_ch: '舍尔沙勒（阿尔及利亚）' },
    { port_code: 'DZA016', port_ch: '凯拉赫港（阿尔及利亚）' },
    { port_code: 'DZA017', port_ch: '奈穆尔（阿尔及利亚）' },
    { port_code: 'DZA018', port_ch: '塞港（阿尔及利亚）' },
    { port_code: 'DZA019', port_ch: '科洛（阿尔及利亚）' },
    { port_code: 'DZA021', port_ch: '代利斯（阿尔及利亚）' },
    { port_code: 'DZA024', port_ch: '贾扎伊尔（阿尔及利亚）' },
    { port_code: 'DZA027', port_ch: '加扎韦特（阿尔及利亚）' },
    { port_code: 'DZA030', port_ch: '吉杰勒（阿尔及利亚）' },
    { port_code: 'DZA033', port_ch: '莫斯塔加内姆（阿尔及利亚）' },
    { port_code: 'DZA035', port_ch: '奥兰（阿尔及利亚）' },
    { port_code: 'DZA036', port_ch: '斯基克达（阿尔及利亚）' },
    { port_code: 'DZA039', port_ch: '提奈斯（阿尔及利亚）' },
    { port_code: 'DZA042', port_ch: '瓦赫兰（阿尔及利亚）' },
    { port_code: 'ECU000', port_ch: '厄瓜多尔' },
    { port_code: 'ECU003', port_ch: '卡拉克斯湾（厄瓜多尔）' },
    { port_code: 'ECU006', port_ch: '巴诺特米拉尔（厄瓜多尔）' },
    { port_code: 'ECU009', port_ch: '埃斯梅拉达斯（厄瓜多尔）' },
    { port_code: 'ECU012', port_ch: '瓜亚基尔（厄瓜多尔）' },
    { port_code: 'ECU015', port_ch: '拉利伯塔德（厄瓜多尔）' },
    { port_code: 'ECU018', port_ch: '曼塔（厄瓜多尔）' },
    { port_code: 'ECU021', port_ch: '玻利瓦尔港（厄瓜多尔）' },
    { port_code: 'ECU024', port_ch: '萨利纳斯（厄瓜多尔）' },
    { port_code: 'ECU027', port_ch: '圣洛伦索（厄瓜多尔）' },
    { port_code: 'EGY000', port_ch: '埃及' },
    { port_code: 'EGY003', port_ch: '阿布宰尼迈（埃及）' },
    { port_code: 'EGY006', port_ch: '阿代比耶（埃及）' },
    { port_code: 'EGY009', port_ch: '艾因苏赫纳（埃及）' },
    { port_code: 'EGY012', port_ch: '亚历山大（埃及）' },
    { port_code: 'EGY015', port_ch: '达米埃塔（埃及）' },
    { port_code: 'EGY018', port_ch: '库赛尔（埃及）' },
    { port_code: 'EGY021', port_ch: '哈姆拉港（埃及）' },
    { port_code: 'EGY024', port_ch: '马特鲁港（埃及）' },
    { port_code: 'EGY027', port_ch: '易卜拉欣港（埃及）' },
    { port_code: 'EGY030', port_ch: '塞得港（埃及）' },
    { port_code: 'EGY033', port_ch: '陶菲克港（埃及）' },
    { port_code: 'EGY036', port_ch: '拉斯加里卜（埃及）' },
    { port_code: 'EGY039', port_ch: '喇斯舒海尔（埃及）' },
    { port_code: 'EGY042', port_ch: '塞法杰（埃及）' },
    { port_code: 'EGY045', port_ch: '塞卢姆（埃及）' },
    { port_code: 'EGY048', port_ch: '西迪基里尔（埃及）' },
    { port_code: 'EGY051', port_ch: '苏伊士（埃及）' },
    { port_code: 'EGY054', port_ch: '瓦迪费兰（埃及）' },
    { port_code: 'EGY055', port_ch: '伊斯梅利亚（埃及）' },
    { port_code: 'EGY901', port_ch: '开罗（埃及）' },
    { port_code: 'ERI000', port_ch: '厄立特里亚' },
    { port_code: 'ERI003', port_ch: '阿萨布（厄立特里亚）' },
    { port_code: 'ERI006', port_ch: '马萨瓦（厄立特里亚）' },
    { port_code: 'ESH000', port_ch: '西撒哈拉' },
    { port_code: 'ESH003', port_ch: '达赫拉（西撒哈拉）' },
    { port_code: 'ESH006', port_ch: '欧云（阿龙恩）（西撒哈拉）' },
    { port_code: 'ESH007', port_ch: '锡兹内罗斯城（西撒哈拉）' },
    { port_code: 'ESP000', port_ch: '西班牙' },
    { port_code: 'ESP003', port_ch: '阿德拉（西班牙）' },
    { port_code: 'ESP006', port_ch: '阿吉拉斯（西班牙）' },
    { port_code: 'ESP009', port_ch: '阿尔库迪亚（西班牙）' },
    { port_code: 'ESP012', port_ch: '阿尔赫西拉斯（西班牙）' },
    { port_code: 'ESP015', port_ch: '阿利坎特（西班牙）' },
    { port_code: 'ESP018', port_ch: '阿尔梅里亚（西班牙）' },
    { port_code: 'ESP020', port_ch: '阿雷西费（西班牙）' },
    { port_code: 'ESP021', port_ch: '阿维莱斯（西班牙）' },
    { port_code: 'ESP024', port_ch: '巴塞罗那（西班牙）' },
    { port_code: 'ESP027', port_ch: '毕尔巴鄂（西班牙）' },
    { port_code: 'ESP030', port_ch: '布拉内斯（西班牙）' },
    { port_code: 'ESP033', port_ch: '布雷拉（西班牙）' },
    { port_code: 'ESP036', port_ch: '布里亚纳（西班牙）' },
    { port_code: 'ESP039', port_ch: '加的斯（西班牙）' },
    { port_code: 'ESP042', port_ch: '菲力斯特里（西班牙）' },
    { port_code: 'ESP045', port_ch: '卡塔赫纳（西班牙）' },
    { port_code: 'ESP047', port_ch: '休达（西班牙）' },
    { port_code: 'ESP048', port_ch: '卡斯特利翁（西班牙）' },
    { port_code: 'ESP051', port_ch: '乌迪亚莱斯堡（西班牙）' },
    { port_code: 'ESP054', port_ch: '锡列罗（西班牙）' },
    { port_code: 'ESP057', port_ch: '科尔库维翁（西班牙）' },
    { port_code: 'ESP060', port_ch: '科伦纳（西班牙）' },
    { port_code: 'ESP063', port_ch: '德尼亚（西班牙）' },
    { port_code: 'ESP066', port_ch: '埃斯孔布雷阿斯（西班牙）' },
    { port_code: 'ESP069', port_ch: '费罗尔（西班牙）' },
    { port_code: 'ESP072', port_ch: '刚迪亚（西班牙）' },
    { port_code: 'ESP075', port_ch: '加鲁查（西班牙）' },
    { port_code: 'ESP078', port_ch: '希洪（西班牙）' },
    { port_code: 'ESP079', port_ch: '拉科鲁尼亚（西班牙）' },
    { port_code: 'ESP080', port_ch: '拉斯帕尔马斯（西班牙）' },
    { port_code: 'ESP081', port_ch: '韦尔瓦（西班牙）' },
    { port_code: 'ESP084', port_ch: '伊维萨（西班牙）' },
    { port_code: 'ESP087', port_ch: '哈韦阿（西班牙）' },
    { port_code: 'ESP090', port_ch: '拉卡莱拉（西班牙）' },
    { port_code: 'ESP093', port_ch: '卢阿尔卡（西班牙）' },
    { port_code: 'ESP096', port_ch: '马翁（西班牙）' },
    { port_code: 'ESP099', port_ch: '马拉加（西班牙）' },
    { port_code: 'ESP100', port_ch: '梅利利亚（西班牙）' },
    { port_code: 'ESP102', port_ch: '马林（西班牙）' },
    { port_code: 'ESP105', port_ch: '马萨龙（西班牙）' },
    { port_code: 'ESP108', port_ch: '莫特里尔（西班牙）' },
    { port_code: 'ESP111', port_ch: '穆罗斯（西班牙）' },
    { port_code: 'ESP114', port_ch: '帕拉莫斯（西班牙）' },
    { port_code: 'ESP117', port_ch: '帕尔马（西班牙）' },
    { port_code: 'ESP120', port_ch: '帕萨赫斯（西班牙）' },
    { port_code: 'ESP123', port_ch: '波图加莱特（西班牙）' },
    { port_code: 'ESP126', port_ch: '萨尔塔卡瓦略（西班牙）' },
    { port_code: 'ESP129', port_ch: '里瓦德奥（西班牙）' },
    { port_code: 'ESP132', port_ch: '里瓦德塞利亚（西班牙）' },
    { port_code: 'ESP135', port_ch: '罗萨斯（西班牙）' },
    { port_code: 'ESP137', port_ch: '罗萨里奥港（西班牙）' },
    { port_code: 'ESP138', port_ch: '罗塔（西班牙）' },
    { port_code: 'ESP141', port_ch: '萨贡托（西班牙）' },
    { port_code: 'ESP144', port_ch: '圣卡洛斯（西班牙）' },
    { port_code: 'ESP147', port_ch: '圣西普里安（西班牙）' },
    { port_code: 'ESP150', port_ch: '圣埃斯特班（西班牙）' },
    { port_code: 'ESP153', port_ch: '圣费里乌德古绍尔斯（西班牙）' },
    { port_code: 'ESP156', port_ch: '圣费尔南多（西班牙）' },
    { port_code: 'ESP159', port_ch: '圣塞瓦斯蒂安（西班牙）' },
    { port_code: 'ESP161', port_ch: '圣克鲁斯（西班牙）' },
    { port_code: 'ESP162', port_ch: '桑坦德（西班牙）' },
    { port_code: 'ESP165', port_ch: '塞维利亚（西班牙）' },
    { port_code: 'ESP168', port_ch: '索列尔（西班牙）' },
    { port_code: 'ESP171', port_ch: '塔拉戈纳（西班牙）' },
    { port_code: 'ESP174', port_ch: '托雷维耶哈（西班牙）' },
    { port_code: 'ESP177', port_ch: '巴伦西亚（西班牙）' },
    { port_code: 'ESP180', port_ch: '维哥（西班牙）' },
    { port_code: 'ESP183', port_ch: '维利亚加西（西班牙）' },
    { port_code: 'ESP186', port_ch: '比韦罗（西班牙）' },
    { port_code: 'ESP201', port_ch: 'ASTILLERO（西班牙）' },
    { port_code: 'ESP202', port_ch: 'BALEARIC IA.（西班牙）' },
    { port_code: 'ESP203', port_ch: '阿斯塔科斯（西班牙）' },
    { port_code: 'ESP205', port_ch: '波尔曼（西班牙）' },
    { port_code: 'ESP206', port_ch: '库列腊（西班牙）' },
    { port_code: 'ESP209', port_ch: '拉萨利内塔（大西洋群岛）' },
    { port_code: 'ESP901', port_ch: '马德里（西班牙）' },
    { port_code: 'EST000', port_ch: '爱沙尼亚' },
    { port_code: 'EST003', port_ch: '纳尔瓦约埃苏（爱沙尼亚）' },
    { port_code: 'EST006', port_ch: '派尔努/皮亚尔努（爱沙尼亚）' },
    { port_code: 'EST009', port_ch: '塔林（爱沙尼亚）' },
    { port_code: 'ETH000', port_ch: '埃塞俄比亚' },
    { port_code: 'ETH003', port_ch: '阿萨布（埃塞俄比亚）' },
    { port_code: 'ETH005', port_ch: '蒂奥（埃塞俄比亚）' },
    { port_code: 'ETH006', port_ch: '马萨瓦（埃塞俄比亚）' },
    { port_code: 'FIN000', port_ch: '芬兰' },
    { port_code: 'FIN003', port_ch: '巴罗生特（芬兰）' },
    { port_code: 'FIN006', port_ch: '代格比（芬兰）' },
    { port_code: 'FIN009', port_ch: '哈米纳（芬兰）' },
    { port_code: 'FIN012', port_ch: '汉科（芬兰）' },
    { port_code: 'FIN013', port_ch: '卡斯基嫩（芬兰）' },
    { port_code: 'FIN014', port_ch: '贾科布斯塔德（芬兰）' },
    { port_code: 'FIN015', port_ch: '赫尔辛基（芬兰）' },
    { port_code: 'FIN018', port_ch: '因科（芬兰）' },
    { port_code: 'FIN021', port_ch: '伊斯奈斯（芬兰）' },
    { port_code: 'FIN024', port_ch: '卡斯基宁（芬兰）' },
    { port_code: 'FIN027', port_ch: '凯米（芬兰）' },
    { port_code: 'FIN030', port_ch: '科科拉（芬兰）' },
    { port_code: 'FIN033', port_ch: '科特卡（芬兰）' },
    { port_code: 'FIN036', port_ch: '科维尔哈（芬兰）' },
    { port_code: 'FIN039', port_ch: '克里斯蒂娜城（芬兰）' },
    { port_code: 'FIN041', port_ch: '克里斯提内斯塔德（芬兰）' },
    { port_code: 'FIN042', port_ch: '拉柏罗吐（芬兰）' },
    { port_code: 'FIN045', port_ch: '洛维萨（芬兰）' },
    { port_code: 'FIN048', port_ch: '曼蒂卢奥托（芬兰）' },
    { port_code: 'FIN051', port_ch: '玛丽港（芬兰）' },
    { port_code: 'FIN054', port_ch: '梅里卡尔维亚（芬兰）' },
    { port_code: 'FIN057', port_ch: '楠塔利（芬兰）' },
    { port_code: 'FIN060', port_ch: '尼斯塔德（芬兰）' },
    { port_code: 'FIN062', port_ch: 'ROYTTA（芬兰）' },
    { port_code: 'FIN063', port_ch: '奥鲁（芬兰）' },
    { port_code: 'FIN066', port_ch: '柏尔加斯（芬兰）' },
    { port_code: 'FIN069', port_ch: '帕特尼安密（芬兰）' },
    { port_code: 'FIN072', port_ch: '皮耶塔尔萨里（芬兰）' },
    { port_code: 'FIN075', port_ch: '波里（芬兰）' },
    { port_code: 'FIN078', port_ch: '波卡拉（芬兰）' },
    { port_code: 'FIN081', port_ch: '波尔沃（芬兰）' },
    { port_code: 'FIN084', port_ch: '拉赫（芬兰）' },
    { port_code: 'FIN086', port_ch: '拉赫提（芬兰）' },
    { port_code: 'FIN087', port_ch: '劳马（芬兰）' },
    { port_code: 'FIN090', port_ch: '雷波萨里（芬兰）' },
    { port_code: 'FIN093', port_ch: '塞马运河（芬兰）' },
    { port_code: 'FIN096', port_ch: '斯库卢（芬兰）' },
    { port_code: 'FIN099', port_ch: '塔米萨里（芬兰）' },
    { port_code: 'FIN102', port_ch: '托基斯（芬兰）' },
    { port_code: 'FIN105', port_ch: '托比拉（芬兰）' },
    { port_code: 'FIN108', port_ch: '托尔尼奥（芬兰）' },
    { port_code: 'FIN110', port_ch: '坦佩雷（芬兰）' },
    { port_code: 'FIN111', port_ch: '图尔库（芬兰）' },
    { port_code: 'FIN114', port_ch: '新考蓬基（芬兰）' },
    { port_code: 'FIN117', port_ch: '瓦萨（芬兰）' },
    { port_code: 'FIN120', port_ch: '瓦斯克尔良托（芬兰）' },
    { port_code: 'FIN123', port_ch: '卫特什露土（芬兰）' },
    { port_code: 'FIN126', port_ch: '瓦尔卡姆（芬兰）' },
    { port_code: 'FIN129', port_ch: '伊克斯皮拉雅（芬兰）' },
    { port_code: 'FJI000', port_ch: '斐济' },
    { port_code: 'FJI003', port_ch: '埃灵顿（斐济）' },
    { port_code: 'FJI006', port_ch: '兰巴萨（斐济）' },
    { port_code: 'FJI009', port_ch: '劳托卡（斐济）' },
    { port_code: 'FJI012', port_ch: '累武卡（斐济）' },
    { port_code: 'FJI015', port_ch: '萨武萨武湾（斐济）' },
    { port_code: 'FJI018', port_ch: '苏瓦（斐济）' },
    { port_code: 'FJI021', port_ch: '瓦提亚角（斐济）' },
    { port_code: 'FJI901', port_ch: '楠迪（斐济）' },
    { port_code: 'FLK000', port_ch: '福克兰群岛(马尔维纳斯)' },
    { port_code: 'FLK003', port_ch: '斯坦利港（福克兰群岛(马尔维纳斯)）' },
    { port_code: 'FRA000', port_ch: '法国' },
    { port_code: 'FRA002', port_ch: 'AMBES（法国）' },
    { port_code: 'FRA003', port_ch: '阿布维尔（法国）' },
    { port_code: 'FRA006', port_ch: '阿雅克肖（法国）' },
    { port_code: 'FRA009', port_ch: '昂蒂布（法国）' },
    { port_code: 'FRA012', port_ch: '昂蒂弗（法国）' },
    { port_code: 'FRA015', port_ch: '阿尔卡雄（法国）' },
    { port_code: 'FRA018', port_ch: '巴森（法国）' },
    { port_code: 'FRA021', port_ch: '巴斯蒂亚（法国）' },
    { port_code: 'FRA024', port_ch: '巴约讷（法国）' },
    { port_code: 'FRA027', port_ch: '贝克德阿姆比斯（法国）' },
    { port_code: 'FRA030', port_ch: '布莱（法国）' },
    { port_code: 'FRA033', port_ch: '博尼法乔（法国）' },
    { port_code: 'FRA036', port_ch: '波尔多（法国）' },
    { port_code: 'FRA039', port_ch: '布洛涅（法国）' },
    { port_code: 'FRA042', port_ch: '布雷斯特（法国）' },
    { port_code: 'FRA045', port_ch: '卡昂（法国）' },
    { port_code: 'FRA048', port_ch: '加来（法国）' },
    { port_code: 'FRA051', port_ch: '卡尔维（法国）' },
    { port_code: 'FRA054', port_ch: '卡马雷（法国）' },
    { port_code: 'FRA057', port_ch: '康卡勒（法国）' },
    { port_code: 'FRA060', port_ch: '戛纳（法国）' },
    { port_code: 'FRA063', port_ch: '卡隆特（法国）' },
    { port_code: 'FRA066', port_ch: '瑟堡（法国）' },
    { port_code: 'FRA069', port_ch: '孔卡尔诺（法国）' },
    { port_code: 'FRA072', port_ch: '达乌埃（法国）' },
    { port_code: 'FRA075', port_ch: '多维尔（法国）' },
    { port_code: 'FRA078', port_ch: '迪耶普（法国）' },
    { port_code: 'FRA081', port_ch: '栋日（法国）' },
    { port_code: 'FRA084', port_ch: '杜阿梅勒兹（法国）' },
    { port_code: 'FRA087', port_ch: '敦刻尔克（法国）' },
    { port_code: 'FRA090', port_ch: '埃塔普勒（法国）' },
    { port_code: 'FRA093', port_ch: '费康（法国）' },
    { port_code: 'FRA096', port_ch: '福斯（法国）' },
    { port_code: 'FRA099', port_ch: '贡夫勒维尔（法国）' },
    { port_code: 'FRA102', port_ch: '格兰维尔（法国）' },
    { port_code: 'FRA105', port_ch: '格拉沃利讷（法国）' },
    { port_code: 'FRA108', port_ch: '阿弗尔（法国）' },
    { port_code: 'FRA111', port_ch: '翁弗勒尔（法国）' },
    { port_code: 'FRA114', port_ch: '伊尔鲁斯（法国）' },
    { port_code: 'FRA117', port_ch: '拉西约塔（法国）' },
    { port_code: 'FRA120', port_ch: '拉努韦勒（法国）' },
    { port_code: 'FRA123', port_ch: '拉帕利斯（法国）' },
    { port_code: 'FRA126', port_ch: '拉罗谢尔（法国）' },
    { port_code: 'FRA129', port_ch: '朗代诺（法国）' },
    { port_code: 'FRA132', port_ch: '拉瓦拉（法国）' },
    { port_code: 'FRA135', port_ch: '奥来龙堡（法国）' },
    { port_code: 'FRA138', port_ch: '勒吉尔多（法国）' },
    { port_code: 'FRA141', port_ch: '利布尔讷（法国）' },
    { port_code: 'FRA144', port_ch: '洛克蒂迪（法国）' },
    { port_code: 'FRA147', port_ch: '洛里昂（法国）' },
    { port_code: 'FRA150', port_ch: '马朗（法国）' },
    { port_code: 'FRA153', port_ch: '马赛（法国）' },
    { port_code: 'FRA156', port_ch: '马蒂格（法国）' },
    { port_code: 'FRA159', port_ch: '蒙托伊尔（法国）' },
    { port_code: 'FRA162', port_ch: '莫尔莱（法国）' },
    { port_code: 'FRA165', port_ch: '南特（法国）' },
    { port_code: 'FRA168', port_ch: '尼斯（法国）' },
    { port_code: 'FRA171', port_ch: '乌伊斯特勒昂（法国）' },
    { port_code: 'FRA174', port_ch: '潘伯夫（法国）' },
    { port_code: 'FRA177', port_ch: '潘波勒（法国）' },
    { port_code: 'FRA180', port_ch: '帕里斯（法国）' },
    { port_code: 'FRA183', port_ch: '波亚克（法国）' },
    { port_code: 'FRA186', port_ch: '彭拉贝（法国）' },
    { port_code: 'FRA189', port_ch: '布克港（法国）' },
    { port_code: 'FRA192', port_ch: '杰罗姆港（法国）' },
    { port_code: 'FRA195', port_ch: '旺德尔港（法国）' },
    { port_code: 'FRA198', port_ch: '韦基奥港（法国）' },
    { port_code: 'FRA201', port_ch: '普罗普里亚诺（法国）' },
    { port_code: 'FRA204', port_ch: '坎佩尔（法国）' },
    { port_code: 'FRA207', port_ch: '罗什福尔（法国）' },
    { port_code: 'FRA210', port_ch: '罗斯科夫（法国）' },
    { port_code: 'FRA213', port_ch: '鲁昂（法国）' },
    { port_code: 'FRA216', port_ch: '萨布勒多隆（法国）' },
    { port_code: 'FRA219', port_ch: '塞特（法国）' },
    { port_code: 'FRA222', port_ch: '圣布里厄（法国）' },
    { port_code: 'FRA225', port_ch: '圣让德吕兹（法国）' },
    { port_code: 'FRA228', port_ch: '圣路易罗纳（法国）' },
    { port_code: 'FRA231', port_ch: '圣马洛（法国）' },
    { port_code: 'FRA234', port_ch: '圣纳泽尔（法国）' },
    { port_code: 'FRA237', port_ch: '圣塞尔旺（法国）' },
    { port_code: 'FRA240', port_ch: '圣瓦勒利（法国）' },
    { port_code: 'FRA243', port_ch: '圣瓦莱里昂科（法国）' },
    { port_code: 'FRA246', port_ch: '斯特拉斯堡（法国）' },
    { port_code: 'FRA249', port_ch: '托内沙朗特（法国）' },
    { port_code: 'FRA252', port_ch: '土伦（法国）' },
    { port_code: 'FRA255', port_ch: '特雷吉耶（法国）' },
    { port_code: 'FRA258', port_ch: '特雷波特（法国）' },
    { port_code: 'FRA261', port_ch: '特鲁维尔（法国）' },
    { port_code: 'FRA264', port_ch: '瓦讷（法国）' },
    { port_code: 'FRA267', port_ch: '韦尔东（法国）' },
    { port_code: 'FRA901', port_ch: '巴黎（法国）' },
    { port_code: 'FRA902', port_ch: '勒阿弗尔（法国）' },
    { port_code: 'FRA903', port_ch: '里昂圣图拉斯（法国）' },
    { port_code: 'FRO000', port_ch: '法罗群岛' },
    { port_code: 'FRO003', port_ch: '克拉克斯维克（法罗群岛）' },
    { port_code: 'FRO006', port_ch: '托尔斯港（法罗群岛）' },
    { port_code: 'FRO009', port_ch: '特朗斯瓦格（法罗群岛）' },
    { port_code: 'FRO012', port_ch: '特瓦罗伊里（法罗群岛）' },
    { port_code: 'FRO015', port_ch: '瓦格（法罗群岛）' },
    { port_code: 'FRO018', port_ch: '韦斯特门港（法罗群岛）' },
    { port_code: 'FSM000', port_ch: '密克罗尼西亚（联邦）' },
    { port_code: 'FSM003', port_ch: '丘克群岛（密克罗尼西亚（联邦））' },
    { port_code: 'FSM006', port_ch: '波纳佩（密克罗尼西亚（联邦））' },
    { port_code: 'FSM009', port_ch: '雅浦（密克罗尼西亚（联邦））' },
    { port_code: 'FSM011', port_ch: '库赛埃岛（密克罗尼西亚（联邦））' },
    { port_code: 'FSM012', port_ch: '瓦兰岛（密克罗尼西亚（联邦））' },
    { port_code: 'GAB000', port_ch: '加蓬' },
    { port_code: 'GAB002', port_ch: '马永巴（加蓬）' },
    { port_code: 'GAB003', port_ch: '洛佩斯角（加蓬）' },
    { port_code: 'GAB006', port_ch: '甘巴（加蓬）' },
    { port_code: 'GAB009', port_ch: '利伯维尔（加蓬）' },
    { port_code: 'GAB012', port_ch: '卢西纳码头（加蓬）' },
    { port_code: 'GAB015', port_ch: '奥文多（加蓬）' },
    { port_code: 'GAB018', port_ch: '让蒂尔港（加蓬）' },
    { port_code: 'GBR000', port_ch: '英国' },
    { port_code: 'GBR003', port_ch: '阿伯丁（英国）' },
    { port_code: 'GBR006', port_ch: '阿伯道尔（英国）' },
    { port_code: 'GBR009', port_ch: '阿伯多维（英国）' },
    { port_code: 'GBR012', port_ch: '阿伯里斯特威斯（英国）' },
    { port_code: 'GBR015', port_ch: '奥尔德尼（英国）' },
    { port_code: 'GBR018', port_ch: '阿姆卢赫（英国）' },
    { port_code: 'GBR021', port_ch: '安纳隆（英国）' },
    { port_code: 'GBR024', port_ch: '安嫩（英国）' },
    { port_code: 'GBR027', port_ch: '安斯特拉瑟（英国）' },
    { port_code: 'GBR030', port_ch: '阿普尔多尔（英国）' },
    { port_code: 'GBR033', port_ch: '阿布罗斯（英国）' },
    { port_code: 'GBR036', port_ch: '阿德格拉斯（英国）' },
    { port_code: 'GBR039', port_ch: '阿德里希格（英国）' },
    { port_code: 'GBR042', port_ch: '阿德罗森（英国）' },
    { port_code: 'GBR045', port_ch: '埃文茅斯（英国）' },
    { port_code: 'GBR048', port_ch: '艾尔（英国）' },
    { port_code: 'GBR051', port_ch: '班戈（W.C.）（英国）' },
    { port_code: 'GBR054', port_ch: '班戈（Co.Down）（英国）' },
    { port_code: 'GBR057', port_ch: '巴茅思（英国）' },
    { port_code: 'GBR060', port_ch: '巴恩斯特珀尔（英国）' },
    { port_code: 'GBR063', port_ch: '巴罗（英国）' },
    { port_code: 'GBR066', port_ch: '巴里（英国）' },
    { port_code: 'GBR069', port_ch: '巴顿（E.C.）（英国）' },
    { port_code: 'GBR072', port_ch: '巴顿（W.C.）（英国）' },
    { port_code: 'GBR075', port_ch: '博马里斯（英国）' },
    { port_code: 'GBR078', port_ch: '贝尔法斯特（英国）' },
    { port_code: 'GBR081', port_ch: '伯威克（英国）' },
    { port_code: 'GBR084', port_ch: '比迪福德（英国）' },
    { port_code: 'GBR087', port_ch: '伯肯黑德（英国）' },
    { port_code: 'GBR090', port_ch: '布莱斯（英国）' },
    { port_code: 'GBR093', port_ch: '波士顿（英国）' },
    { port_code: 'GBR096', port_ch: '布里奇沃特（英国）' },
    { port_code: 'GBR099', port_ch: '布里德灵顿（英国）' },
    { port_code: 'GBR102', port_ch: '布里德波特（英国）' },
    { port_code: 'GBR105', port_ch: '布赖特灵西（英国）' },
    { port_code: 'GBR108', port_ch: '布赖顿（英国）' },
    { port_code: 'GBR111', port_ch: '布里斯托尔（英国）' },
    { port_code: 'GBR114', port_ch: '布里克瑟姆（英国）' },
    { port_code: 'GBR117', port_ch: '布朗巴勒（英国）' },
    { port_code: 'GBR120', port_ch: '巴基（英国）' },
    { port_code: 'GBR123', port_ch: '伯格黑德（英国）' },
    { port_code: 'GBR126', port_ch: '本泰兰（英国）' },
    { port_code: 'GBR129', port_ch: '卡那封（英国）' },
    { port_code: 'GBR132', port_ch: '坎贝尔敦（英国）' },
    { port_code: 'GBR135', port_ch: '加的夫（英国）' },
    { port_code: 'GBR138', port_ch: '卡里克弗格斯（英国）' },
    { port_code: 'GBR141', port_ch: '卡斯尔敦（英国）' },
    { port_code: 'GBR144', port_ch: '查尔斯敦（Corn.）（英国）' },
    { port_code: 'GBR147', port_ch: '查尔斯敦（Fife）（英国）' },
    { port_code: 'GBR150', port_ch: '科尔切斯特（英国）' },
    { port_code: 'GBR153', port_ch: '科尔雷恩（英国）' },
    { port_code: 'GBR156', port_ch: '康纳斯基（英国）' },
    { port_code: 'GBR159', port_ch: '科珀赫（英国）' },
    { port_code: 'GBR162', port_ch: '考斯（英国）' },
    { port_code: 'GBR165', port_ch: '克罗默蒂（英国）' },
    { port_code: 'GBR168', port_ch: '达特茅斯（英国）' },
    { port_code: 'GBR171', port_ch: '丁沃尔（英国）' },
    { port_code: 'GBR174', port_ch: '道格拉斯（英国）' },
    { port_code: 'GBR176', port_ch: '克莱德港（英国）' },
    { port_code: 'GBR177', port_ch: '多佛尔（英国）' },
    { port_code: 'GBR180', port_ch: '邓弗里斯（英国）' },
    { port_code: 'GBR183', port_ch: '邓巴（英国）' },
    { port_code: 'GBR186', port_ch: '邓迪（英国）' },
    { port_code: 'GBR189', port_ch: '邓德拉姆（英国）' },
    { port_code: 'GBR192', port_ch: '埃尔斯米尔港（英国）' },
    { port_code: 'GBR195', port_ch: '埃克塞特（英国）' },
    { port_code: 'GBR198', port_ch: '埃克斯茅斯（英国）' },
    { port_code: 'GBR201', port_ch: '艾茅斯（英国）' },
    { port_code: 'GBR204', port_ch: '法尔茅斯（英国）' },
    { port_code: 'GBR207', port_ch: '福利（英国）' },
    { port_code: 'GBR210', port_ch: '弗利克斯托（英国）' },
    { port_code: 'GBR213', port_ch: '芬纳特（英国）' },
    { port_code: 'GBR216', port_ch: '菲什加德（英国）' },
    { port_code: 'GBR219', port_ch: '弗利特伍德（英国）' },
    { port_code: 'GBR222', port_ch: '福克斯通（英国）' },
    { port_code: 'GBR225', port_ch: '福伊（英国）' },
    { port_code: 'GBR228', port_ch: '弗雷泽堡（英国）' },
    { port_code: 'GBR231', port_ch: '盖恩斯伯勒（英国）' },
    { port_code: 'GBR234', port_ch: '加利斯敦（英国）' },
    { port_code: 'GBR237', port_ch: '加斯顿（英国）' },
    { port_code: 'GBR240', port_ch: '格文（英国）' },
    { port_code: 'GBR243', port_ch: '格拉斯哥（英国）' },
    { port_code: 'GBR246', port_ch: '格莱纳姆（英国）' },
    { port_code: 'GBR249', port_ch: '格洛斯特（英国）' },
    { port_code: 'GBR252', port_ch: '古尔（英国）' },
    { port_code: 'GBR255', port_ch: '古罗克（英国）' },
    { port_code: 'GBR258', port_ch: '格兰奇茅斯（英国）' },
    { port_code: 'GBR261', port_ch: '格雷夫森德（英国）' },
    { port_code: 'GBR264', port_ch: '大雅茅斯（英国）' },
    { port_code: 'GBR267', port_ch: '格里诺克（英国）' },
    { port_code: 'GBR270', port_ch: '格里姆斯比（英国）' },
    { port_code: 'GBR273', port_ch: '冈纳斯（英国）' },
    { port_code: 'GBR276', port_ch: '哈特尔浦（英国）' },
    { port_code: 'GBR279', port_ch: '哈里奇（英国）' },
    { port_code: 'GBR282', port_ch: '海尔（英国）' },
    { port_code: 'GBR285', port_ch: '希舍姆（英国）' },
    { port_code: 'GBR288', port_ch: '霍利黑德（英国）' },
    { port_code: 'GBR291', port_ch: '霍德角（英国）' },
    { port_code: 'GBR294', port_ch: '赫尔（英国）' },
    { port_code: 'GBR297', port_ch: '亨特斯顿（英国）' },
    { port_code: 'GBR300', port_ch: '伊明赫姆（英国）' },
    { port_code: 'GBR303', port_ch: '因弗戈登（英国）' },
    { port_code: 'GBR306', port_ch: '因弗内斯（英国）' },
    { port_code: 'GBR309', port_ch: '伊普斯威奇（英国）' },
    { port_code: 'GBR312', port_ch: '欧文（英国）' },
    { port_code: 'GBR315', port_ch: '谷岛（英国）' },
    { port_code: 'GBR318', port_ch: '基尔基尔（英国）' },
    { port_code: 'GBR321', port_ch: '基林霍尔姆（英国）' },
    { port_code: 'GBR324', port_ch: '金斯林（英国）' },
    { port_code: 'GBR327', port_ch: '柯科迪（英国）' },
    { port_code: 'GBR330', port_ch: '柯克沃尔（英国）' },
    { port_code: 'GBR333', port_ch: '洛哈尔什教区凯尔（英国）' },
    { port_code: 'GBR336', port_ch: '朗姆（英国）' },
    { port_code: 'GBR339', port_ch: '兰开斯特（英国）' },
    { port_code: 'GBR342', port_ch: '拉格斯（英国）' },
    { port_code: 'GBR345', port_ch: '拉恩（英国）' },
    { port_code: 'GBR348', port_ch: '利斯（英国）' },
    { port_code: 'GBR351', port_ch: '勒威克（英国）' },
    { port_code: 'GBR354', port_ch: '利特尔汉普顿（英国）' },
    { port_code: 'GBR357', port_ch: '利物浦（英国）' },
    { port_code: 'GBR360', port_ch: '兰杜拉斯（英国）' },
    { port_code: 'GBR363', port_ch: '拉内利（英国）' },
    { port_code: 'GBR366', port_ch: '洛赫博伊斯代尔（英国）' },
    { port_code: 'GBR369', port_ch: '洛赫马迪（英国）' },
    { port_code: 'GBR372', port_ch: '洛哈林（英国）' },
    { port_code: 'GBR375', port_ch: '伦敦（英国）' },
    { port_code: 'GBR378', port_ch: '伦敦德里（英国）' },
    { port_code: 'GBR381', port_ch: '卢港（英国）' },
    { port_code: 'GBR384', port_ch: '洛西茅斯（英国）' },
    { port_code: 'GBR387', port_ch: '洛斯托夫特（英国）' },
    { port_code: 'GBR390', port_ch: '利布斯特（英国）' },
    { port_code: 'GBR393', port_ch: '利德尼（英国）' },
    { port_code: 'GBR396', port_ch: '麦克达夫（英国）' },
    { port_code: 'GBR399', port_ch: '莫尔登（英国）' },
    { port_code: 'GBR402', port_ch: '马莱格（英国）' },
    { port_code: 'GBR405', port_ch: '曼彻斯特（英国）' },
    { port_code: 'GBR408', port_ch: '梅西尔（英国）' },
    { port_code: 'GBR411', port_ch: '梅瓦吉西（英国）' },
    { port_code: 'GBR414', port_ch: '米德尔斯伯勒（英国）' },
    { port_code: 'GBR417', port_ch: '米勒姆（英国）' },
    { port_code: 'GBR420', port_ch: '迈恩黑德（英国）' },
    { port_code: 'GBR423', port_ch: '米斯特利（英国）' },
    { port_code: 'GBR426', port_ch: '蒙特罗斯（英国）' },
    { port_code: 'GBR429', port_ch: '莫斯廷（英国）' },
    { port_code: 'GBR432', port_ch: '奈恩（英国）' },
    { port_code: 'GBR435', port_ch: '尼思（英国）' },
    { port_code: 'GBR438', port_ch: '纽堡（英国）' },
    { port_code: 'GBR443', port_ch: '米尔福德港（英国）' },
    { port_code: 'GBR444', port_ch: '纽卡斯尔（英国）' },
    { port_code: 'GBR447', port_ch: '纽黑文（英国）' },
    { port_code: 'GBR450', port_ch: '纽林（英国）' },
    { port_code: 'GBR453', port_ch: '纽波特（英国）' },
    { port_code: 'GBR459', port_ch: '纽里（英国）' },
    { port_code: 'GBR462', port_ch: '北森德兰（英国）' },
    { port_code: 'GBR465', port_ch: '诺里奇（英国）' },
    { port_code: 'GBR468', port_ch: '奥本（英国）' },
    { port_code: 'GBR471', port_ch: '帕德斯托（英国）' },
    { port_code: 'GBR474', port_ch: '帕尔纳基（英国）' },
    { port_code: 'GBR477', port_ch: '帕（英国）' },
    { port_code: 'GBR480', port_ch: '帕克斯顿瓜伊（英国）' },
    { port_code: 'GBR483', port_ch: '帕廷顿（英国）' },
    { port_code: 'GBR486', port_ch: '皮尔（英国）' },
    { port_code: 'GBR489', port_ch: '彭布罗克（英国）' },
    { port_code: 'GBR492', port_ch: '彭迈恩毛尔（英国）' },
    { port_code: 'GBR495', port_ch: '彭林（英国）' },
    { port_code: 'GBR498', port_ch: '彭赞斯（英国）' },
    { port_code: 'GBR501', port_ch: '珀斯（英国）' },
    { port_code: 'GBR504', port_ch: '彼得黑德（英国）' },
    { port_code: 'GBR507', port_ch: '普利茅斯（英国）' },
    { port_code: 'GBR510', port_ch: '普尔（英国）' },
    { port_code: 'GBR513', port_ch: '波塔斯凯格（英国）' },
    { port_code: 'GBR516', port_ch: '埃伦港（英国）' },
    { port_code: 'GBR519', port_ch: '圣马里港（英国）' },
    { port_code: 'GBR522', port_ch: '塔尔伯特港（英国）' },
    { port_code: 'GBR525', port_ch: '威廉港（英国）' },
    { port_code: 'GBR528', port_ch: '波尔特布里（英国）' },
    { port_code: 'GBR531', port_ch: '波特马多克（英国）' },
    { port_code: 'GBR534', port_ch: '波蒂斯黑德（英国）' },
    { port_code: 'GBR537', port_ch: '波特兰角（英国）' },
    { port_code: 'GBR540', port_ch: '波特兰（英国）' },
    { port_code: 'GBR543', port_ch: '波特里（英国）' },
    { port_code: 'GBR546', port_ch: '波特拉什（英国）' },
    { port_code: 'GBR549', port_ch: '朴次茅斯（英国）' },
    { port_code: 'GBR552', port_ch: '普雷斯顿（英国）' },
    { port_code: 'GBR555', port_ch: '普尔黑利（英国）' },
    { port_code: 'GBR558', port_ch: '昆伯勒（英国）' },
    { port_code: 'GBR561', port_ch: '昆斯费里（英国）' },
    { port_code: 'GBR564', port_ch: '雷纳姆（英国）' },
    { port_code: 'GBR567', port_ch: '拉姆西（英国）' },
    { port_code: 'GBR570', port_ch: '拉姆斯盖特（英国）' },
    { port_code: 'GBR573', port_ch: '雷德卡（英国）' },
    { port_code: 'GBR576', port_ch: '里尔（英国）' },
    { port_code: 'GBR579', port_ch: '里奇伯勒（英国）' },
    { port_code: 'GBR582', port_ch: '利德哈姆多克（英国）' },
    { port_code: 'GBR585', port_ch: '罗切斯特（英国）' },
    { port_code: 'GBR588', port_ch: '罗赛斯（英国）' },
    { port_code: 'GBR591', port_ch: '罗斯西（英国）' },
    { port_code: 'GBR594', port_ch: '朗科恩（英国）' },
    { port_code: 'GBR597', port_ch: '拉伊（英国）' },
    { port_code: 'GBR600', port_ch: '桑迪（英国）' },
    { port_code: 'GBR603', port_ch: '桑德威奇（英国）' },
    { port_code: 'GBR606', port_ch: '桑德斯富特（英国）' },
    { port_code: 'GBR609', port_ch: '斯卡洛韦（英国）' },
    { port_code: 'GBR612', port_ch: '斯卡帕夫洛（英国）' },
    { port_code: 'GBR615', port_ch: '斯卡伯勒（英国）' },
    { port_code: 'GBR618', port_ch: '斯克拉布斯特（英国）' },
    { port_code: 'GBR621', port_ch: '锡厄姆（英国）' },
    { port_code: 'GBR624', port_ch: '塞尔比（英国）' },
    { port_code: 'GBR627', port_ch: '夏普内斯（英国）' },
    { port_code: 'GBR630', port_ch: '希尔内斯（英国）' },
    { port_code: 'GBR633', port_ch: '谢尔赫文（英国）' },
    { port_code: 'GBR636', port_ch: '肖勒姆（英国）' },
    { port_code: 'GBR639', port_ch: '南安普顿（英国）' },
    { port_code: 'GBR642', port_ch: '绍森德（英国）' },
    { port_code: 'GBR645', port_ch: '圣赫利尔（英国）' },
    { port_code: 'GBR648', port_ch: '圣艾夫斯（英国）' },
    { port_code: 'GBR651', port_ch: '圣马格丽茨贝（英国）' },
    { port_code: 'GBR654', port_ch: '圣彼德港（英国）' },
    { port_code: 'GBR657', port_ch: '斯坦洛（英国）' },
    { port_code: 'GBR660', port_ch: '斯托克顿（英国）' },
    { port_code: 'GBR663', port_ch: '斯通黑文（英国）' },
    { port_code: 'GBR666', port_ch: '斯托诺韦（英国）' },
    { port_code: 'GBR669', port_ch: '斯特兰福德（英国）' },
    { port_code: 'GBR672', port_ch: '斯特兰拉尔（英国）' },
    { port_code: 'GBR675', port_ch: '斯特罗姆内斯（英国）' },
    { port_code: 'GBR678', port_ch: '萨洛姆湾（英国）' },
    { port_code: 'GBR681', port_ch: '森德兰（英国）' },
    { port_code: 'GBR684', port_ch: '萨顿布里奇（英国）' },
    { port_code: 'GBR687', port_ch: '斯旺西（英国）' },
    { port_code: 'GBR690', port_ch: '塔伯特（英国）' },
    { port_code: 'GBR693', port_ch: '提斯港（英国）' },
    { port_code: 'GBR696', port_ch: '廷茅斯（英国）' },
    { port_code: 'GBR699', port_ch: '滕比（英国）' },
    { port_code: 'GBR702', port_ch: '特奈特米纳尔（英国）' },
    { port_code: 'GBR705', port_ch: '瑟索（英国）' },
    { port_code: 'GBR708', port_ch: '蒂尔伯里（英国）' },
    { port_code: 'GBR711', port_ch: '托伯莫里（英国）' },
    { port_code: 'GBR714', port_ch: '托普瑟姆（英国）' },
    { port_code: 'GBR717', port_ch: '托基（英国）' },
    { port_code: 'GBR720', port_ch: '托特尼斯（英国）' },
    { port_code: 'GBR723', port_ch: '特伦（英国）' },
    { port_code: 'GBR726', port_ch: '特鲁罗（英国）' },
    { port_code: 'GBR729', port_ch: '太恩港（英国）' },
    { port_code: 'GBR732', port_ch: '阿勒浦（英国）' },
    { port_code: 'GBR735', port_ch: '沃克沃思（英国）' },
    { port_code: 'GBR738', port_ch: '沃伦波因特（英国）' },
    { port_code: 'GBR741', port_ch: '沃切特（英国）' },
    { port_code: 'GBR744', port_ch: '韦尔斯（英国）' },
    { port_code: 'GBR747', port_ch: '韦斯特雷（英国）' },
    { port_code: 'GBR750', port_ch: '韦茅斯（英国）' },
    { port_code: 'GBR753', port_ch: '惠特比（英国）' },
    { port_code: 'GBR756', port_ch: '怀特黑文（英国）' },
    { port_code: 'GBR759', port_ch: '惠特斯特布尔（英国）' },
    { port_code: 'GBR762', port_ch: '威克（英国）' },
    { port_code: 'GBR765', port_ch: '威斯贝奇（英国）' },
    { port_code: 'GBR768', port_ch: '沃金顿（英国）' },
    { port_code: 'GBR771', port_ch: '雅茅斯（英国）' },
    { port_code: 'GBR901', port_ch: '泰晤士港（英国）' },
    { port_code: 'GBR902', port_ch: '利兹（英国）' },
    { port_code: 'GBR903', port_ch: 'AMNLE（英国）' },
    { port_code: 'GBR904', port_ch: 'BALFAST（英国）' },
    { port_code: 'GBR905', port_ch: 'BATSKARSNAS（英国）' },
    { port_code: 'GBR906', port_ch: 'BRRAY DOCKS（英国）' },
    { port_code: 'GBR907', port_ch: 'EDINBURGH（英国）' },
    { port_code: 'GBR908', port_ch: 'PORTKNOCKIE（英国）' },
    { port_code: 'GBR909', port_ch: 'PURFLEET（英国）' },
    { port_code: 'GBR910', port_ch: '阿尔赫西拉斯（英国）' },
    { port_code: 'GBR911', port_ch: '阿斯凯格皮尔港（英国）' },
    { port_code: 'GBR912', port_ch: '艾泽耳沃思（英国）' },
    { port_code: 'GBR913', port_ch: '安德顿德波（英国）' },
    { port_code: 'GBR914', port_ch: '巴金（英国）' },
    { port_code: 'GBR915', port_ch: '贝尔波特（英国）' },
    { port_code: 'GBR916', port_ch: '波里莱文（英国）' },
    { port_code: 'GBR917', port_ch: '博林（英国）' },
    { port_code: 'GBR919', port_ch: '伯明翰（英国）' },
    { port_code: 'GBR920', port_ch: '布德（英国）' },
    { port_code: 'GBR921', port_ch: '达农（英国）' },
    { port_code: 'GBR922', port_ch: '戴根纳姆（英国）' },
    { port_code: 'GBR923', port_ch: '当斯（英国）' },
    { port_code: 'GBR924', port_ch: '迪甘韦港（英国）' },
    { port_code: 'GBR925', port_ch: '福恩港（英国）' },
    { port_code: 'GBR926', port_ch: '福思港（英国）' },
    { port_code: 'GBR927', port_ch: '怀特霍耳（英国）' },
    { port_code: 'GBR928', port_ch: '喀利多尼亚运河（英国）' },
    { port_code: 'GBR929', port_ch: '卡恩拉夫（英国）' },
    { port_code: 'GBR930', port_ch: '科尔帕奇-喀里多尼亚（英国）' },
    { port_code: 'GBR931', port_ch: '克赖根多兰（英国）' },
    { port_code: 'GBR932', port_ch: '克里南运河（英国）' },
    { port_code: 'GBR933', port_ch: '洛桑（英国）' },
    { port_code: 'GBR934', port_ch: '诺丁汉（英国）' },
    { port_code: 'GBR935', port_ch: '圣墨利厄尔（英国）' },
    { port_code: 'GBR936', port_ch: '太国（英国）' },
    { port_code: 'GBR937', port_ch: '特威德河畔伯里克（英国）' },
    { port_code: 'GBR939', port_ch: '威姆斯贝（英国）' },
    { port_code: 'GBR940', port_ch: '韦斯顿波因特（英国）' },
    { port_code: 'GBR941', port_ch: '维文霍（英国）' },
    { port_code: 'GBR943', port_ch: '锡利群岛（英国）' },
    { port_code: 'GBR945', port_ch: '锡洛思（英国）' },
    { port_code: 'GBR946', port_ch: '伊夫腊库姆（英国）' },
    { port_code: 'GBR947', port_ch: '曼岛（英国）' },
    { port_code: 'GEO000', port_ch: '格鲁吉亚' },
    { port_code: 'GEO003', port_ch: '巴统（格鲁吉亚）' },
    { port_code: 'GEO006', port_ch: '波季（格鲁吉亚）' },
    { port_code: 'GEO009', port_ch: '苏呼米（格鲁吉亚）' },
    { port_code: 'GGY000', port_ch: '根西岛' },
    { port_code: 'GHA000', port_ch: '加纳' },
    { port_code: 'GHA003', port_ch: '阿克拉（加纳）' },
    { port_code: 'GHA006', port_ch: '阿达（加纳）' },
    { port_code: 'GHA009', port_ch: '阿克西姆（加纳）' },
    { port_code: 'GHA012', port_ch: '海岸角（加纳）' },
    { port_code: 'GHA015', port_ch: '凯塔（加纳）' },
    { port_code: 'GHA018', port_ch: '塞康第（加纳）' },
    { port_code: 'GHA021', port_ch: '塔科拉迪（加纳）' },
    { port_code: 'GHA024', port_ch: '特马（加纳）' },
    { port_code: 'GHA027', port_ch: '温尼巴（加纳）' },
    { port_code: 'GIB000', port_ch: '直布罗陀' },
    { port_code: 'GIB003', port_ch: '直布罗陀（直布罗陀）' },
    { port_code: 'GIN000', port_ch: '几内亚' },
    { port_code: 'GIN003', port_ch: '科纳克里（几内亚）' },
    { port_code: 'GIN006', port_ch: '卡姆萨尔（几内亚）' },
    { port_code: 'GIN009', port_ch: '维多利亚（几内亚）' },
    { port_code: 'GIN012', port_ch: '本蒂（几内亚）' },
    { port_code: 'GLP000', port_ch: '瓜德罗普' },
    { port_code: 'GLP003', port_ch: '巴斯特尔（瓜德罗普）' },
    { port_code: 'GLP006', port_ch: '皮特尔角城（瓜德罗普）' },
    { port_code: 'GMB000', port_ch: '冈比亚' },
    { port_code: 'GMB003', port_ch: '班珠尔（冈比亚）' },
    { port_code: 'GNB000', port_ch: '几内亚比绍' },
    { port_code: 'GNB003', port_ch: '比绍（几内亚比绍）' },
    { port_code: 'GNB006', port_ch: '博拉多（几内亚比绍）' },
    { port_code: 'GNB009', port_ch: '布巴克（几内亚比绍）' },
    { port_code: 'GNB012', port_ch: '卡谢马（几内亚比绍）' },
    { port_code: 'GNQ000', port_ch: '赤道几内亚' },
    { port_code: 'GNQ003', port_ch: '巴塔（赤道几内亚）' },
    { port_code: 'GNQ006', port_ch: '布图库卢巴（赤道几内亚）' },
    { port_code: 'GNQ007', port_ch: '圣卡尔洛斯（赤道几内亚）' },
    { port_code: 'GNQ008', port_ch: '里奥白尼托（赤道几内亚）' },
    { port_code: 'GNQ009', port_ch: '马拉博（赤道几内亚）' },
    { port_code: 'GNQ012', port_ch: '圣伊萨贝尔（赤道几内亚）' },
    { port_code: 'GRC000', port_ch: '希腊' },
    { port_code: 'GRC003', port_ch: '圣洛安尼斯（希腊）' },
    { port_code: 'GRC004', port_ch: 'HERMUPOLIS（希腊）' },
    { port_code: 'GRC005', port_ch: 'LIXURI（希腊）' },
    { port_code: 'GRC006', port_ch: '圣尼古拉奥斯（希腊）' },
    { port_code: 'GRC007', port_ch: '扎金索斯（希腊）' },
    { port_code: 'GRC009', port_ch: '圣塞多罗伊（希腊）' },
    { port_code: 'GRC012', port_ch: '亚历山德鲁波利斯（希腊）' },
    { port_code: 'GRC015', port_ch: '阿尔戈斯托利（希腊）' },
    { port_code: 'GRC018', port_ch: '阿斯普罗皮戈斯（希腊）' },
    { port_code: 'GRC019', port_ch: '阿哥斯托利昂（希腊）' },
    { port_code: 'GRC021', port_ch: '阿斯塔科斯（希腊）' },
    { port_code: 'GRC022', port_ch: '阿伊阿特里阿斯（希腊）' },
    { port_code: 'GRC024', port_ch: '干尼亚（希腊）' },
    { port_code: 'GRC027', port_ch: '哈尔基斯（希腊）' },
    { port_code: 'GRC030', port_ch: '希俄斯（希腊）' },
    { port_code: 'GRC033', port_ch: '科孚（希腊）' },
    { port_code: 'GRC036', port_ch: '科林斯（希腊）' },
    { port_code: 'GRC039', port_ch: '德拉佩特佐拉（希腊）' },
    { port_code: 'GRC040', port_ch: '代提（希腊）' },
    { port_code: 'GRC042', port_ch: '埃莱夫西斯（希腊）' },
    { port_code: 'GRC045', port_ch: '加夫里翁（希腊）' },
    { port_code: 'GRC048', port_ch: '伊西翁（希腊）' },
    { port_code: 'GRC051', port_ch: '伊古迈尼察（希腊）' },
    { port_code: 'GRC054', port_ch: '伊拉克利翁（希腊）' },
    { port_code: 'GRC057', port_ch: '伊斯米亚（希腊）' },
    { port_code: 'GRC060', port_ch: '伊泰阿（希腊）' },
    { port_code: 'GRC063', port_ch: '伊萨基（希腊）' },
    { port_code: 'GRC066', port_ch: '卡拉马基角（希腊）' },
    { port_code: 'GRC069', port_ch: '卡拉迈（希腊）' },
    { port_code: 'GRC072', port_ch: '卡利利梅内斯（希腊）' },
    { port_code: 'GRC075', port_ch: '卡利姆诺斯（希腊）' },
    { port_code: 'GRC078', port_ch: '卡梅纳基（希腊）' },
    { port_code: 'GRC081', port_ch: '卡塔科洛（希腊）' },
    { port_code: 'GRC084', port_ch: '卡瓦拉（希腊）' },
    { port_code: 'GRC087', port_ch: '凯阿（希腊）' },
    { port_code: 'GRC090', port_ch: '基亚托（希腊）' },
    { port_code: 'GRC093', port_ch: '科斯岛（希腊）' },
    { port_code: 'GRC096', port_ch: '库塔拉（希腊）' },
    { port_code: 'GRC102', port_ch: '拉夫里翁（希腊）' },
    { port_code: 'GRC105', port_ch: '莱罗斯岛（希腊）' },
    { port_code: 'GRC108', port_ch: '利明西鲁（希腊）' },
    { port_code: 'GRC111', port_ch: '拉克利昂（希腊）' },
    { port_code: 'GRC114', port_ch: '迈加拉（希腊）' },
    { port_code: 'GRC117', port_ch: '迈索隆吉翁（希腊）' },
    { port_code: 'GRC120', port_ch: '迈索尼（希腊）' },
    { port_code: 'GRC123', port_ch: '米洛斯岛（希腊）' },
    { port_code: 'GRC126', port_ch: '米提林尼（希腊）' },
    { port_code: 'GRC129', port_ch: '纳夫普利亚（希腊）' },
    { port_code: 'GRC132', port_ch: '纳夫帕克托斯（希腊）' },
    { port_code: 'GRC135', port_ch: '内亚卡瓦利（希腊）' },
    { port_code: 'GRC136', port_ch: '帕尔加（希腊）' },
    { port_code: 'GRC138', port_ch: '佩特莫斯（希腊）' },
    { port_code: 'GRC141', port_ch: '佩特雷（希腊）' },
    { port_code: 'GRC144', port_ch: '比雷埃夫斯（希腊）' },
    { port_code: 'GRC147', port_ch: '利瓦德希港（希腊）' },
    { port_code: 'GRC150', port_ch: '瓦锡港（希腊）' },
    { port_code: 'GRC153', port_ch: '普雷韦扎（希腊）' },
    { port_code: 'GRC156', port_ch: '皮洛斯（希腊）' },
    { port_code: 'GRC159', port_ch: '雷西姆农（希腊）' },
    { port_code: 'GRC162', port_ch: '罗得（希腊）' },
    { port_code: 'GRC165', port_ch: '萨摩斯岛（希腊）' },
    { port_code: 'GRC168', port_ch: '斯科派洛斯（希腊）' },
    { port_code: 'GRC171', port_ch: '斯特拉托尼（希腊）' },
    { port_code: 'GRC174', port_ch: '苏达湾（希腊）' },
    { port_code: 'GRC176', port_ch: '锡罗斯（希腊）' },
    { port_code: 'GRC177', port_ch: '塞萨洛尼基（希腊）' },
    { port_code: 'GRC179', port_ch: '塞里福斯岛（希腊）' },
    { port_code: 'GRC180', port_ch: '伏洛斯（希腊）' },
    { port_code: 'GRC183', port_ch: '亚利岛（希腊）' },
    { port_code: 'GRC184', port_ch: '雅典（希腊）' },
    { port_code: 'GRC186', port_ch: '耶兰基尼（希腊）' },
    { port_code: 'GRC189', port_ch: '赞特（希腊）' },
    { port_code: 'GRD000', port_ch: '格林纳达' },
    { port_code: 'GRD003', port_ch: '圣乔治（格林纳达）' },
    { port_code: 'GRL000', port_ch: '格陵兰' },
    { port_code: 'GRL003', port_ch: '克里斯蒂安斯霍布（格陵兰）' },
    { port_code: 'GRL006', port_ch: '奥希奥特（格陵兰）' },
    { port_code: 'GRL009', port_ch: '费灵厄港（格陵兰）' },
    { port_code: 'GRL012', port_ch: '腓特烈斯霍布（格陵兰）' },
    { port_code: 'GRL015', port_ch: '戈德港（格陵兰）' },
    { port_code: 'GRL018', port_ch: '努克（格陵兰）' },
    { port_code: 'GRL021', port_ch: '荷尔斯泰因斯堡（格陵兰）' },
    { port_code: 'GRL024', port_ch: '伊维赫图特（格陵兰）' },
    { port_code: 'GRL027', port_ch: '雅各布港（格陵兰）' },
    { port_code: 'GRL030', port_ch: '尤利安娜霍布（格陵兰）' },
    { port_code: 'GRL033', port_ch: '康加米尤特（格陵兰）' },
    { port_code: 'GRL036', port_ch: '马莫里利克（格陵兰）' },
    { port_code: 'GRL039', port_ch: '纳萨尔苏瓦克（格陵兰）' },
    { port_code: 'GRL042', port_ch: '马尼措克（格陵兰）' },
    { port_code: 'GRL045', port_ch: '乌马纳克（格陵兰）' },
    { port_code: 'GRL048', port_ch: '乌佩尼维克（格陵兰）' },
    { port_code: 'GTM000', port_ch: '危地马拉' },
    { port_code: 'GTM003', port_ch: '钱佩里科（危地马拉）' },
    { port_code: 'GTM006', port_ch: '利文斯顿（危地马拉）' },
    { port_code: 'GTM008', port_ch: 'PAYARDI（危地马拉）' },
    { port_code: 'GTM009', port_ch: '巴里奥斯港（危地马拉）' },
    { port_code: 'GTM010', port_ch: '夸特扎尔港（危地马拉）' },
    { port_code: 'GTM012', port_ch: '圣何塞（危地马拉）' },
    { port_code: 'GTM015', port_ch: '圣托马斯德卡斯蒂利亚（危地马拉）' },
    { port_code: 'GUF000', port_ch: '法属圭亚那' },
    { port_code: 'GUF003', port_ch: '卡宴（法属圭亚那）' },
    { port_code: 'GUF005', port_ch: '库鲁（法属圭亚那）' },
    { port_code: 'GUF006', port_ch: '德格拉德卡内斯（法属圭亚那）' },
    { port_code: 'GUM000', port_ch: '关岛' },
    { port_code: 'GUM003', port_ch: '阿加尼亚（关岛）' },
    { port_code: 'GUM006', port_ch: '阿普拉（关岛）' },
    { port_code: 'GUM009', port_ch: '关岛（关岛）' },
    { port_code: 'GUY000', port_ch: '圭亚那' },
    { port_code: 'GUY003', port_ch: '巴提卡（圭亚那）' },
    { port_code: 'GUY006', port_ch: '乔治敦（圭亚那）' },
    { port_code: 'GUY009', port_ch: '新阿姆斯特丹（圭亚那）' },
    { port_code: 'GUY020', port_ch: '查里提（圭亚那）' },
    { port_code: 'HKG000', port_ch: '中国香港' },
    { port_code: 'HKG003', port_ch: '香港（中国香港）' },
    { port_code: 'HMD000', port_ch: '赫德岛和麦克唐纳群岛' },
    { port_code: 'HND000', port_ch: '洪都拉斯' },
    { port_code: 'HND003', port_ch: '阿马帕拉（洪都拉斯）' },
    { port_code: 'HND006', port_ch: '拉塞瓦（洪都拉斯）' },
    { port_code: 'HND009', port_ch: '卡斯蒂利亚港（洪都拉斯）' },
    { port_code: 'HND012', port_ch: '科尔特斯港（洪都拉斯）' },
    { port_code: 'HND015', port_ch: '罗阿坦（洪都拉斯）' },
    { port_code: 'HND018', port_ch: '圣洛伦索（洪都拉斯）' },
    { port_code: 'HND021', port_ch: '特拉（洪都拉斯）' },
    { port_code: 'HND024', port_ch: '特鲁希略（洪都拉斯）' },
    { port_code: 'HRV000', port_ch: '克罗地亚' },
    { port_code: 'HRV003', port_ch: '巴卡尔（克罗地亚）' },
    { port_code: 'HRV006', port_ch: '杜布罗夫尼克（克罗地亚）' },
    { port_code: 'HRV009', port_ch: '杜吉腊特（克罗地亚）' },
    { port_code: 'HRV012', port_ch: '赫瓦尔（克罗地亚）' },
    { port_code: 'HRV015', port_ch: '普洛切（克罗地亚）' },
    { port_code: 'HRV018', port_ch: '科尔丘拉（克罗地亚）' },
    { port_code: 'HRV021', port_ch: '马斯利尼索（克罗地亚）' },
    { port_code: 'HRV024', port_ch: '奥米沙利（克罗地亚）' },
    { port_code: 'HRV027', port_ch: '普拉（克罗地亚）' },
    { port_code: 'HRV030', port_ch: '拉萨（克罗地亚）' },
    { port_code: 'HRV033', port_ch: '里耶卡（克罗地亚）' },
    { port_code: 'HRV036', port_ch: '罗维尼（克罗地亚）' },
    { port_code: 'HRV039', port_ch: '塞尼（克罗地亚）' },
    { port_code: 'HRV042', port_ch: '希贝尼克（克罗地亚）' },
    { port_code: 'HRV045', port_ch: '斯普利特（克罗地亚）' },
    { port_code: 'HRV048', port_ch: '扎达尔（克罗地亚）' },
    { port_code: 'HRV050', port_ch: 'SVETI KAJO（克罗地亚）' },
    { port_code: 'HRV052', port_ch: 'SUCURAC（克罗地亚）' },
    { port_code: 'HRV053', port_ch: '卡托罗（克罗地亚）' },
    { port_code: 'HTI000', port_ch: '海地' },
    { port_code: 'HTI003', port_ch: '莱凯（海地）' },
    { port_code: 'HTI006', port_ch: '海地角（海地）' },
    { port_code: 'HTI009', port_ch: '利贝泰堡（海地）' },
    { port_code: 'HTI012', port_ch: '戈纳伊夫（海地）' },
    { port_code: 'HTI015', port_ch: '热雷米（海地）' },
    { port_code: 'HTI018', port_ch: '米腊关（海地）' },
    { port_code: 'HTI019', port_ch: '欧凯（海地）' },
    { port_code: 'HTI021', port_ch: '太子港（海地）' },
    { port_code: 'HTI024', port_ch: '圣马克（海地）' },
    { port_code: 'HUN000', port_ch: '匈牙利' },
    { port_code: 'HUN003', port_ch: '布达佩斯（匈牙利）' },
    { port_code: 'IDN000', port_ch: '印度尼西亚' },
    { port_code: 'IDN003', port_ch: '安汶（印度尼西亚）' },
    { port_code: 'IDN006', port_ch: '安佩南（印度尼西亚）' },
    { port_code: 'IDN008', port_ch: 'BALAWAN（印度尼西亚）' },
    { port_code: 'IDN009', port_ch: '阿米纳油码头（印度尼西亚）' },
    { port_code: 'IDN010', port_ch: '阿罗湾（印度尼西亚）' },
    { port_code: 'IDN011', port_ch: '阿萨汗（印度尼西亚）' },
    { port_code: 'IDN012', port_ch: '巴眼牙比（印度尼西亚）' },
    { port_code: 'IDN015', port_ch: '巴厘巴板（印度尼西亚）' },
    { port_code: 'IDN018', port_ch: '马辰（印度尼西亚）' },
    { port_code: 'IDN019', port_ch: '洛塞马韦（印度尼西亚）' },
    { port_code: 'IDN021', port_ch: '巴纽旺宣（印度尼西亚）' },
    { port_code: 'IDN024', port_ch: '勿拉湾（印度尼西亚）' },
    { port_code: 'IDN027', port_ch: '望加丽（印度尼西亚）' },
    { port_code: 'IDN029', port_ch: '佩纳巴（印度尼西亚）' },
    { port_code: 'IDN030', port_ch: '朋古鲁（印度尼西亚）' },
    { port_code: 'IDN033', port_ch: '伯诺阿（印度尼西亚）' },
    { port_code: 'IDN036', port_ch: '比马（印度尼西亚）' },
    { port_code: 'IDN039', port_ch: '比通（印度尼西亚）' },
    { port_code: 'IDN042', port_ch: '勿里洋（印度尼西亚）' },
    { port_code: 'IDN045', port_ch: '布莱伦（印度尼西亚）' },
    { port_code: 'IDN048', port_ch: '芝格丁（印度尼西亚）' },
    { port_code: 'IDN051', port_ch: '芝拉扎（印度尼西亚）' },
    { port_code: 'IDN054', port_ch: '信塔油码头（印度尼西亚）' },
    { port_code: 'IDN057', port_ch: '井里汶（印度尼西亚）' },
    { port_code: 'IDN060', port_ch: '达博（印度尼西亚）' },
    { port_code: 'IDN063', port_ch: '栋加拉（印度尼西亚）' },
    { port_code: 'IDN066', port_ch: '杜迈（印度尼西亚）' },
    { port_code: 'IDN069', port_ch: '法克法克（印度尼西亚）' },
    { port_code: 'IDN072', port_ch: '哥伦打洛（印度尼西亚）' },
    { port_code: 'IDN075', port_ch: '格雷西（锦石）（印度尼西亚）' },
    { port_code: 'IDN078', port_ch: '古农西托利（印度尼西亚）' },
    { port_code: 'IDN081', port_ch: '雅加达（印度尼西亚）' },
    { port_code: 'IDN084', port_ch: '占碑（印度尼西亚）' },
    { port_code: 'IDN087', port_ch: '查亚普拉（印度尼西亚）' },
    { port_code: 'IDN090', port_ch: '卡利昂厄特（印度尼西亚）' },
    { port_code: 'IDN093', port_ch: '卡西姆（印度尼西亚）' },
    { port_code: 'IDN096', port_ch: '肯达里（印度尼西亚）' },
    { port_code: 'IDN098', port_ch: '贺兰狄亚（印度尼西亚）' },
    { port_code: 'IDN099', port_ch: '吉打邦（印度尼西亚）' },
    { port_code: 'IDN100', port_ch: '贾贾普拉（印度尼西亚）' },
    { port_code: 'IDN102', port_ch: '哥打巴鲁（印度尼西亚）' },
    { port_code: 'IDN105', port_ch: '格鲁（印度尼西亚）' },
    { port_code: 'IDN108', port_ch: '瓜拉卡普阿斯（印度尼西亚）' },
    { port_code: 'IDN111', port_ch: '古邦（印度尼西亚）' },
    { port_code: 'IDN114', port_ch: '马卡萨（印度尼西亚）' },
    { port_code: 'IDN115', port_ch: '马德拉斯（印度尼西亚）' },
    { port_code: 'IDN117', port_ch: '马利利（印度尼西亚）' },
    { port_code: 'IDN120', port_ch: '马穆朱（印度尼西亚）' },
    { port_code: 'IDN123', port_ch: '马诺夸里（印度尼西亚）' },
    { port_code: 'IDN124', port_ch: '满各里（印度尼西亚）' },
    { port_code: 'IDN125', port_ch: '毛梅雷（印度尼西亚）' },
    { port_code: 'IDN126', port_ch: '棉兰（印度尼西亚）' },
    { port_code: 'IDN127', port_ch: '蒙法尔科内（印度尼西亚）' },
    { port_code: 'IDN128', port_ch: '万隆（印度尼西亚）' },
    { port_code: 'IDN129', port_ch: '万鸦老（印度尼西亚）' },
    { port_code: 'IDN132', port_ch: '默拉克（孔雀岛）（印度尼西亚）' },
    { port_code: 'IDN135', port_ch: '马老奇（印度尼西亚）' },
    { port_code: 'IDN136', port_ch: '马都拉岛（印度尼西亚）' },
    { port_code: 'IDN137', port_ch: '马杰尼（印度尼西亚）' },
    { port_code: 'IDN138', port_ch: '米拉务（印度尼西亚）' },
    { port_code: 'IDN141', port_ch: '蒙托克（印度尼西亚）' },
    { port_code: 'IDN144', port_ch: '巴东（印度尼西亚）' },
    { port_code: 'IDN147', port_ch: '北千巴鲁（印度尼西亚）' },
    { port_code: 'IDN150', port_ch: '巨港（印度尼西亚）' },
    { port_code: 'IDN152', port_ch: '帕干巴鲁（印度尼西亚）' },
    { port_code: 'IDN153', port_ch: '帕洛波（印度尼西亚）' },
    { port_code: 'IDN156', port_ch: '帕马努坎（印度尼西亚）' },
    { port_code: 'IDN159', port_ch: '巴那鲁干（印度尼西亚）' },
    { port_code: 'IDN162', port_ch: '庞卡尔（印度尼西亚）' },
    { port_code: 'IDN165', port_ch: '槟港（印度尼西亚）' },
    { port_code: 'IDN168', port_ch: '庞卡兰苏苏（印度尼西亚）' },
    { port_code: 'IDN170', port_ch: '潘吉姆（印度尼西亚）' },
    { port_code: 'IDN171', port_ch: '潘姜（印度尼西亚）' },
    { port_code: 'IDN174', port_ch: '巴里巴里（印度尼西亚）' },
    { port_code: 'IDN177', port_ch: '巴苏鲁安（印度尼西亚）' },
    { port_code: 'IDN180', port_ch: '北加浪岸（印度尼西亚）' },
    { port_code: 'IDN183', port_ch: '班马吉（印度尼西亚）' },
    { port_code: 'IDN186', port_ch: '波马拉（印度尼西亚）' },
    { port_code: 'IDN188', port_ch: '库迈（印度尼西亚）' },
    { port_code: 'IDN189', port_ch: '坤甸（印度尼西亚）' },
    { port_code: 'IDN192', port_ch: '波索（印度尼西亚）' },
    { port_code: 'IDN195', port_ch: '普罗博林戈（印度尼西亚）' },
    { port_code: 'IDN198', port_ch: '普劳桑布（印度尼西亚）' },
    { port_code: 'IDN201', port_ch: '沙璜（印度尼西亚）' },
    { port_code: 'IDN203', port_ch: '桑坦港（印度尼西亚）' },
    { port_code: 'IDN204', port_ch: '沙拉瓦蒂（印度尼西亚）' },
    { port_code: 'IDN207', port_ch: '三马林达（印度尼西亚）' },
    { port_code: 'IDN210', port_ch: '三发（印度尼西亚）' },
    { port_code: 'IDN213', port_ch: '桑皮特（印度尼西亚）' },
    { port_code: 'IDN216', port_ch: '桑库利朗（印度尼西亚）' },
    { port_code: 'IDN219', port_ch: '塞拉潘姜（印度尼西亚）' },
    { port_code: 'IDN222', port_ch: '三宝垄（印度尼西亚）' },
    { port_code: 'IDN223', port_ch: '苏拉威西（印度尼西亚）' },
    { port_code: 'IDN224', port_ch: '泗水（印度尼西亚）' },
    { port_code: 'IDN225', port_ch: '塞尼帕油码头（印度尼西亚）' },
    { port_code: 'IDN227', port_ch: '山口羊（印度尼西亚）' },
    { port_code: 'IDN228', port_ch: '实武牙（印度尼西亚）' },
    { port_code: 'IDN229', port_ch: '苏门达腊（印度尼西亚）' },
    { port_code: 'IDN230', port_ch: '苏苏（印度尼西亚）' },
    { port_code: 'IDN231', port_ch: '索龙（印度尼西亚）' },
    { port_code: 'IDN234', port_ch: '双溪格龙（印度尼西亚）' },
    { port_code: 'IDN237', port_ch: '双溪克拉克（印度尼西亚）' },
    { port_code: 'IDN240', port_ch: '巴宁河（印度尼西亚）' },
    { port_code: 'IDN246', port_ch: '丹戎潘丹（印度尼西亚）' },
    { port_code: 'IDN249', port_ch: '丹戎槟榔（印度尼西亚）' },
    { port_code: 'IDN252', port_ch: '丹戎不碌（印度尼西亚）' },
    { port_code: 'IDN255', port_ch: '丹戎勒德布（印度尼西亚）' },
    { port_code: 'IDN258', port_ch: '丹戎索法（印度尼西亚）' },
    { port_code: 'IDN261', port_ch: '丹戎乌班（印度尼西亚）' },
    { port_code: 'IDN264', port_ch: '打拉根（印度尼西亚）' },
    { port_code: 'IDN266', port_ch: '直落巴由（印度尼西亚）' },
    { port_code: 'IDN267', port_ch: '直葛（印度尼西亚）' },
    { port_code: 'IDN270', port_ch: '直落勿洞（印度尼西亚）' },
    { port_code: 'IDN273', port_ch: '淡美拉汉（印度尼西亚）' },
    { port_code: 'IDN276', port_ch: '德那第（印度尼西亚）' },
    { port_code: 'IDN278', port_ch: '乌戎潘当（印度尼西亚）' },
    { port_code: 'IDN279', port_ch: '都保里（印度尼西亚）' },
    { port_code: 'IDN282', port_ch: '托利托利（印度尼西亚）' },
    { port_code: 'IDN283', port_ch: '塔帕土安（印度尼西亚）' },
    { port_code: 'IDN284', port_ch: '特卢巴尤尔（印度尼西亚）' },
    { port_code: 'IDN285', port_ch: '图班（印度尼西亚）' },
    { port_code: 'IDN300', port_ch: '米瓦纳（印度尼西亚）' },
    { port_code: 'IDN302', port_ch: '文古尔拉（印度尼西亚）' },
    { port_code: 'IDN303', port_ch: '西姆拉（印度尼西亚）' },
    { port_code: 'IDN304', port_ch: '锡卡（印度尼西亚）' },
    { port_code: 'IDN305', port_ch: '雅加达海港（印度尼西亚）' },
    { port_code: 'IDN306', port_ch: '爪畦岛（印度尼西亚）' },
    { port_code: 'IDN900', port_ch: '奥莱勒厄（印度尼西亚）' },
    { port_code: 'IDN901', port_ch: '巴淡（印度尼西亚）' },
    { port_code: 'IDN902', port_ch: '乌戎潘生（印度尼西亚）' },
    { port_code: 'IMN000', port_ch: '马恩岛' },
    { port_code: 'IND000', port_ch: '印度' },
    { port_code: 'IND003', port_ch: '阿勒皮（印度）' },
    { port_code: 'IND006', port_ch: '贝迪（印度）' },
    { port_code: 'IND009', port_ch: '贝莱克里（印度）' },
    { port_code: 'IND012', port_ch: '包纳加尔（印度）' },
    { port_code: 'IND015', port_ch: '比穆尼帕特南（印度）' },
    { port_code: 'IND018', port_ch: '孟买（印度）' },
    { port_code: 'IND021', port_ch: '加尔格答（印度）' },
    { port_code: 'IND024', port_ch: '卡利卡特（印度）' },
    { port_code: 'IND027', port_ch: '格灵格伯德讷姆（印度）' },
    { port_code: 'IND030', port_ch: '坎纳诺尔（印度）' },
    { port_code: 'IND033', port_ch: '科钦（印度）' },
    { port_code: 'IND036', port_ch: '科拉歇尔（印度）' },
    { port_code: 'IND039', port_ch: '贡达布尔（印度）' },
    { port_code: 'IND042', port_ch: '库达洛尔（印度）' },
    { port_code: 'IND045', port_ch: '达曼（印度）' },
    { port_code: 'IND048', port_ch: '第乌（印度）' },
    { port_code: 'IND051', port_ch: '杜瓦尔卡（印度）' },
    { port_code: 'IND054', port_ch: '戈巴尔布尔（印度）' },
    { port_code: 'IND057', port_ch: '霍尔迪亚（印度）' },
    { port_code: 'IND060', port_ch: '霍纳沃尔（印度）' },
    { port_code: 'IND063', port_ch: '加法拉巴德（印度）' },
    { port_code: 'IND066', port_ch: '杰考（印度）' },
    { port_code: 'IND069', port_ch: '卡基纳达（印度）' },
    { port_code: 'IND072', port_ch: '根德拉（印度）' },
    { port_code: 'IND075', port_ch: '加里加尔（印度）' },
    { port_code: 'IND078', port_ch: '加尔瓦尔（印度）' },
    { port_code: 'IND081', port_ch: '默吉利伯德讷姆（印度）' },
    { port_code: 'IND084', port_ch: '金奈（印度）' },
    { port_code: 'IND087', port_ch: '马埃（印度）' },
    { port_code: 'IND088', port_ch: '马苏利帕特南（印度）' },
    { port_code: 'IND090', port_ch: '马尔佩（印度）' },
    { port_code: 'IND093', port_ch: '曼达帕姆（印度）' },
    { port_code: 'IND096', port_ch: '曼德维（印度）' },
    { port_code: 'IND099', port_ch: '芒格洛尔（印度）' },
    { port_code: 'IND102', port_ch: '曼格罗尔（印度）' },
    { port_code: 'IND105', port_ch: '米尼科伊岛（印度）' },
    { port_code: 'IND108', port_ch: '莫尔穆冈（印度）' },
    { port_code: 'IND111', port_ch: '蒙德拉（印度）' },
    { port_code: 'IND114', port_ch: '纳加伯蒂讷姆（印度）' },
    { port_code: 'IND117', port_ch: '瑙勒基（印度）' },
    { port_code: 'IND120', port_ch: '新芒格洛尔（印度）' },
    { port_code: 'IND122', port_ch: '哈瓦舍瓦（尼赫鲁）（印度）' },
    { port_code: 'IND123', port_ch: '新土提科林（印度）' },
    { port_code: 'IND126', port_ch: '班本（印度）' },
    { port_code: 'IND129', port_ch: '潘吉姆（印度）' },
    { port_code: 'IND132', port_ch: '巴拉迪布（印度）' },
    { port_code: 'IND135', port_ch: '本地治里（印度）' },
    { port_code: 'IND138', port_ch: '博尔本德尔（印度）' },
    { port_code: 'IND141', port_ch: '布莱尔港（印度）' },
    { port_code: 'IND144', port_ch: '奥卡港（印度）' },
    { port_code: 'IND147', port_ch: '波多诺伏港（印度）' },
    { port_code: 'IND150', port_ch: '普里（印度）' },
    { port_code: 'IND153', port_ch: '奎隆（印度）' },
    { port_code: 'IND156', port_ch: '勒德纳吉里（印度）' },
    { port_code: 'IND159', port_ch: '雷迪（印度）' },
    { port_code: 'IND162', port_ch: '瑟拉亚（印度）' },
    { port_code: 'IND163', port_ch: '色纳加尔（印度）' },
    { port_code: 'IND165', port_ch: '锡卡（印度）' },
    { port_code: 'IND166', port_ch: '新德里（印度）' },
    { port_code: 'IND168', port_ch: '苏拉特（印度）' },
    { port_code: 'IND169', port_ch: '塔德里（印度）' },
    { port_code: 'IND171', port_ch: '代利杰里（印度）' },
    { port_code: 'IND174', port_ch: '特里凡得琅（印度）' },
    { port_code: 'IND177', port_ch: '杜蒂戈林（印度）' },
    { port_code: 'IND180', port_ch: '文古尔拉（印度）' },
    { port_code: 'IND183', port_ch: '韦拉沃尔（印度）' },
    { port_code: 'IND186', port_ch: '维沙卡帕特南（印度）' },
    { port_code: 'IND901', port_ch: '德里（印度）' },
    { port_code: 'IND904', port_ch: '加尔各答（印度）' },
    { port_code: 'IND907', port_ch: '班加罗尔（印度）' },
    { port_code: 'IOT000', port_ch: '英属印度洋领土' },
    { port_code: 'IRL000', port_ch: '爱尔兰' },
    { port_code: 'IRL003', port_ch: '阿克洛（爱尔兰）' },
    { port_code: 'IRL006', port_ch: '巴尔布里根（爱尔兰）' },
    { port_code: 'IRL009', port_ch: '巴利纳（爱尔兰）' },
    { port_code: 'IRL012', port_ch: '巴尔的摩（爱尔兰）' },
    { port_code: 'IRL015', port_ch: '班特里（爱尔兰）' },
    { port_code: 'IRL018', port_ch: '伯顿波特（爱尔兰）' },
    { port_code: 'IRL021', port_ch: '克尔西文（爱尔兰）' },
    { port_code: 'IRL024', port_ch: '卡斯尔顿贝尔（爱尔兰）' },
    { port_code: 'IRL027', port_ch: '克莱尔卡斯尔（爱尔兰）' },
    { port_code: 'IRL030', port_ch: '克洛纳基尔蒂（爱尔兰）' },
    { port_code: 'IRL033', port_ch: '科夫（爱尔兰）' },
    { port_code: 'IRL036', port_ch: '科克（爱尔兰）' },
    { port_code: 'IRL039', port_ch: '多尼戈尔（爱尔兰）' },
    { port_code: 'IRL042', port_ch: '德罗赫达（爱尔兰）' },
    { port_code: 'IRL045', port_ch: '都柏林（爱尔兰）' },
    { port_code: 'IRL048', port_ch: '邓莱里（爱尔兰）' },
    { port_code: 'IRL051', port_ch: '邓坎嫩（爱尔兰）' },
    { port_code: 'IRL054', port_ch: '邓多克（爱尔兰）' },
    { port_code: 'IRL057', port_ch: '邓加文（爱尔兰）' },
    { port_code: 'IRL060', port_ch: '邓莫尔（爱尔兰）' },
    { port_code: 'IRL063', port_ch: '费尼特（爱尔兰）' },
    { port_code: 'IRL066', port_ch: '福因斯（爱尔兰）' },
    { port_code: 'IRL069', port_ch: '戈尔韦（爱尔兰）' },
    { port_code: 'IRL072', port_ch: '格里诺尔（爱尔兰）' },
    { port_code: 'IRL075', port_ch: '霍思（爱尔兰）' },
    { port_code: 'IRL078', port_ch: '基拉拉（爱尔兰）' },
    { port_code: 'IRL081', port_ch: '基利贝格斯（爱尔兰）' },
    { port_code: 'IRL084', port_ch: '基尔罗南（爱尔兰）' },
    { port_code: 'IRL087', port_ch: '基尔拉什（爱尔兰）' },
    { port_code: 'IRL090', port_ch: '金塞尔（爱尔兰）' },
    { port_code: 'IRL093', port_ch: '利默里克（爱尔兰）' },
    { port_code: 'IRL096', port_ch: '莫维尔（爱尔兰）' },
    { port_code: 'IRL099', port_ch: '新罗斯（爱尔兰）' },
    { port_code: 'IRL102', port_ch: '拉斯马伦（爱尔兰）' },
    { port_code: 'IRL105', port_ch: '罗斯莱尔（爱尔兰）' },
    { port_code: 'IRL108', port_ch: '斯卡尔（爱尔兰）' },
    { port_code: 'IRL111', port_ch: '斯莱戈（爱尔兰）' },
    { port_code: 'IRL114', port_ch: '特拉利（爱尔兰）' },
    { port_code: 'IRL117', port_ch: '瓦伦西亚（爱尔兰）' },
    { port_code: 'IRL120', port_ch: '沃特福德（爱尔兰）' },
    { port_code: 'IRL123', port_ch: '韦克斯福德（爱尔兰）' },
    { port_code: 'IRL126', port_ch: '威克洛（爱尔兰）' },
    { port_code: 'IRL129', port_ch: '约尔（爱尔兰）' },
    { port_code: 'IRL130', port_ch: '基尔马西蒙港（爱尔兰）' },
    { port_code: 'IRL131', port_ch: '克里弗登（爱尔兰）' },
    { port_code: 'IRL132', port_ch: '马尔罗伊（爱尔兰）' },
    { port_code: 'IRL133', port_ch: '韦斯特波特（爱尔兰）' },
    { port_code: 'IRN000', port_ch: '伊朗' },
    { port_code: 'IRN003', port_ch: '阿巴丹（伊朗）' },
    { port_code: 'IRN006', port_ch: '阿巴斯港（伊朗）' },
    { port_code: 'IRN009', port_ch: '霍梅尼港（伊朗）' },
    { port_code: 'IRN012', port_ch: '马赫沙赫尔港（伊朗）' },
    { port_code: 'IRN015', port_ch: '布什尔（伊朗）' },
    { port_code: 'IRN018', port_ch: '居鲁士码头（伊朗）' },
    { port_code: 'IRN021', port_ch: '贾斯克（伊朗）' },
    { port_code: 'IRN023', port_ch: '恰赫巴哈尔（伊朗）' },
    { port_code: 'IRN024', port_ch: '哈尔克岛（伊朗）' },
    { port_code: 'IRN027', port_ch: '胡宁沙赫尔（伊朗）' },
    { port_code: 'IRN030', port_ch: '拉万岛（伊朗）' },
    { port_code: 'IRN033', port_ch: '林格（伊朗）' },
    { port_code: 'IRN036', port_ch: '巴里根角（伊朗）' },
    { port_code: 'IRN040', port_ch: '大不里士（伊朗）' },
    { port_code: 'IRN042', port_ch: '帕勒维（伊朗）' },
    { port_code: 'IRN043', port_ch: '沙赫普尔港（伊朗）' },
    { port_code: 'IRN901', port_ch: '德黑兰（伊朗）' },
    { port_code: 'IRQ000', port_ch: '伊拉克' },
    { port_code: 'IRQ003', port_ch: '巴士拉（伊拉克）' },
    { port_code: 'IRQ006', port_ch: '法奥（伊拉克）' },
    { port_code: 'IRQ009', port_ch: '豪尔艾迈耶（伊拉克）' },
    { port_code: 'IRQ012', port_ch: '阿巴克（伊拉克）' },
    { port_code: 'IRQ015', port_ch: '乌姆盖斯尔（伊拉克）' },
    { port_code: 'IRQ016', port_ch: 'ZUBAIR（伊拉克）' },
    { port_code: 'IRQ018', port_ch: '霍尔阿米亚（伊拉克）' },
    { port_code: 'IRQ019', port_ch: '基尔库克（伊拉克）' },
    { port_code: 'IRQ020', port_ch: '摩苏尔（伊拉克）' },
    { port_code: 'IRQ901', port_ch: '巴格达（伊拉克）' },
    { port_code: 'ISL000', port_ch: '冰岛' },
    { port_code: 'ISL003', port_ch: '阿克拉内斯（冰岛）' },
    { port_code: 'ISL006', port_ch: '阿克雷里（冰岛）' },
    { port_code: 'ISL009', port_ch: '哈布纳菲厄泽（冰岛）' },
    { port_code: 'ISL012', port_ch: '胡萨维克（冰岛）' },
    { port_code: 'ISL015', port_ch: '伊萨菲厄泽（冰岛）' },
    { port_code: 'ISL018', port_ch: '凯夫拉维克（冰岛）' },
    { port_code: 'ISL021', port_ch: '内斯克伊斯塔泽（冰岛）' },
    { port_code: 'ISL024', port_ch: '帕特雷克峡湾（冰岛）' },
    { port_code: 'ISL027', port_ch: '雷克雅末克（冰岛）' },
    { port_code: 'ISL030', port_ch: '塞济斯菲厄泽（冰岛）' },
    { port_code: 'ISL033', port_ch: '锡格吕菲厄泽（冰岛）' },
    { port_code: 'ISL036', port_ch: '斯卡加斯特伦（冰岛）' },
    { port_code: 'ISL039', port_ch: '斯特勒伊姆维克（冰岛）' },
    { port_code: 'ISL042', port_ch: '韦斯特曼纳岛（冰岛）' },
    { port_code: 'ISR000', port_ch: '以色列' },
    { port_code: 'ISR003', port_ch: '阿卡（以色列）' },
    { port_code: 'ISR006', port_ch: '阿什杜德（以色列）' },
    { port_code: 'ISR009', port_ch: '阿什克伦（以色列）' },
    { port_code: 'ISR012', port_ch: '埃拉特（以色列）' },
    { port_code: 'ISR015', port_ch: '哈代拉（以色列）' },
    { port_code: 'ISR018', port_ch: '海法（以色列）' },
    { port_code: 'ISR024', port_ch: '特拉维夫-雅法（以色列）' },
    { port_code: 'ITA000', port_ch: '意大利' },
    { port_code: 'ITA003', port_ch: '阿尔盖罗（意大利）' },
    { port_code: 'ITA006', port_ch: '安科纳（意大利）' },
    { port_code: 'ITA009', port_ch: '安齐奥（意大利）' },
    { port_code: 'ITA012', port_ch: '阿尔巴塔克斯（意大利）' },
    { port_code: 'ITA015', port_ch: '奥古斯塔（意大利）' },
    { port_code: 'ITA018', port_ch: '阿沃拉（意大利）' },
    { port_code: 'ITA021', port_ch: '巴尼奥利（意大利）' },
    { port_code: 'ITA024', port_ch: '巴里（意大利）' },
    { port_code: 'ITA027', port_ch: '巴列塔（意大利）' },
    { port_code: 'ITA030', port_ch: '布林迪西（意大利）' },
    { port_code: 'ITA033', port_ch: '卡利亚里（意大利）' },
    { port_code: 'ITA036', port_ch: '卡洛福泰（意大利）' },
    { port_code: 'ITA039', port_ch: '斯塔比亚海堡（意大利）' },
    { port_code: 'ITA042', port_ch: '卡塔尼亚（意大利）' },
    { port_code: 'ITA045', port_ch: '卡坦扎罗（意大利）' },
    { port_code: 'ITA048', port_ch: '基奥贾（意大利）' },
    { port_code: 'ITA051', port_ch: '奇维塔韦基亚（意大利）' },
    { port_code: 'ITA054', port_ch: '克罗托内（意大利）' },
    { port_code: 'ITA056', port_ch: '法尔科纳拉（意大利）' },
    { port_code: 'ITA057', port_ch: '菲乌米奇诺（意大利）' },
    { port_code: 'ITA060', port_ch: '福洛尼卡（意大利）' },
    { port_code: 'ITA063', port_ch: '福尔米亚（意大利）' },
    { port_code: 'ITA066', port_ch: '加埃塔（意大利）' },
    { port_code: 'ITA069', port_ch: '加利波利（意大利）' },
    { port_code: 'ITA072', port_ch: '杰拉（意大利）' },
    { port_code: 'ITA075', port_ch: '热那亚（意大利）' },
    { port_code: 'ITA078', port_ch: '因佩里亚（意大利）' },
    { port_code: 'ITA081', port_ch: '拉马达莱那（意大利）' },
    { port_code: 'ITA084', port_ch: '里窝那（意大利）' },
    { port_code: 'ITA087', port_ch: '利卡塔（意大利）' },
    { port_code: 'ITA090', port_ch: '曼夫雷多尼亚（意大利）' },
    { port_code: 'ITA093', port_ch: '马里纳迪卡拉拉（意大利）' },
    { port_code: 'ITA096', port_ch: '马尔萨拉（意大利）' },
    { port_code: 'ITA099', port_ch: '马扎拉德尔瓦洛（意大利）' },
    { port_code: 'ITA102', port_ch: '梅利利（意大利）' },
    { port_code: 'ITA105', port_ch: '墨西拿（意大利）' },
    { port_code: 'ITA108', port_ch: '米拉佐（意大利）' },
    { port_code: 'ITA111', port_ch: '莫尔费塔（意大利）' },
    { port_code: 'ITA114', port_ch: '蒙法尔科内（意大利）' },
    { port_code: 'ITA117', port_ch: '莫诺波利（意大利）' },
    { port_code: 'ITA120', port_ch: '那波利（意大利）' },
    { port_code: 'ITA123', port_ch: '奥尔比亚（意大利）' },
    { port_code: 'ITA126', port_ch: '奥里斯塔诺（意大利）' },
    { port_code: 'ITA129', port_ch: '奥托纳（意大利）' },
    { port_code: 'ITA132', port_ch: '巴勒莫（意大利）' },
    { port_code: 'ITA135', port_ch: '佩萨罗（意大利）' },
    { port_code: 'ITA138', port_ch: '佩斯卡拉（意大利）' },
    { port_code: 'ITA141', port_ch: '皮翁比诺（意大利）' },
    { port_code: 'ITA144', port_ch: '波蒂奇（意大利）' },
    { port_code: 'ITA147', port_ch: '波蒂格里欧内（意大利）' },
    { port_code: 'ITA150', port_ch: '阿祖罗港（意大利）' },
    { port_code: 'ITA153', port_ch: '恩佩多克莱港（意大利）' },
    { port_code: 'ITA156', port_ch: '马尔盖腊港（意大利）' },
    { port_code: 'ITA159', port_ch: '圣托斯特凡诺港（意大利）' },
    { port_code: 'ITA162', port_ch: '托雷斯港（意大利）' },
    { port_code: 'ITA165', port_ch: '韦斯梅港（意大利）' },
    { port_code: 'ITA168', port_ch: '费拉约港（意大利）' },
    { port_code: 'ITA171', port_ch: '斯库索港（意大利）' },
    { port_code: 'ITA174', port_ch: '波佐利（意大利）' },
    { port_code: 'ITA177', port_ch: '普里奥洛（意大利）' },
    { port_code: 'ITA180', port_ch: '腊万纳（意大利）' },
    { port_code: 'ITA183', port_ch: '雷焦（意大利）' },
    { port_code: 'ITA186', port_ch: '里奥马里纳（意大利）' },
    { port_code: 'ITA189', port_ch: '萨莱诺（意大利）' },
    { port_code: 'ITA192', port_ch: '圣雷莫（意大利）' },
    { port_code: 'ITA195', port_ch: '萨罗克（福克西港）（意大利）' },
    { port_code: 'ITA198', port_ch: '萨沃纳（意大利）' },
    { port_code: 'ITA201', port_ch: '锡拉库萨（意大利）' },
    { port_code: 'ITA204', port_ch: '斯佩齐亚（意大利）' },
    { port_code: 'ITA207', port_ch: '塔拉莫内（意大利）' },
    { port_code: 'ITA210', port_ch: '塔兰托（意大利）' },
    { port_code: 'ITA213', port_ch: '托雷德尔格雷科（意大利）' },
    { port_code: 'ITA216', port_ch: '托雷安农齐亚塔（意大利）' },
    { port_code: 'ITA219', port_ch: '特拉帕尼（意大利）' },
    { port_code: 'ITA222', port_ch: '的里雅斯特（意大利）' },
    { port_code: 'ITA225', port_ch: '瓦斯托（意大利）' },
    { port_code: 'ITA228', port_ch: '威尼斯（意大利）' },
    { port_code: 'ITA231', port_ch: '维亚雷焦（意大利）' },
    { port_code: 'ITA242', port_ch: '奥克里卡（意大利）' },
    { port_code: 'ITA243', port_ch: '博洛尼亚（意大利）' },
    { port_code: 'ITA244', port_ch: '利窝那（意大利）' },
    { port_code: 'ITA245', port_ch: '那不勒斯（意大利）' },
    { port_code: 'ITA247', port_ch: '普腊托（意大利）' },
    { port_code: 'ITA248', port_ch: '撒丁岛（意大利）' },
    { port_code: 'ITA249', port_ch: '桑达基斯达（意大利）' },
    { port_code: 'ITA252', port_ch: '西西里（意大利）' },
    { port_code: 'ITA253', port_ch: '锡腊丘斯（意大利）' },
    { port_code: 'ITA901', port_ch: '罗马（意大利）' },
    { port_code: 'ITA902', port_ch: '米兰（意大利）' },
    { port_code: 'JAM000', port_ch: '牙买加' },
    { port_code: 'JAM003', port_ch: '阿利盖德庞德（牙买加）' },
    { port_code: 'JAM006', port_ch: '布莱克河（牙买加）' },
    { port_code: 'JAM009', port_ch: '布卢菲尔兹（牙买加）' },
    { port_code: 'JAM012', port_ch: '法尔茅斯（牙买加）' },
    { port_code: 'JAM015', port_ch: '金斯敦（牙买加）' },
    { port_code: 'JAM018', port_ch: '卢西（牙买加）' },
    { port_code: 'JAM021', port_ch: '蒙特哥湾（牙买加）' },
    { port_code: 'JAM024', port_ch: '奥乔里奥斯湾（牙买加）' },
    { port_code: 'JAM027', port_ch: '安东尼奥港（牙买加）' },
    { port_code: 'JAM030', port_ch: '埃斯基韦尔港（牙买加）' },
    { port_code: 'JAM033', port_ch: '凯泽港（牙买加）' },
    { port_code: 'JAM036', port_ch: '莫兰特港（牙买加）' },
    { port_code: 'JAM039', port_ch: '罗德港（牙买加）' },
    { port_code: 'JAM042', port_ch: '罗亚尔港（牙买加）' },
    { port_code: 'JAM045', port_ch: '里奥布埃诺（牙买加）' },
    { port_code: 'JAM048', port_ch: '罗基波因特（牙买加）' },
    { port_code: 'JAM051', port_ch: '萨尔特里弗（牙买加）' },
    { port_code: 'JAM054', port_ch: '滨海萨凡纳（牙买加）' },
    { port_code: 'JEY000', port_ch: '泽西岛' },
    { port_code: 'JOR000', port_ch: '约旦' },
    { port_code: 'JOR003', port_ch: '亚喀巴（约旦）' },
    { port_code: 'JOR004', port_ch: '纳布鲁斯（约旦）' },
    { port_code: 'JOR005', port_ch: '伊尔比德（约旦）' },
    { port_code: 'JPN000', port_ch: '日本' },
    { port_code: 'JPN003', port_ch: '网走（日本）' },
    { port_code: 'JPN006', port_ch: '网干（日本）' },
    { port_code: 'JPN009', port_ch: '相浦（日本）' },
    { port_code: 'JPN012', port_ch: '相生（日本）' },
    { port_code: 'JPN015', port_ch: '秋田（日本）' },
    { port_code: 'JPN018', port_ch: '赤穗湾（日本）' },
    { port_code: 'JPN021', port_ch: '尼崎（日本）' },
    { port_code: 'JPN024', port_ch: '阿南（日本）' },
    { port_code: 'JPN027', port_ch: '青森（日本）' },
    { port_code: 'JPN030', port_ch: '渥美（日本）' },
    { port_code: 'JPN033', port_ch: '别府（日本）' },
    { port_code: 'JPN036', port_ch: '千叶（日本）' },
    { port_code: 'JPN039', port_ch: '知多（日本）' },
    { port_code: 'JPN042', port_ch: '江名（日本）' },
    { port_code: 'JPN045', port_ch: '江田岛（日本）' },
    { port_code: 'JPN048', port_ch: '福冈（日本）' },
    { port_code: 'JPN051', port_ch: '福山（日本）' },
    { port_code: 'JPN054', port_ch: '船桥（日本）' },
    { port_code: 'JPN057', port_ch: '船川（日本）' },
    { port_code: 'JPN060', port_ch: '伏木（日本）' },
    { port_code: 'JPN063', port_ch: '蒲郡（日本）' },
    { port_code: 'JPN066', port_ch: '八户（日本）' },
    { port_code: 'JPN069', port_ch: '荻（日本）' },
    { port_code: 'JPN072', port_ch: '博多（日本）' },
    { port_code: 'JPN075', port_ch: '函馆（日本）' },
    { port_code: 'JPN078', port_ch: '滨田（日本）' },
    { port_code: 'JPN081', port_ch: '滨松（日本）' },
    { port_code: 'JPN084', port_ch: '半田（日本）' },
    { port_code: 'JPN087', port_ch: '阪南（日本）' },
    { port_code: 'JPN090', port_ch: '日明（日本）' },
    { port_code: 'JPN093', port_ch: '响滩湾（日本）' },
    { port_code: 'JPN096', port_ch: '光市（日本）' },
    { port_code: 'JPN099', port_ch: '姬路（日本）' },
    { port_code: 'JPN102', port_ch: '平生（日本）' },
    { port_code: 'JPN105', port_ch: '广田（日本）' },
    { port_code: 'JPN108', port_ch: '广岛（日本）' },
    { port_code: 'JPN111', port_ch: '久之滨（日本）' },
    { port_code: 'JPN114', port_ch: '日立（日本）' },
    { port_code: 'JPN117', port_ch: '细岛（日本）' },
    { port_code: 'JPN120', port_ch: '辑保（日本）' },
    { port_code: 'JPN123', port_ch: '今治（日本）' },
    { port_code: 'JPN126', port_ch: '伊万里（日本）' },
    { port_code: 'JPN129', port_ch: '因岛（日本）' },
    { port_code: 'JPN132', port_ch: '伊良湖（日本）' },
    { port_code: 'JPN135', port_ch: '石垣（日本）' },
    { port_code: 'JPN138', port_ch: '石卷（日本）' },
    { port_code: 'JPN141', port_ch: '系崎（日本）' },
    { port_code: 'JPN144', port_ch: '岩国（日本）' },
    { port_code: 'JPN147', port_ch: '伊予三岛（日本）' },
    { port_code: 'JPN150', port_ch: '严原（日本）' },
    { port_code: 'JPN153', port_ch: '泉佐野（日本）' },
    { port_code: 'JPN156', port_ch: '鹿儿岛（日本）' },
    { port_code: 'JPN159', port_ch: '海南（日本）' },
    { port_code: 'JPN162', port_ch: '加古川（日本）' },
    { port_code: 'JPN165', port_ch: '釜石（日本）' },
    { port_code: 'JPN168', port_ch: '金泽（日本）' },
    { port_code: 'JPN171', port_ch: '刈田（日本）' },
    { port_code: 'JPN174', port_ch: '关门（日本）' },
    { port_code: 'JPN177', port_ch: '鹿川（日本）' },
    { port_code: 'JPN180', port_ch: '唐津（日本）' },
    { port_code: 'JPN183', port_ch: '笠冈（日本）' },
    { port_code: 'JPN186', port_ch: '鹿岛（日本）' },
    { port_code: 'JPN189', port_ch: '川之江（日本）' },
    { port_code: 'JPN192', port_ch: '川崎（日本）' },
    { port_code: 'JPN195', port_ch: '喜入（日本）' },
    { port_code: 'JPN198', port_ch: '菊间（日本）' },
    { port_code: 'JPN201', port_ch: '金湾（日本）' },
    { port_code: 'JPN204', port_ch: '衣浦（日本）' },
    { port_code: 'JPN207', port_ch: '木更津（日本）' },
    { port_code: 'JPN210', port_ch: '北九州（日本）' },
    { port_code: 'JPN213', port_ch: '神户（日本）' },
    { port_code: 'JPN216', port_ch: '高知（日本）' },
    { port_code: 'JPN219', port_ch: '小仓（日本）' },
    { port_code: 'JPN222', port_ch: '小松岛（日本）' },
    { port_code: 'JPN225', port_ch: '神岛（日本）' },
    { port_code: 'JPN228', port_ch: '下松（日本）' },
    { port_code: 'JPN231', port_ch: '吴（日本）' },
    { port_code: 'JPN234', port_ch: '黑崎（日本）' },
    { port_code: 'JPN237', port_ch: '钏路（日本）' },
    { port_code: 'JPN240', port_ch: '舞鹤（日本）' },
    { port_code: 'JPN243', port_ch: '牧山（日本）' },
    { port_code: 'JPN246', port_ch: '丸龟（日本）' },
    { port_code: 'JPN249', port_ch: '马刀泻（日本）' },
    { port_code: 'JPN252', port_ch: '松永（日本）' },
    { port_code: 'JPN255', port_ch: '松山（日本）' },
    { port_code: 'JPN258', port_ch: '松坂（日本）' },
    { port_code: 'JPN261', port_ch: '妻鹿（日本）' },
    { port_code: 'JPN264', port_ch: '三原（日本）' },
    { port_code: 'JPN267', port_ch: '三池（日本）' },
    { port_code: 'JPN270', port_ch: '美川（日本）' },
    { port_code: 'JPN273', port_ch: '水俣（日本）' },
    { port_code: 'JPN276', port_ch: '三岛（日本）' },
    { port_code: 'JPN279', port_ch: '三角（日本）' },
    { port_code: 'JPN282', port_ch: '三子岛（日本）' },
    { port_code: 'JPN285', port_ch: '宫古（日本）' },
    { port_code: 'JPN288', port_ch: '宫崎（日本）' },
    { port_code: 'JPN291', port_ch: '宫津（日本）' },
    { port_code: 'JPN294', port_ch: '水岛（日本）' },
    { port_code: 'JPN297', port_ch: '门司（日本）' },
    { port_code: 'JPN300', port_ch: '门别（日本）' },
    { port_code: 'JPN303', port_ch: '向岛（日本）' },
    { port_code: 'JPN306', port_ch: '室兰（日本）' },
    { port_code: 'JPN309', port_ch: '六连（日本）' },
    { port_code: 'JPN312', port_ch: '长崎（日本）' },
    { port_code: 'JPN315', port_ch: '长浦（日本）' },
    { port_code: 'JPN318', port_ch: '名古屋（日本）' },
    { port_code: 'JPN321', port_ch: '那霸（日本）' },
    { port_code: 'JPN322', port_ch: '新泻（日本）' },
    { port_code: 'JPN324', port_ch: '中城（日本）' },
    { port_code: 'JPN327', port_ch: '七尾（日本）' },
    { port_code: 'JPN330', port_ch: '直江津（日本）' },
    { port_code: 'JPN333', port_ch: '直岛（日本）' },
    { port_code: 'JPN336', port_ch: '根岸（日本）' },
    { port_code: 'JPN339', port_ch: '根室（日本）' },
    { port_code: 'JPN345', port_ch: '新舄东（日本）' },
    { port_code: 'JPN348', port_ch: '新居滨（日本）' },
    { port_code: 'JPN351', port_ch: '西宫（日本）' },
    { port_code: 'JPN354', port_ch: '能代（日本）' },
    { port_code: 'JPN357', port_ch: '大船渡（日本）' },
    { port_code: 'JPN360', port_ch: '扇岛（日本）' },
    { port_code: 'JPN363', port_ch: '大分（日本）' },
    { port_code: 'JPN366', port_ch: '冈山（日本）' },
    { port_code: 'JPN369', port_ch: '御前崎（日本）' },
    { port_code: 'JPN372', port_ch: '大凑（日本）' },
    { port_code: 'JPN375', port_ch: '大三岛（日本）' },
    { port_code: 'JPN378', port_ch: '小名滨（日本）' },
    { port_code: 'JPN381', port_ch: '尾道（日本）' },
    { port_code: 'JPN384', port_ch: '大阪（日本）' },
    { port_code: 'JPN387', port_ch: '小樽（日本）' },
    { port_code: 'JPN390', port_ch: '尾鹫（日本）' },
    { port_code: 'JPN393', port_ch: '留萌（日本）' },
    { port_code: 'JPN396', port_ch: '佐贺关（日本）' },
    { port_code: 'JPN399', port_ch: '佐伯（日本）' },
    { port_code: 'JPN402', port_ch: '界（日本）' },
    { port_code: 'JPN405', port_ch: '坂出（日本）' },
    { port_code: 'JPN408', port_ch: '境港（日本）' },
    { port_code: 'JPN411', port_ch: '界泉北（日本）' },
    { port_code: 'JPN414', port_ch: '酒田（日本）' },
    { port_code: 'JPN417', port_ch: '崎户（日本）' },
    { port_code: 'JPN420', port_ch: '佐世保（日本）' },
    { port_code: 'JPN423', port_ch: '仙台（日本）' },
    { port_code: 'JPN426', port_ch: '芝浦（日本）' },
    { port_code: 'JPN429', port_ch: '饰磨（日本）' },
    { port_code: 'JPN432', port_ch: '清水（日本）' },
    { port_code: 'JPN435', port_ch: '下田（日本）' },
    { port_code: 'JPN438', port_ch: '下关（日本）' },
    { port_code: 'JPN441', port_ch: '下津（日本）' },
    { port_code: 'JPN444', port_ch: '师崎（日本）' },
    { port_code: 'JPN447', port_ch: '盐斧（日本）' },
    { port_code: 'JPN450', port_ch: '新凑（日本）' },
    { port_code: 'JPN453', port_ch: '须崎（日本）' },
    { port_code: 'JPN456', port_ch: '桔（日本）' },
    { port_code: 'JPN459', port_ch: '多度津（日本）' },
    { port_code: 'JPN462', port_ch: '田子浦（日本）' },
    { port_code: 'JPN465', port_ch: '高松（日本）' },
    { port_code: 'JPN471', port_ch: '诧间（日本）' },
    { port_code: 'JPN474', port_ch: '玉岛（日本）' },
    { port_code: 'JPN477', port_ch: '玉野（日本）' },
    { port_code: 'JPN480', port_ch: '田边（日本）' },
    { port_code: 'JPN483', port_ch: '馆山（日本）' },
    { port_code: 'JPN486', port_ch: '谷山（日本）' },
    { port_code: 'JPN489', port_ch: '户田（日本）' },
    { port_code: 'JPN492', port_ch: '十胜（日本）' },
    { port_code: 'JPN495', port_ch: '东海（日本）' },
    { port_code: 'JPN498', port_ch: '德山（日本）' },
    { port_code: 'JPN501', port_ch: '东京（日本）' },
    { port_code: 'JPN504', port_ch: '苫小牧（日本）' },
    { port_code: 'JPN507', port_ch: '富田（日本）' },
    { port_code: 'JPN510', port_ch: '鸟取（日本）' },
    { port_code: 'JPN513', port_ch: '富山（日本）' },
    { port_code: 'JPN516', port_ch: '富山新港（日本）' },
    { port_code: 'JPN519', port_ch: '丰桥（日本）' },
    { port_code: 'JPN522', port_ch: '津（日本）' },
    { port_code: 'JPN525', port_ch: '津居山（日本）' },
    { port_code: 'JPN528', port_ch: '津久见（日本）' },
    { port_code: 'JPN531', port_ch: '敦贺（日本）' },
    { port_code: 'JPN534', port_ch: '鹤见（日本）' },
    { port_code: 'JPN537', port_ch: '鹤崎（日本）' },
    { port_code: 'JPN540', port_ch: '宇部（日本）' },
    { port_code: 'JPN543', port_ch: '内浦（日本）' },
    { port_code: 'JPN546', port_ch: '宇野（日本）' },
    { port_code: 'JPN549', port_ch: '若松（日本）' },
    { port_code: 'JPN552', port_ch: '和歌山（日本）' },
    { port_code: 'JPN555', port_ch: '稚内（日本）' },
    { port_code: 'JPN558', port_ch: '八代（日本）' },
    { port_code: 'JPN561', port_ch: '八幡（日本）' },
    { port_code: 'JPN564', port_ch: '八恬滨（日本）' },
    { port_code: 'JPN567', port_ch: '四日市（日本）' },
    { port_code: 'JPN570', port_ch: '横滨（日本）' },
    { port_code: 'JPN573', port_ch: '横须贺（日本）' },
    { port_code: 'JPN576', port_ch: '寄岛（日本）' },
    { port_code: 'JPN579', port_ch: '四仓（日本）' },
    { port_code: 'JPN582', port_ch: '由良（日本）' },
    { port_code: 'JPN590', port_ch: 'AJIGAWA（日本）' },
    { port_code: 'JPN591', port_ch: 'AKITSU（日本）' },
    { port_code: 'JPN592', port_ch: 'DOKAI（日本）' },
    { port_code: 'JPN593', port_ch: 'KEIHIN PORT（日本）' },
    { port_code: 'JPN595', port_ch: '东播磨(IHO)（日本）' },
    { port_code: 'JPN596', port_ch: '浮岛（日本）' },
    { port_code: 'JPN597', port_ch: '君津（日本）' },
    { port_code: 'JPN598', port_ch: '鹿儿岛新港（日本）' },
    { port_code: 'JPN600', port_ch: '三岛 川三江（日本）' },
    { port_code: 'JPN602', port_ch: '苏萨（日本）' },
    { port_code: 'JPN605', port_ch: '宇野和玉野（日本）' },
    { port_code: 'JPN606', port_ch: '枕崎（日本）' },
    { port_code: 'JPN901', port_ch: '札幌（日本）' },
    { port_code: 'JPN902', port_ch: '冲绳（日本）' },
    { port_code: 'KAZ000', port_ch: '哈萨克斯坦' },
    { port_code: 'KAZ901', port_ch: '十月市（哈萨克斯坦）' },
    { port_code: 'KAZ902', port_ch: '尤日内（哈萨克斯坦）' },
    { port_code: 'KAZ903', port_ch: '迈哈布奇盖（哈萨克斯坦）' },
    { port_code: 'KAZ904', port_ch: '阿连谢夫卡（哈萨克斯坦）' },
    { port_code: 'KAZ905', port_ch: '巴克特（哈萨克斯坦）' },
    { port_code: 'KAZ906', port_ch: '德鲁日巴（哈萨克斯坦）' },
    { port_code: 'KAZ907', port_ch: '霍尔果斯（哈萨克斯坦）' },
    { port_code: 'KAZ908', port_ch: '科里扎特（哈萨克斯坦）' },
    { port_code: 'KAZ909', port_ch: '纳林果勒（哈萨克斯坦）' },
    { port_code: 'KEN000', port_ch: '肯尼亚' },
    { port_code: 'KEN003', port_ch: '拉穆（肯尼亚）' },
    { port_code: 'KEN006', port_ch: '马林迪（肯尼亚）' },
    { port_code: 'KEN009', port_ch: '蒙巴萨（肯尼亚）' },
    { port_code: 'KEN012', port_ch: '万加（肯尼亚）' },
    { port_code: 'KEN901', port_ch: '内罗毕（肯尼亚）' },
    { port_code: 'KGZ000', port_ch: '吉尔吉斯斯坦' },
    { port_code: 'KGZ901', port_ch: '图鲁噶尔（吉尔吉斯斯坦）' },
    { port_code: 'KGZ902', port_ch: '比什凯克（吉尔吉斯斯坦）' },
    { port_code: 'KGZ903', port_ch: '伊尔克什坦（吉尔吉斯斯坦）' },
    { port_code: 'KGZ904', port_ch: '纳伦（吉尔吉斯斯坦）' },
    { port_code: 'KGZ905', port_ch: '奥什（吉尔吉斯斯坦）' },
    { port_code: 'KHM000', port_ch: '柬埔寨' },
    { port_code: 'KHM003', port_ch: '磅逊（柬埔寨）' },
    { port_code: 'KHM006', port_ch: '金边（柬埔寨）' },
    { port_code: 'KIR000', port_ch: '基里巴斯' },
    { port_code: 'KIR003', port_ch: '巴纳巴岛（基里巴斯）' },
    { port_code: 'KIR006', port_ch: '圣诞岛（基里巴斯）' },
    { port_code: 'KIR009', port_ch: '范宁岛（基里巴斯）' },
    { port_code: 'KIR012', port_ch: '塔拉瓦（基里巴斯）' },
    { port_code: 'KIR020', port_ch: 'ARANUKA I.（基里巴斯）' },
    { port_code: 'KIR021', port_ch: 'BAIRIKI（基里巴斯）' },
    { port_code: 'KIR022', port_ch: 'BUKINTERIKE（基里巴斯）' },
    { port_code: 'KIR023', port_ch: '阿拜昂岛（基里巴斯）' },
    { port_code: 'KIR024', port_ch: '奥罗纳岛（基里巴斯）' },
    { port_code: 'KIR025', port_ch: '奥诺托阿岛（基里巴斯）' },
    { port_code: 'KIR026', port_ch: '赫尔岛（基里巴斯）' },
    { port_code: 'KIR027', port_ch: '华盛顿岛（基里巴斯）' },
    { port_code: 'KIR030', port_ch: '坎顿岛（基里巴斯）' },
    { port_code: 'KIR031', port_ch: '库里亚岛（基里巴斯）' },
    { port_code: 'KIR032', port_ch: '马拉凯伊岛（基里巴斯）' },
    { port_code: 'KIR033', port_ch: '马亚纳岛（基里巴斯）' },
    { port_code: 'KIR034', port_ch: '麦基恩岛（基里巴斯）' },
    { port_code: 'KIR035', port_ch: '曼拉岛（基里巴斯）' },
    { port_code: 'KIR036', port_ch: '莫尔登（基里巴斯）' },
    { port_code: 'KIR037', port_ch: '尼库马罗罗岛（基里巴斯）' },
    { port_code: 'KIR038', port_ch: '尼库瑙岛（基里巴斯）' },
    { port_code: 'KIR039', port_ch: '诺诺乌蒂岛（基里巴斯）' },
    { port_code: 'KIR040', port_ch: '斯塔巴克岛（基里巴斯）' },
    { port_code: 'KIR041', port_ch: '塔邦泰拜克（基里巴斯）' },
    { port_code: 'KIR042', port_ch: '塔比泰韦阿岛（基里巴斯）' },
    { port_code: 'KIR043', port_ch: '塔布阿埃兰岛（基里巴斯）' },
    { port_code: 'KIR050', port_ch: '塔马纳岛（基里巴斯）' },
    { port_code: 'KIR051', port_ch: '塔皮瓦（基里巴斯）' },
    { port_code: 'KIR052', port_ch: '乌马（基里巴斯）' },
    { port_code: 'KNA000', port_ch: '圣基茨和尼维斯' },
    { port_code: 'KNA003', port_ch: '巴斯特尔（圣基茨和尼维斯）' },
    { port_code: 'KNA006', port_ch: '查尔斯敦（圣基茨和尼维斯）' },
    { port_code: 'KOR000', port_ch: '韩国' },
    { port_code: 'KOR003', port_ch: '釜山（韩国）' },
    { port_code: 'KOR004', port_ch: '光阳（韩国）' },
    { port_code: 'KOR006', port_ch: '长项（韩国）' },
    { port_code: 'KOR009', port_ch: '济州（韩国）' },
    { port_code: 'KOR012', port_ch: '镇海（韩国）' },
    { port_code: 'KOR015', port_ch: '台普（韩国）' },
    { port_code: 'KOR018', port_ch: '仁川（韩国）' },
    { port_code: 'KOR021', port_ch: '群山（韩国）' },
    { port_code: 'KOR024', port_ch: '马山（韩国）' },
    { port_code: 'KOR027', port_ch: '木浦（韩国）' },
    { port_code: 'KOR030', port_ch: '墨湖（韩国）' },
    { port_code: 'KOR033', port_ch: '浦项（韩国）' },
    { port_code: 'KOR034', port_ch: '平泽（韩国）' },
    { port_code: 'KOR036', port_ch: '三陟（韩国）' },
    { port_code: 'KOR039', port_ch: '蔚山（韩国）' },
    { port_code: 'KOR042', port_ch: '丽水（韩国）' },
    { port_code: 'KOR901', port_ch: '首尔（韩国）' },
    { port_code: 'KWT000', port_ch: '科威特' },
    { port_code: 'KWT003', port_ch: '霍尔姆法塔（科威特）' },
    { port_code: 'KWT006', port_ch: '科威特（科威特）' },
    { port_code: 'KWT009', port_ch: '艾哈迈迪港（科威特）' },
    { port_code: 'KWT012', port_ch: '米纳阿卜杜拉（科威特）' },
    { port_code: 'KWT015', port_ch: '米纳索特（科威特）' },
    { port_code: 'KWT018', port_ch: '舒艾拜（科威特）' },
    { port_code: 'KWT021', port_ch: '舒韦赫（科威特）' },
    { port_code: 'KWT022', port_ch: '米内艾哈迈迪（科威特）' },
    { port_code: 'LAO000', port_ch: '老挝' },
    { port_code: 'LAO901', port_ch: '万象（老挝）' },
    { port_code: 'LBN000', port_ch: '黎巴嫩' },
    { port_code: 'LBN003', port_ch: '贝鲁特（黎巴嫩）' },
    { port_code: 'LBN006', port_ch: '舍卡（黎巴嫩）' },
    { port_code: 'LBN009', port_ch: '朱尼耶（黎巴嫩）' },
    { port_code: 'LBN012', port_ch: '腊斯塞拉塔（黎巴嫩）' },
    { port_code: 'LBN015', port_ch: '赛达（黎巴嫩）' },
    { port_code: 'LBN018', port_ch: '苏尔（黎巴嫩）' },
    { port_code: 'LBN021', port_ch: '的黎波里（黎巴嫩）' },
    { port_code: 'LBN024', port_ch: '宰赫拉尼（黎巴嫩）' },
    { port_code: 'LBN030', port_ch: '西顿（黎巴嫩）' },
    { port_code: 'LBR000', port_ch: '利比里亚' },
    { port_code: 'LBR003', port_ch: '布坎南（利比里亚）' },
    { port_code: 'LBR006', port_ch: '帕尔马斯角（利比里亚）' },
    { port_code: 'LBR009', port_ch: '大巴萨（利比里亚）' },
    { port_code: 'LBR012', port_ch: '格林维尔（利比里亚）' },
    { port_code: 'LBR015', port_ch: '马歇尔（利比里亚）' },
    { port_code: 'LBR018', port_ch: '蒙罗维亚（利比里亚）' },
    { port_code: 'LBR021', port_ch: '里弗塞斯（利比里亚）' },
    { port_code: 'LBR030', port_ch: 'HARPER C.（利比里亚）' },
    { port_code: 'LBR031', port_ch: '下布坎南（利比里亚）' },
    { port_code: 'LBY000', port_ch: '利比亚' },
    { port_code: 'LBY003', port_ch: '阿济伟亚（利比亚）' },
    { port_code: 'LBY006', port_ch: '巴迪亚（利比亚）' },
    { port_code: 'LBY009', port_ch: '班加西（利比亚）' },
    { port_code: 'LBY012', port_ch: '德尔纳（利比亚）' },
    { port_code: 'LBY015', port_ch: '锡德尔（利比亚）' },
    { port_code: 'LBY017', port_ch: '卜雷加港（利比亚）' },
    { port_code: 'LBY018', port_ch: '哈里盖港（利比亚）' },
    { port_code: 'LBY021', port_ch: '米苏拉塔区（利比亚）' },
    { port_code: 'LBY024', port_ch: '拉斯拉努夫（利比亚）' },
    { port_code: 'LBY027', port_ch: '图卜鲁格（利比亚）' },
    { port_code: 'LBY030', port_ch: '的黎波里（利比亚）' },
    { port_code: 'LBY033', port_ch: '兹利坦（利比亚）' },
    { port_code: 'LBY036', port_ch: '兹瓦拉（利比亚）' },
    { port_code: 'LBY039', port_ch: '祖埃提纳（利比亚）' },
    { port_code: 'LCA000', port_ch: '圣卢西亚' },
    { port_code: 'LCA003', port_ch: '卡斯特里（圣卢西亚）' },
    { port_code: 'LCA006', port_ch: '苏弗里耶尔（圣卢西亚）' },
    { port_code: 'LCA009', port_ch: '维约堡（圣卢西亚）' },
    { port_code: 'LIE000', port_ch: '列支敦士登' },
    { port_code: 'LKA000', port_ch: '斯里兰卡' },
    { port_code: 'LKA003', port_ch: '拜蒂克洛（斯里兰卡）' },
    { port_code: 'LKA006', port_ch: '科伦坡（斯里兰卡）' },
    { port_code: 'LKA009', port_ch: '加勒（斯里兰卡）' },
    { port_code: 'LKA012', port_ch: '贾夫纳（斯里兰卡）' },
    { port_code: 'LKA015', port_ch: '卡卢特勒（斯里兰卡）' },
    { port_code: 'LKA018', port_ch: '坎凯桑图赖（斯里兰卡）' },
    { port_code: 'LKA021', port_ch: '凯茨（斯里兰卡）' },
    { port_code: 'LKA024', port_ch: '马特勒（斯里兰卡）' },
    { port_code: 'LKA027', port_ch: '尼甘布（斯里兰卡）' },
    { port_code: 'LKA028', port_ch: '马纳尔（斯里兰卡）' },
    { port_code: 'LKA029', port_ch: '塔莱曼纳尔（斯里兰卡）' },
    { port_code: 'LKA030', port_ch: '亭可马里（斯里兰卡）' },
    { port_code: 'LSO000', port_ch: '莱索托' },
    { port_code: 'LTU000', port_ch: '立陶宛' },
    { port_code: 'LTU002', port_ch: '克莱佩达（立陶宛）' },
    { port_code: 'LUX000', port_ch: '卢森堡' },
    { port_code: 'LUX001', port_ch: '卢森堡（卢森堡）' },
    { port_code: 'LVA000', port_ch: '拉脱维亚' },
    { port_code: 'LVA003', port_ch: '里加（拉脱维亚）' },
    { port_code: 'LVA006', port_ch: '利耶帕亚（拉脱维亚）' },
    { port_code: 'LVA009', port_ch: '文茨皮尔斯（拉脱维亚）' },
    { port_code: 'MAC000', port_ch: '中国澳门' },
    { port_code: 'MAC003', port_ch: '澳门（中国澳门）' },
    { port_code: 'MAF000', port_ch: '圣马丁(法国)' },
    { port_code: 'MAF003', port_ch: '菲利普斯堡（圣马丁(法国)）' },
    { port_code: 'Mar-00', port_ch: '摩洛哥' },
    { port_code: '3-Mar', port_ch: '阿加迪尔（摩洛哥）' },
    { port_code: '6-Mar', port_ch: '卡萨布兰卡（摩洛哥）' },
    { port_code: '9-Mar', port_ch: '贾迪达（摩洛哥）' },
    { port_code: '12-Mar', port_ch: '索维拉（摩洛哥）' },
    { port_code: '15-Mar', port_ch: '朱尔夫莱斯费尔（摩洛哥）' },
    { port_code: '18-Mar', port_ch: '盖尼特拉（摩洛哥）' },
    { port_code: '21-Mar', port_ch: '拉腊什（摩洛哥）' },
    { port_code: '24-Mar', port_ch: '穆罕默迪耶（摩洛哥）' },
    { port_code: '27-Mar', port_ch: '纳祖尔（摩洛哥）' },
    { port_code: '30-Mar', port_ch: '拉巴特（摩洛哥）' },
    { port_code: 'Mar-33', port_ch: '萨菲（摩洛哥）' },
    { port_code: 'Mar-36', port_ch: '丹吉尔（摩洛哥）' },
    { port_code: 'Mar-39', port_ch: '塔尔法亚（摩洛哥）' },
    { port_code: 'Mar-42', port_ch: '得土安（摩洛哥）' },
    { port_code: 'Mar-51', port_ch: 'RIO MARTIN（摩洛哥）' },
    { port_code: 'Mar-54', port_ch: '克尼特拉（摩洛哥）' },
    { port_code: 'Mar-55', port_ch: '马尔提勒（摩洛哥）' },
    { port_code: 'Mar-56', port_ch: 'Tetuan（摩洛哥）' },
    { port_code: 'Mar-57', port_ch: '伊萨奥伊拉（摩洛哥）' },
    { port_code: 'MCO000', port_ch: '摩纳哥' },
    { port_code: 'MCO002', port_ch: '摩纳哥（摩纳哥）' },
    { port_code: 'MCO003', port_ch: '蒙特卡洛（摩纳哥）' },
    { port_code: 'MDA000', port_ch: '摩尔多瓦' },
    { port_code: 'MDG000', port_ch: '马达加斯加' },
    { port_code: 'MDG003', port_ch: '阿纳拉拉瓦（马达加斯加）' },
    { port_code: 'MDG006', port_ch: '安塔拉哈（马达加斯加）' },
    { port_code: 'MDG009', port_ch: '安齐拉纳纳（马达加斯加）' },
    { port_code: 'MDG012', port_ch: '法拉凡加纳（马达加斯加）' },
    { port_code: 'MDG015', port_ch: '多凡堡（马达加斯加）' },
    { port_code: 'MDG018', port_ch: '马任加（马达加斯加）' },
    { port_code: 'MDG021', port_ch: '马纳卡拉（马达加斯加）' },
    { port_code: 'MDG024', port_ch: '马南扎里河（马达加斯加）' },
    { port_code: 'MDG027', port_ch: '马鲁安采特拉（马达加斯加）' },
    { port_code: 'MDG030', port_ch: '穆龙贝（马达加斯加）' },
    { port_code: 'MDG033', port_ch: '穆龙达瓦（马达加斯加）' },
    { port_code: 'MDG036', port_ch: '贝岛（马达加斯加）' },
    { port_code: 'MDG039', port_ch: '桑巴瓦（马达加斯加）' },
    { port_code: 'MDG042', port_ch: '图阿马西纳（马达加斯加）' },
    { port_code: 'MDG045', port_ch: '托拉纳罗（马达加斯加）' },
    { port_code: 'MDG048', port_ch: '图莱亚尔（马达加斯加）' },
    { port_code: 'MDG050', port_ch: '努西贝（马达加斯加）' },
    { port_code: 'MDG051', port_ch: '塔那那利佛（马达加斯加）' },
    { port_code: 'MDV000', port_ch: '马尔代夫' },
    { port_code: 'MDV003', port_ch: '阿杜环礁（马尔代夫）' },
    { port_code: 'MDV006', port_ch: '马累岛（马尔代夫）' },
    { port_code: 'MEL000', port_ch: '梅利利亚' },
    { port_code: 'MEL003', port_ch: '梅利利亚（梅利利亚）' },
    { port_code: 'MEX000', port_ch: '墨西哥' },
    { port_code: 'MEX003', port_ch: '阿卡普尔科（墨西哥）' },
    { port_code: 'MEX006', port_ch: '阿尔瓦拉多（墨西哥）' },
    { port_code: 'MEX009', port_ch: '坎佩切（墨西哥）' },
    { port_code: 'MEX012', port_ch: '阿卡斯群岛码头（墨西哥）' },
    { port_code: 'MEX015', port_ch: '卡门城（墨西哥）' },
    { port_code: 'MEX018', port_ch: '夸察夸尔科斯（墨西哥）' },
    { port_code: 'MEX021', port_ch: '科苏梅尔岛（墨西哥）' },
    { port_code: 'MEX024', port_ch: '多斯博卡斯（墨西哥）' },
    { port_code: 'MEX027', port_ch: '恩塞纳达（墨西哥）' },
    { port_code: 'MEX030', port_ch: '弗龙特拉（墨西哥）' },
    { port_code: 'MEX033', port_ch: '瓜伊马斯（墨西哥）' },
    { port_code: 'MEX036', port_ch: '拉巴斯（墨西哥）' },
    { port_code: 'MEX039', port_ch: '拉萨罗卡德纳斯（墨西哥）' },
    { port_code: 'MEX042', port_ch: '曼萨尼略（墨西哥）' },
    { port_code: 'MEX045', port_ch: '马萨特兰（墨西哥）' },
    { port_code: 'MEX048', port_ch: '米纳蒂特兰（墨西哥）' },
    { port_code: 'MEX051', port_ch: '莫罗雷东杜（墨西哥）' },
    { port_code: 'MEX054', port_ch: '南吉塔（墨西哥）' },
    { port_code: 'MEX057', port_ch: '瑙特拉（墨西哥）' },
    { port_code: 'MEX060', port_ch: '普罗格雷索（墨西哥）' },
    { port_code: 'MEX063', port_ch: '马德罗港（墨西哥）' },
    { port_code: 'MEX066', port_ch: '罗萨里托码头（墨西哥）' },
    { port_code: 'MEX069', port_ch: '萨利纳克鲁斯（墨西哥）' },
    { port_code: 'MEX072', port_ch: '圣罗萨利亚（墨西哥）' },
    { port_code: 'MEX075', port_ch: '坦皮科（墨西哥）' },
    { port_code: 'MEX078', port_ch: '托波洛班波（墨西哥）' },
    { port_code: 'MEX081', port_ch: '图斯潘（墨西哥）' },
    { port_code: 'MEX084', port_ch: '韦拉克鲁斯（墨西哥）' },
    { port_code: 'MEX091', port_ch: '瓦哈卡（墨西哥）' },
    { port_code: 'MEX092', port_ch: '锡纳洛阿（墨西哥）' },
    { port_code: 'MEX901', port_ch: '墨西长利（墨西哥）' },
    { port_code: 'MEX904', port_ch: '墨西哥城（墨西哥）' },
    { port_code: 'MHL000', port_ch: '马绍尔群岛' },
    { port_code: 'MHL003', port_ch: '塔罗阿（马绍尔群岛）' },
    { port_code: 'MHL006', port_ch: '马朱罗（马绍尔群岛）' },
    { port_code: 'MHL007', port_ch: '贾卢伊特（马绍尔群岛）' },
    { port_code: 'MHL008', port_ch: '夸贾林（马绍尔群岛）' },
    { port_code: 'MHL009', port_ch: '莱岛（马绍尔群岛）' },
    { port_code: 'MHL010', port_ch: '沃特杰（马绍尔群岛）' },
    { port_code: 'MHL011', port_ch: '查尔里特（马绍尔群岛）' },
    { port_code: 'MKD000', port_ch: '马其顿' },
    { port_code: 'MLI000', port_ch: '马里' },
    { port_code: 'MLI001', port_ch: '凯斯（马里）' },
    { port_code: 'MLI002', port_ch: '塞古（马里）' },
    { port_code: 'MLI003', port_ch: '廷巴克图（马里）' },
    { port_code: 'MLI004', port_ch: '锡卡索（马里）' },
    { port_code: 'MLT000', port_ch: '马耳他' },
    { port_code: 'MLT003', port_ch: '瓦莱塔（马耳他）' },
    { port_code: 'MLT006', port_ch: '马尔萨什洛克（马耳他）' },
    { port_code: 'MMR000', port_ch: '缅甸' },
    { port_code: 'MMR001', port_ch: '八莫（缅甸）' },
    { port_code: 'MMR003', port_ch: '实兑（缅甸）' },
    { port_code: 'MMR006', port_ch: '勃生（缅甸）' },
    { port_code: 'MMR009', port_ch: '皎漂（缅甸）' },
    { port_code: 'MMR012', port_ch: '墨吉（缅甸）' },
    { port_code: 'MMR015', port_ch: '毛淡棉（缅甸）' },
    { port_code: 'MMR018', port_ch: '仰光（缅甸）' },
    { port_code: 'MMR021', port_ch: '丹兑（山多威）（缅甸）' },
    { port_code: 'MMR024', port_ch: '土瓦（缅甸）' },
    { port_code: 'MMR026', port_ch: '耶城（缅甸）' },
    { port_code: 'MMR027', port_ch: '德林达伊（缅甸）' },
    { port_code: 'MMR030', port_ch: '维多利亚角（缅甸）' },
    { port_code: 'MNE000', port_ch: '黑山共和国' },
    { port_code: 'MNE003', port_ch: '巴尔（黑山共和国）' },
    { port_code: 'MNE006', port_ch: '科托尔（黑山共和国）' },
    { port_code: 'MNE009', port_ch: '卡达尔耶娃（黑山共和国）' },
    { port_code: 'MNG000', port_ch: '蒙古' },
    { port_code: 'MNG901', port_ch: '乌兰巴托（蒙古）' },
    { port_code: 'MNG902', port_ch: '扎门乌德（蒙古）' },
    { port_code: 'MNG903', port_ch: '赛音山达（蒙古）' },
    { port_code: 'MNG904', port_ch: '苏赫巴托（蒙古）' },
    { port_code: 'MNG905', port_ch: '温都尔汗（蒙古）' },
    { port_code: 'MNG906', port_ch: '达尔汗（蒙古）' },
    { port_code: 'MNG907', port_ch: '哈比日嘎（蒙古）' },
    { port_code: 'MNG908', port_ch: '白音胡硕（蒙古）' },
    { port_code: 'MNG909', port_ch: '松布尔（蒙古）' },
    { port_code: 'MNG910', port_ch: '布尔干（蒙古）' },
    { port_code: 'MNG911', port_ch: '大洋（蒙古）' },
    { port_code: 'MNG912', port_ch: '布尔嘎斯台（蒙古）' },
    { port_code: 'MNG913', port_ch: '北塔格（蒙古）' },
    { port_code: 'MNP000', port_ch: '北马里亚纳自由联邦' },
    { port_code: 'MNP003', port_ch: '塞班岛（北马里亚纳自由联邦）' },
    { port_code: 'MNP006', port_ch: '提尼安岛（北马里亚纳自由联邦）' },
    { port_code: 'MNP007', port_ch: '马里亚纳群岛（北马里亚纳自由联邦）' },
    { port_code: 'MOZ000', port_ch: '莫桑比克' },
    { port_code: 'MOZ003', port_ch: '安托尼奥埃尼什（莫桑比克）' },
    { port_code: 'MOZ006', port_ch: '贝拉（莫桑比克）' },
    { port_code: 'MOZ009', port_ch: '欣代（莫桑比克）' },
    { port_code: 'MOZ012', port_ch: '伊博（莫桑比克）' },
    { port_code: 'MOZ015', port_ch: '伊尼扬巴内（莫桑比克）' },
    { port_code: 'MOZ018', port_ch: '马普托（莫桑比克）' },
    { port_code: 'MOZ021', port_ch: '莫辛布瓦（莫桑比克）' },
    { port_code: 'MOZ024', port_ch: '莫马（莫桑比克）' },
    { port_code: 'MOZ027', port_ch: '莫桑比克（莫桑比克）' },
    { port_code: 'MOZ030', port_ch: '纳卡拉（莫桑比克）' },
    { port_code: 'MOZ033', port_ch: '彭巴（莫桑比克）' },
    { port_code: 'MOZ036', port_ch: '克利马内（莫桑比克）' },
    { port_code: 'MOZ041', port_ch: '阿梅利亚港（莫桑比克）' },
    { port_code: 'MOZ042', port_ch: '杰迪达（莫桑比克）' },
    { port_code: 'MOZ043', port_ch: '洛伦索-马贵斯（莫桑比克）' },
    { port_code: 'MRT000', port_ch: '毛里塔尼亚' },
    { port_code: 'MRT003', port_ch: '努瓦迪布（毛里塔尼亚）' },
    { port_code: 'MRT006', port_ch: '努瓦克肖特（毛里塔尼亚）' },
    { port_code: 'MSR000', port_ch: '蒙特塞拉特' },
    { port_code: 'MSR003', port_ch: '普里茅斯（蒙特塞拉特）' },
    { port_code: 'MTQ000', port_ch: '马提尼克' },
    { port_code: 'MTQ003', port_ch: '法兰西堡（马提尼克）' },
    { port_code: 'MTQ006', port_ch: '特里尼泰（马提尼克）' },
    { port_code: 'MTQ007', port_ch: '圣皮埃尔（马提尼克）' },
    { port_code: 'MUS000', port_ch: '毛里求斯' },
    { port_code: 'MUS003', port_ch: '路易港（毛里求斯）' },
    { port_code: 'MWI000', port_ch: '马拉维' },
    { port_code: 'MWI001', port_ch: '利隆圭（马拉维）' },
    { port_code: 'MYS000', port_ch: '马来西亚' },
    { port_code: 'MYS003', port_ch: '巴眼拿督（马来西亚）' },
    { port_code: 'MYS006', port_ch: '巴拉姆（马来西亚）' },
    { port_code: 'MYS009', port_ch: '巴株巴辖（马来西亚）' },
    { port_code: 'MYS012', port_ch: '民那丹（马来西亚）' },
    { port_code: 'MYS015', port_ch: '民都鲁（马来西亚）' },
    { port_code: 'MYS017', port_ch: '新山（马来西亚）' },
    { port_code: 'MYS018', port_ch: '巴特沃思（马来西亚）' },
    { port_code: 'MYS021', port_ch: '龙运（马来西亚）' },
    { port_code: 'MYS024', port_ch: '恩达乌（马来西亚）' },
    { port_code: 'MYS027', port_ch: '乔治敦（马来西亚）' },
    { port_code: 'MYS032', port_ch: '哥打基纳巴卢（马来西亚）' },
    { port_code: 'MYS033', port_ch: '甘马挽（马来西亚）' },
    { port_code: 'MYS036', port_ch: '居茶（马来西亚）' },
    { port_code: 'MYS039', port_ch: '哥打巴鲁（马来西亚）' },
    { port_code: 'MYS045', port_ch: '瓜拉彭亨（马来西亚）' },
    { port_code: 'MYS048', port_ch: '瓜拉弄宾（马来西亚）' },
    { port_code: 'MYS051', port_ch: '瓜拉雪兰莪（马来西亚）' },
    { port_code: 'MYS054', port_ch: '瓜拉苏埃（马来西亚）' },
    { port_code: 'MYS057', port_ch: '瓜拉丁加奴（马来西亚）' },
    { port_code: 'MYS060', port_ch: '关丹（马来西亚）' },
    { port_code: 'MYS063', port_ch: '古晋（马来西亚）' },
    { port_code: 'MYS066', port_ch: '古达（马来西亚）' },
    { port_code: 'MYS068', port_ch: '纳闽（马来西亚）' },
    { port_code: 'MYS069', port_ch: '库纳克（马来西亚）' },
    { port_code: 'MYS075', port_ch: '拉哈达图（马来西亚）' },
    { port_code: 'MYS078', port_ch: '林加（马来西亚）' },
    { port_code: 'MYS081', port_ch: '卢穆特（马来西亚）' },
    { port_code: 'MYS084', port_ch: '隆杜（马来西亚）' },
    { port_code: 'MYS087', port_ch: '马六甲（马来西亚）' },
    { port_code: 'MYS090', port_ch: '米里（马来西亚）' },
    { port_code: 'MYS093', port_ch: '尼亚（马来西亚）' },
    { port_code: 'MYS096', port_ch: '帕西古当（马来西亚）' },
    { port_code: 'MYS099', port_ch: '槟城（马来西亚）' },
    { port_code: 'MYS102', port_ch: '波德申（马来西亚）' },
    { port_code: 'MYS105', port_ch: '巴生港（马来西亚）' },
    { port_code: 'MYS108', port_ch: '文德港（马来西亚）' },
    { port_code: 'MYS111', port_ch: '布莱（马来西亚）' },
    { port_code: 'MYS114', port_ch: '山打根（马来西亚）' },
    { port_code: 'MYS117', port_ch: '泗里奎（马来西亚）' },
    { port_code: 'MYS120', port_ch: '塞京卡（马来西亚）' },
    { port_code: 'MYS123', port_ch: '仙本那（马来西亚）' },
    { port_code: 'MYS124', port_ch: '诗巫（马来西亚）' },
    { port_code: 'MYS129', port_ch: '双溪麻坡（马来西亚）' },
    { port_code: 'MYS132', port_ch: '丹章马尼（马来西亚）' },
    { port_code: 'MYS133', port_ch: '斗湖（马来西亚）' },
    { port_code: 'MYS138', port_ch: '安顺（马来西亚）' },
    { port_code: 'MYS141', port_ch: '特洛拉穆尼亚（马来西亚）' },
    { port_code: 'MYS144', port_ch: '通北（马来西亚）' },
    { port_code: 'MYS147', port_ch: '华莱士（马来西亚）' },
    { port_code: 'MYS150', port_ch: '韦斯顿（马来西亚）' },
    { port_code: 'MYS200', port_ch: 'TG.MANIS（马来西亚）' },
    { port_code: 'MYS201', port_ch: '巴卡皮（马来西亚）' },
    { port_code: 'MYS204', port_ch: '拉布安（马来西亚）' },
    { port_code: 'MYS205', port_ch: '拉瓦斯（马来西亚）' },
    { port_code: 'MYS206', port_ch: '林邦（马来西亚）' },
    { port_code: 'MYS901', port_ch: '吉隆坡（马来西亚）' },
    { port_code: 'MYT000', port_ch: '马约特' },
    { port_code: 'MYT003', port_ch: '藻德济（马约特）' },
    { port_code: 'NAM000', port_ch: '纳米比亚' },
    { port_code: 'NAM003', port_ch: '吕德里茨（纳米比亚）' },
    { port_code: 'NAM006', port_ch: '鲸湾港（纳米比亚）' },
    { port_code: 'NAM007', port_ch: '奥兰治蒙德（纳米比亚）' },
    { port_code: 'NAM008', port_ch: '温得和克（纳米比亚）' },
    { port_code: 'NCL000', port_ch: '新喀里多尼亚' },
    { port_code: 'NCL001', port_ch: '新喀里多尼亚（新喀里多尼亚）' },
    { port_code: 'NCL003', port_ch: '巴布勒特（新喀里多尼亚）' },
    { port_code: 'NCL006', port_ch: '努美阿（新喀里多尼亚）' },
    { port_code: 'NER000', port_ch: '尼日尔' },
    { port_code: 'NER001', port_ch: '津德尔（尼日尔）' },
    { port_code: 'NER002', port_ch: '阿加德兹（尼日尔）' },
    { port_code: 'NER003', port_ch: '尼亚美（尼日尔）' },
    { port_code: 'NFK000', port_ch: '诺福克岛' },
    { port_code: 'NFK003', port_ch: '金斯敦（诺福克岛）' },
    { port_code: 'NFK006', port_ch: '诺福克岛（诺福克岛）' },
    { port_code: 'NGA000', port_ch: '尼日利亚' },
    { port_code: 'NGA003', port_ch: '阿卡萨（尼日利亚）' },
    { port_code: 'NGA006', port_ch: '阿帕帕（尼日利亚）' },
    { port_code: 'NGA009', port_ch: '巴达格里（尼日利亚）' },
    { port_code: 'NGA012', port_ch: '邦尼（尼日利亚）' },
    { port_code: 'NGA015', port_ch: '布拉斯（尼日利亚）' },
    { port_code: 'NGA018', port_ch: '布鲁图（尼日利亚）' },
    { port_code: 'NGA021', port_ch: '卡拉巴尔（尼日利亚）' },
    { port_code: 'NGA024', port_ch: '代盖马（尼日利亚）' },
    { port_code: 'NGA027', port_ch: '拉沃斯河（尼日利亚）' },
    { port_code: 'NGA030', port_ch: '福卡多斯（尼日利亚）' },
    { port_code: 'NGA033', port_ch: '科科（尼日利亚）' },
    { port_code: 'NGA036', port_ch: '拉各斯（尼日利亚）' },
    { port_code: 'NGA039', port_ch: '奥克里卡（尼日利亚）' },
    { port_code: 'NGA042', port_ch: '奥波博（尼日利亚）' },
    { port_code: 'NGA045', port_ch: '彭宁顿码头（尼日利亚）' },
    { port_code: 'NGA047', port_ch: '哈科特港（尼日利亚）' },
    { port_code: 'NGA048', port_ch: '奥尼（尼日利亚）' },
    { port_code: 'NGA051', port_ch: '夸伊博（尼日利亚）' },
    { port_code: 'NGA054', port_ch: '萨佩莱（尼日利亚）' },
    { port_code: 'NGA056', port_ch: '延坎岛（尼日利亚）' },
    { port_code: 'NGA057', port_ch: '瓦里（尼日利亚）' },
    { port_code: 'NGA060', port_ch: 'IDDO（尼日利亚）' },
    { port_code: 'NGA901', port_ch: '卡诺（尼日利亚）' },
    { port_code: 'NIC000', port_ch: '尼加拉瓜' },
    { port_code: 'NIC003', port_ch: '布卢菲尔兹（尼加拉瓜）' },
    { port_code: 'NIC006', port_ch: '科林托（尼加拉瓜）' },
    { port_code: 'NIC009', port_ch: '卡贝萨斯港（尼加拉瓜）' },
    { port_code: 'NIC010', port_ch: '马那瓜（尼加拉瓜）' },
    { port_code: 'NIC012', port_ch: '圣蒂诺港（尼加拉瓜）' },
    { port_code: 'NIC015', port_ch: '南圣胡安（尼加拉瓜）' },
    { port_code: 'NIU000', port_ch: '纽埃' },
    { port_code: 'NIU003', port_ch: '阿洛菲（纽埃）' },
    { port_code: 'NIU006', port_ch: '纽埃岛（纽埃）' },
    { port_code: 'NLD000', port_ch: '荷兰' },
    { port_code: 'NLD003', port_ch: '阿尔克马（荷兰）' },
    { port_code: 'NLD006', port_ch: '阿姆斯特丹（荷兰）' },
    { port_code: 'NLD009', port_ch: '阿纳姆（荷兰）' },
    { port_code: 'NLD012', port_ch: '布劳沃斯港（荷兰）' },
    { port_code: 'NLD015', port_ch: '比瑟姆（荷兰）' },
    { port_code: 'NLD018', port_ch: '代尔夫宰尔（荷兰）' },
    { port_code: 'NLD021', port_ch: '多德雷赫特（荷兰）' },
    { port_code: 'NLD024', port_ch: '埃姆斯哈文（荷兰）' },
    { port_code: 'NLD027', port_ch: '欧罗波特（荷兰）' },
    { port_code: 'NLD030', port_ch: '符拉辛（荷兰）' },
    { port_code: 'NLD033', port_ch: '格罗宁根（荷兰）' },
    { port_code: 'NLD036', port_ch: '汉斯韦尔特（荷兰）' },
    { port_code: 'NLD039', port_ch: '哈灵根（荷兰）' },
    { port_code: 'NLD042', port_ch: '海尔蒙德（荷兰）' },
    { port_code: 'NLD045', port_ch: '荷兰角（荷兰）' },
    { port_code: 'NLD048', port_ch: '坎彭（荷兰）' },
    { port_code: 'NLD051', port_ch: '吕伐登（荷兰）' },
    { port_code: 'NLD054', port_ch: '莱顿（荷兰）' },
    { port_code: 'NLD057', port_ch: '马斯莱斯（荷兰）' },
    { port_code: 'NLD060', port_ch: '梅珀尔（荷兰）' },
    { port_code: 'NLD063', port_ch: '米德尔堡（荷兰）' },
    { port_code: 'NLD066', port_ch: '鹿特丹（荷兰）' },
    { port_code: 'NLD069', port_ch: '罗曾堡（荷兰）' },
    { port_code: 'NLD072', port_ch: '萨斯范亨特（荷兰）' },
    { port_code: 'NLD075', port_ch: '斯海弗宁恩（荷兰）' },
    { port_code: 'NLD078', port_ch: '斯希丹（荷兰）' },
    { port_code: 'NLD081', port_ch: '斯勒伊斯基尔（荷兰）' },
    { port_code: 'NLD084', port_ch: '泰尔讷曾（荷兰）' },
    { port_code: 'NLD087', port_ch: '蒂尔堡（荷兰）' },
    { port_code: 'NLD090', port_ch: '文洛（荷兰）' },
    { port_code: 'NLD093', port_ch: '弗拉尔丁恩（荷兰）' },
    { port_code: 'NLD099', port_ch: '威廉斯塔德（荷兰）' },
    { port_code: 'NLD102', port_ch: '艾默伊登（荷兰）' },
    { port_code: 'NLD104', port_ch: '弗利辛恩（荷兰）' },
    { port_code: 'NLD105', port_ch: '赞丹（荷兰）' },
    { port_code: 'NLD108', port_ch: '济里克泽（荷兰）' },
    { port_code: 'NLD111', port_ch: '聚特芬（荷兰）' },
    { port_code: 'NLD114', port_ch: '兹沃勒（荷兰）' },
    { port_code: 'NLD121', port_ch: '海勒武特斯莱斯（荷兰）' },
    { port_code: 'NLD122', port_ch: '赫尔德（荷兰）' },
    { port_code: 'NLD123', port_ch: '摩的克（荷兰）' },
    { port_code: 'NLD124', port_ch: '奈梅根（荷兰）' },
    { port_code: 'NLD125', port_ch: '希尔佛苏姆（荷兰）' },
    { port_code: 'NLD126', port_ch: '伊默伊登（荷兰）' },
    { port_code: 'NOR000', port_ch: '挪威' },
    { port_code: 'NOR001', port_ch: 'RISOBANK（挪威）' },
    { port_code: 'NOR003', port_ch: '奥勒松（挪威）' },
    { port_code: 'NOR006', port_ch: '阿尔达尔斯坦根（挪威）' },
    { port_code: 'NOR012', port_ch: '阿伦达尔（挪威）' },
    { port_code: 'NOR018', port_ch: '卑尔根（挪威）' },
    { port_code: 'NOR021', port_ch: '博多（挪威）' },
    { port_code: 'NOR024', port_ch: '布雷维克（挪威）' },
    { port_code: 'NOR027', port_ch: '布伦讷于松（挪威）' },
    { port_code: 'NOR030', port_ch: '德拉门（挪威）' },
    { port_code: 'NOR033', port_ch: '艾格松（挪威）' },
    { port_code: 'NOR036', port_ch: '艾特尔海姆（挪威）' },
    { port_code: 'NOR039', port_ch: '法格斯特兰德（挪威）' },
    { port_code: 'NOR042', port_ch: '法尔松德（挪威）' },
    { port_code: 'NOR048', port_ch: '弗莱克菲尤尔（挪威）' },
    { port_code: 'NOR051', port_ch: '弗卢勒（挪威）' },
    { port_code: 'NOR054', port_ch: '腓特烈斯塔（挪威）' },
    { port_code: 'NOR057', port_ch: '格洛姆菲尤尔（挪威）' },
    { port_code: 'NOR060', port_ch: '格里姆斯塔（挪威）' },
    { port_code: 'NOR063', port_ch: '哈尔登（挪威）' },
    { port_code: 'NOR066', port_ch: '哈默弗斯特（挪威）' },
    { port_code: 'NOR069', port_ch: '哈尔斯塔（挪威）' },
    { port_code: 'NOR072', port_ch: '海于格松（挪威）' },
    { port_code: 'NOR075', port_ch: '哈维克（挪威）' },
    { port_code: 'NOR078', port_ch: '哈略（挪威）' },
    { port_code: 'NOR081', port_ch: '霍尔默斯特兰（挪威）' },
    { port_code: 'NOR084', port_ch: '霍腾（挪威）' },
    { port_code: 'NOR087', port_ch: '赫杨厄尔（挪威）' },
    { port_code: 'NOR090', port_ch: '许斯内斯（挪威）' },
    { port_code: 'NOR093', port_ch: '希尔克内斯（挪威）' },
    { port_code: 'NOR096', port_ch: '克来文（挪威）' },
    { port_code: 'NOR099', port_ch: '科珀维克（挪威）' },
    { port_code: 'NOR102', port_ch: '克拉格勒（挪威）' },
    { port_code: 'NOR105', port_ch: '克里斯蒂安桑（挪威）' },
    { port_code: 'NOR108', port_ch: '克里斯蒂安松（挪威）' },
    { port_code: 'NOR111', port_ch: '克维内斯达尔（挪威）' },
    { port_code: 'NOR114', port_ch: '朗厄松（挪威）' },
    { port_code: 'NOR117', port_ch: '拉尔维克（挪威）' },
    { port_code: 'NOR120', port_ch: '利勒桑（挪威）' },
    { port_code: 'NOR123', port_ch: '勒丁恩（挪威）' },
    { port_code: 'NOR126', port_ch: '林厄尔（挪威）' },
    { port_code: 'NOR129', port_ch: '马洛于（挪威）' },
    { port_code: 'NOR132', port_ch: '马尔姆（挪威）' },
    { port_code: 'NOR135', port_ch: '曼达尔（挪威）' },
    { port_code: 'NOR138', port_ch: '曼斯塔德（挪威）' },
    { port_code: 'NOR141', port_ch: '摩城（挪威）' },
    { port_code: 'NOR144', port_ch: '莫尔德（挪威）' },
    { port_code: 'NOR147', port_ch: '蒙斯塔德（挪威）' },
    { port_code: 'NOR150', port_ch: '莫舍恩（挪威）' },
    { port_code: 'NOR153', port_ch: '莫斯（挪威）' },
    { port_code: 'NOR156', port_ch: '奈斯内斯（挪威）' },
    { port_code: 'NOR159', port_ch: '纳姆索斯（挪威）' },
    { port_code: 'NOR162', port_ch: '纳尔维克（挪威）' },
    { port_code: 'NOR165', port_ch: '奥达（挪威）' },
    { port_code: 'NOR168', port_ch: '奥普洛（挪威）' },
    { port_code: 'NOR171', port_ch: '奥斯陆（挪威）' },
    { port_code: 'NOR174', port_ch: '波斯格伦（挪威）' },
    { port_code: 'NOR177', port_ch: '里瑟尔（挪威）' },
    { port_code: 'NOR180', port_ch: '桑讷菲尤尔（挪威）' },
    { port_code: 'NOR183', port_ch: '桑内斯（挪威）' },
    { port_code: 'NOR186', port_ch: '萨尔普斯堡（挪威）' },
    { port_code: 'NOR189', port_ch: '赛于达（挪威）' },
    { port_code: 'NOR192', port_ch: '希恩（挪威）' },
    { port_code: 'NOR195', port_ch: '斯屈德内斯港（挪威）' },
    { port_code: 'NOR198', port_ch: '斯拉根（挪威）' },
    { port_code: 'NOR201', port_ch: '斯塔万格（挪威）' },
    { port_code: 'NOR204', port_ch: '斯泰恩谢尔（挪威）' },
    { port_code: 'NOR207', port_ch: '孙达尔瑟拉（挪威）' },
    { port_code: 'NOR210', port_ch: '斯韦尔根（挪威）' },
    { port_code: 'NOR213', port_ch: '斯瓦尔维克（挪威）' },
    { port_code: 'NOR216', port_ch: '斯沃尔韦尔（挪威）' },
    { port_code: 'NOR219', port_ch: '塔姆港（挪威）' },
    { port_code: 'NOR222', port_ch: '托夫特（挪威）' },
    { port_code: 'NOR225', port_ch: '滕斯贝格（挪威）' },
    { port_code: 'NOR228', port_ch: '塔乌（挪威）' },
    { port_code: 'NOR231', port_ch: '特罗姆瑟（挪威）' },
    { port_code: 'NOR234', port_ch: '特隆赫姆（挪威）' },
    { port_code: 'NOR237', port_ch: '特维德斯特兰德（挪威）' },
    { port_code: 'NOR240', port_ch: '瓦德瑟（挪威）' },
    { port_code: 'NOR243', port_ch: '瓦克斯达尔（挪威）' },
    { port_code: 'NOR246', port_ch: '沃尔德（挪威）' },
    { port_code: 'NOR249', port_ch: '沃尔达（挪威）' },
    { port_code: 'NOR252', port_ch: 'BYE（挪威）' },
    { port_code: 'NPL000', port_ch: '尼泊尔' },
    { port_code: 'NPL901', port_ch: '加德满都（尼泊尔）' },
    { port_code: 'NPL902', port_ch: '科达里（尼泊尔）' },
    { port_code: 'NRU000', port_ch: '瑙鲁' },
    { port_code: 'NRU003', port_ch: '瑙鲁岛（瑙鲁）' },
    { port_code: 'NRU006', port_ch: '亚伦（瑙鲁）' },
    { port_code: 'NZL000', port_ch: '新西兰' },
    { port_code: 'NZL001', port_ch: '璜加雷（新西兰）' },
    { port_code: 'NZL003', port_ch: '奥克兰（新西兰）' },
    { port_code: 'NZL004', port_ch: '克马德克群岛（新西兰）' },
    { port_code: 'NZL006', port_ch: '布拉夫（新西兰）' },
    { port_code: 'NZL008', port_ch: '克赖斯特彻奇（新西兰）' },
    { port_code: 'NZL009', port_ch: '达尼丁（新西兰）' },
    { port_code: 'NZL011', port_ch: '塔拉纳基港（新西兰）' },
    { port_code: 'NZL012', port_ch: '吉斯珀恩（新西兰）' },
    { port_code: 'NZL015', port_ch: '格雷茅斯（新西兰）' },
    { port_code: 'NZL018', port_ch: '因弗卡吉尔（新西兰）' },
    { port_code: 'NZL021', port_ch: '利特尔顿（新西兰）' },
    { port_code: 'NZL024', port_ch: '芒特芒阿努伊（新西兰）' },
    { port_code: 'NZL027', port_ch: '内皮尔（新西兰）' },
    { port_code: 'NZL030', port_ch: '纳尔逊（新西兰）' },
    { port_code: 'NZL033', port_ch: '新普利茅斯（新西兰）' },
    { port_code: 'NZL036', port_ch: '奥马鲁（新西兰）' },
    { port_code: 'NZL039', port_ch: '奥尼洪加（新西兰）' },
    { port_code: 'NZL042', port_ch: '奥普阿（新西兰）' },
    { port_code: 'NZL044', port_ch: '奥塔戈（新西兰）' },
    { port_code: 'NZL045', port_ch: '皮克顿（新西兰）' },
    { port_code: 'NZL048', port_ch: '查默斯港（新西兰）' },
    { port_code: 'NZL051', port_ch: '罗塞尔港（新西兰）' },
    { port_code: 'NZL056', port_ch: '塔哈罗阿（新西兰）' },
    { port_code: 'NZL057', port_ch: '陶朗阿（新西兰）' },
    { port_code: 'NZL060', port_ch: '蒂马鲁（新西兰）' },
    { port_code: 'NZL063', port_ch: '怀劳（新西兰）' },
    { port_code: 'NZL066', port_ch: '旺加努伊（新西兰）' },
    { port_code: 'NZL069', port_ch: '韦弗利港（新西兰）' },
    { port_code: 'NZL072', port_ch: '惠灵顿（新西兰）' },
    { port_code: 'NZL075', port_ch: '韦斯特皮特（新西兰）' },
    { port_code: 'NZL078', port_ch: '旺阿雷（新西兰）' },
    { port_code: 'NZL102', port_ch: '邦蒂群岛（新西兰）' },
    { port_code: 'NZL103', port_ch: '阿卡罗亚（新西兰）' },
    { port_code: 'OMN000', port_ch: '阿曼' },
    { port_code: 'OMN003', port_ch: '费赫勒港（阿曼）' },
    { port_code: 'OMN006', port_ch: '卡布斯港（阿曼）' },
    { port_code: 'OMN009', port_ch: '马特拉（阿曼）' },
    { port_code: 'OMN012', port_ch: '塞拉莱（阿曼）' },
    { port_code: 'OMN015', port_ch: '马斯喀特（阿曼）' },
    { port_code: 'OMN018', port_ch: '赖苏特（阿曼）' },
    { port_code: 'OMN021', port_ch: '索哈（阿曼）' },
    { port_code: 'PAK000', port_ch: '巴基斯坦' },
    { port_code: 'PAK003', port_ch: '瓜德尔（巴基斯坦）' },
    { port_code: 'PAK006', port_ch: '卡拉奇（巴基斯坦）' },
    { port_code: 'PAK008', port_ch: '穆罕默德宾加西姆（巴基斯坦）' },
    { port_code: 'PAK009', port_ch: '奥尔马拉（巴基斯坦）' },
    { port_code: 'PAK012', port_ch: '伯斯尼（巴基斯坦）' },
    { port_code: 'PAK901', port_ch: '苏斯特（巴基斯坦）' },
    { port_code: 'PAK902', port_ch: '伊斯兰堡（巴基斯坦）' },
    { port_code: 'PAN000', port_ch: '巴拿马' },
    { port_code: 'PAN001', port_ch: 'PUERTO DELABAHIA DE（巴拿马）' },
    { port_code: 'PAN002', port_ch: '巴拿马运河（巴拿马）' },
    { port_code: 'PAN003', port_ch: '阿瓜杜尔塞（巴拿马）' },
    { port_code: 'PAN004', port_ch: '贝略港（巴拿马）' },
    { port_code: 'PAN005', port_ch: '博卡斯-德尔扎罗（巴拿马）' },
    { port_code: 'PAN006', port_ch: '阿尔米兰特（巴拿马）' },
    { port_code: 'PAN007', port_ch: '托斯米纳斯湾（巴拿马）' },
    { port_code: 'PAN008', port_ch: '拉斯米纳斯湾港（巴拿马）' },
    { port_code: 'PAN009', port_ch: '安蒙勒斯（巴拿马）' },
    { port_code: 'PAN012', port_ch: '巴尔博亚（巴拿马）' },
    { port_code: 'PAN015', port_ch: '大奇里基（巴拿马）' },
    { port_code: 'PAN018', port_ch: '科隆（巴拿马）' },
    { port_code: 'PAN021', port_ch: '克里斯托瓦尔（巴拿马）' },
    { port_code: 'PAN022', port_ch: '曼萨尼约（巴拿马）' },
    { port_code: 'PAN023', port_ch: '巴拿马城（巴拿马）' },
    { port_code: 'PAN024', port_ch: '拉帕尔马（巴拿马）' },
    { port_code: 'PAN027', port_ch: '帕纳马（巴拿马）' },
    { port_code: 'PAN030', port_ch: '佩德雷加尔（巴拿马）' },
    { port_code: 'PAN033', port_ch: '巴尔蒙特（巴拿马）' },
    { port_code: 'PCN000', port_ch: '皮特凯恩群岛' },
    { port_code: 'PCN003', port_ch: '亚当斯敦（皮特凯恩群岛）' },
    { port_code: 'PCN006', port_ch: '皮特凯恩岛（皮特凯恩群岛）' },
    { port_code: 'PER000', port_ch: '秘鲁' },
    { port_code: 'PER002', port_ch: 'BESIQUE（秘鲁）' },
    { port_code: 'PER003', port_ch: '安孔（秘鲁）' },
    { port_code: 'PER006', port_ch: '阿蒂科（秘鲁）' },
    { port_code: 'PER009', port_ch: '卡沃布兰科（秘鲁）' },
    { port_code: 'PER012', port_ch: '卡亚俄（秘鲁）' },
    { port_code: 'PER015', port_ch: '塞罗阿苏尔（秘鲁）' },
    { port_code: 'PER018', port_ch: '钱凯（秘鲁）' },
    { port_code: 'PER021', port_ch: '奇卡马（秘鲁）' },
    { port_code: 'PER024', port_ch: '钦博塔（秘鲁）' },
    { port_code: 'PER027', port_ch: '科伊希科（秘鲁）' },
    { port_code: 'PER030', port_ch: '康昌（秘鲁）' },
    { port_code: 'PER033', port_ch: '埃腾（秘鲁）' },
    { port_code: 'PER036', port_ch: '圣马丁将军镇（秘鲁）' },
    { port_code: 'PER039', port_ch: '瓦乔（秘鲁）' },
    { port_code: 'PER042', port_ch: '瓦尔梅（秘鲁）' },
    { port_code: 'PER045', port_ch: '伊洛（秘鲁）' },
    { port_code: 'PER048', port_ch: '伊基托斯（秘鲁）' },
    { port_code: 'PER051', port_ch: '拉帕姆皮拉（秘鲁）' },
    { port_code: 'PER054', port_ch: '洛维托斯（秘鲁）' },
    { port_code: 'PER057', port_ch: '洛布斯岛（秘鲁）' },
    { port_code: 'PER060', port_ch: '洛马斯（秘鲁）' },
    { port_code: 'PER063', port_ch: '马塔拉尼（秘鲁）' },
    { port_code: 'PER066', port_ch: '莫延多（秘鲁）' },
    { port_code: 'PER069', port_ch: '帕卡斯马约（秘鲁）' },
    { port_code: 'PER072', port_ch: '派塔（秘鲁）' },
    { port_code: 'PER075', port_ch: '帕拉蒙加（秘鲁）' },
    { port_code: 'PER078', port_ch: '皮门特尔（秘鲁）' },
    { port_code: 'PER081', port_ch: '皮萨瓜（秘鲁）' },
    { port_code: 'PER084', port_ch: '皮斯科（秘鲁）' },
    { port_code: 'PER087', port_ch: '巴约瓦尔港（秘鲁）' },
    { port_code: 'PER090', port_ch: '萨拉韦里（秘鲁）' },
    { port_code: 'PER093', port_ch: '圣胡安（秘鲁）' },
    { port_code: 'PER096', port_ch: '圣尼古拉斯（秘鲁）' },
    { port_code: 'PER099', port_ch: '苏佩（秘鲁）' },
    { port_code: 'PER102', port_ch: '塔拉拉（秘鲁）' },
    { port_code: 'PER104', port_ch: '特鲁希略（秘鲁）' },
    { port_code: 'PER105', port_ch: '坦博-德莫拉（秘鲁）' },
    { port_code: 'PHL000', port_ch: '菲律宾' },
    { port_code: 'PHL002', port_ch: '碧瑶（菲律宾）' },
    { port_code: 'PHL003', port_ch: '阿布约（菲律宾）' },
    { port_code: 'PHL004', port_ch: '班乃岛（菲律宾）' },
    { port_code: 'PHL005', port_ch: '保和（菲律宾）' },
    { port_code: 'PHL006', port_ch: '阿姆尼坦（菲律宾）' },
    { port_code: 'PHL007', port_ch: '布瓦杨（菲律宾）' },
    { port_code: 'PHL009', port_ch: '阿纳根（菲律宾）' },
    { port_code: 'PHL011', port_ch: '棉兰老岛（菲律宾）' },
    { port_code: 'PHL012', port_ch: '安蒂莫纳（菲律宾）' },
    { port_code: 'PHL013', port_ch: '萨马岛（菲律宾）' },
    { port_code: 'PHL015', port_ch: '阿帕里（菲律宾）' },
    { port_code: 'PHL018', port_ch: '巴科洛德（菲律宾）' },
    { port_code: 'PHL021', port_ch: '拜斯（菲律宾）' },
    { port_code: 'PHL024', port_ch: '巴丹（菲律宾）' },
    { port_code: 'PHL027', port_ch: '八打雁（菲律宾）' },
    { port_code: 'PHL030', port_ch: '比斯利格（菲律宾）' },
    { port_code: 'PHL033', port_ch: '博哥（菲律宾）' },
    { port_code: 'PHL036', port_ch: '武端（菲律宾）' },
    { port_code: 'PHL039', port_ch: '加的斯（菲律宾）' },
    { port_code: 'PHL042', port_ch: '卡加延德奥罗（菲律宾）' },
    { port_code: 'PHL045', port_ch: '甲描育（菲律宾）' },
    { port_code: 'PHL048', port_ch: '卡皮斯（菲律宾）' },
    { port_code: 'PHL051', port_ch: '甲米地（菲律宾）' },
    { port_code: 'PHL054', port_ch: '宿务（菲律宾）' },
    { port_code: 'PHL057', port_ch: '达沃（菲律宾）' },
    { port_code: 'PHL060', port_ch: '迪纳加特（菲律宾）' },
    { port_code: 'PHL063', port_ch: '丁阿兰湾（菲律宾）' },
    { port_code: 'PHL066', port_ch: '第波罗（菲律宾）' },
    { port_code: 'PHL069', port_ch: '杜马格特（菲律宾）' },
    { port_code: 'PHL072', port_ch: '桑托斯（菲律宾）' },
    { port_code: 'PHL075', port_ch: '吉马拉斯岛（菲律宾）' },
    { port_code: 'PHL078', port_ch: '希尼加兰（菲律宾）' },
    { port_code: 'PHL081', port_ch: '伊利甘（菲律宾）' },
    { port_code: 'PHL084', port_ch: '伊洛伊洛（菲律宾）' },
    { port_code: 'PHL087', port_ch: '伊萨贝尔（菲律宾）' },
    { port_code: 'PHL090', port_ch: '伊萨贝拉（菲律宾）' },
    { port_code: 'PHL093', port_ch: '霍洛（菲律宾）' },
    { port_code: 'PHL096', port_ch: '何塞庞阿尼班村（菲律宾）' },
    { port_code: 'PHL099', port_ch: '拉乌尼翁（菲律宾）' },
    { port_code: 'PHL102', port_ch: '拉瓦格（菲律宾）' },
    { port_code: 'PHL105', port_ch: '莱巴克（菲律宾）' },
    { port_code: 'PHL108', port_ch: '黎牙实比（菲律宾）' },
    { port_code: 'PHL111', port_ch: '林加延（菲律宾）' },
    { port_code: 'PHL114', port_ch: '马尼拉（菲律宾）' },
    { port_code: 'PHL117', port_ch: '马里韦莱斯（菲律宾）' },
    { port_code: 'PHL120', port_ch: '马萨豪（菲律宾）' },
    { port_code: 'PHL123', port_ch: '马斯巴特（菲律宾）' },
    { port_code: 'PHL126', port_ch: '马辛洛克（菲律宾）' },
    { port_code: 'PHL129', port_ch: '马蒂（菲律宾）' },
    { port_code: 'PHL132', port_ch: '米尔布克（菲律宾）' },
    { port_code: 'PHL135', port_ch: '那牙（菲律宾）' },
    { port_code: 'PHL138', port_ch: '纳斯皮特（菲律宾）' },
    { port_code: 'PHL141', port_ch: '纳苏格布（菲律宾）' },
    { port_code: 'PHL144', port_ch: '奥隆阿坡（菲律宾）' },
    { port_code: 'PHL147', port_ch: '奥尔莫克（菲律宾）' },
    { port_code: 'PHL150', port_ch: '潘普洛纳（菲律宾）' },
    { port_code: 'PHL153', port_ch: '帕兰（菲律宾）' },
    { port_code: 'PHL156', port_ch: '波略克（菲律宾）' },
    { port_code: 'PHL159', port_ch: '波罗（Luzon）（菲律宾）' },
    { port_code: 'PHL162', port_ch: '波罗（Poro I.）（菲律宾）' },
    { port_code: 'PHL165', port_ch: '荷兰港（菲律宾）' },
    { port_code: 'PHL168', port_ch: '圣玛丽亚港（菲律宾）' },
    { port_code: 'PHL171', port_ch: '普林塞萨港（菲律宾）' },
    { port_code: 'PHL174', port_ch: '普卢潘丹（菲律宾）' },
    { port_code: 'PHL177', port_ch: '圣卡洛斯（菲律宾）' },
    { port_code: 'PHL180', port_ch: '圣弗尔南多（菲律宾）' },
    { port_code: 'PHL183', port_ch: '桑义（菲律宾）' },
    { port_code: 'PHL186', port_ch: '圣克鲁斯（菲律宾）' },
    { port_code: 'PHL189', port_ch: '索索贡（菲律宾）' },
    { port_code: 'PHL192', port_ch: '苏里高（菲律宾）' },
    { port_code: 'PHL195', port_ch: '塔瓦科（菲律宾）' },
    { port_code: 'PHL198', port_ch: '塔克洛班（菲律宾）' },
    { port_code: 'PHL201', port_ch: '塔比拉兰（菲律宾）' },
    { port_code: 'PHL204', port_ch: '坦多哥（菲律宾）' },
    { port_code: 'PHL207', port_ch: '托莱多（菲律宾）' },
    { port_code: 'PHL210', port_ch: '维拉努埃瓦（菲律宾）' },
    { port_code: 'PHL213', port_ch: '三宝颜（菲律宾）' },
    { port_code: 'PHL216', port_ch: '奎松城（菲律宾）' },
    { port_code: 'PHL219', port_ch: '民多罗岛（菲律宾）' },
    { port_code: 'PHL910', port_ch: '吕宋岛（菲律宾）' },
    { port_code: 'PLW000', port_ch: '帕劳' },
    { port_code: 'PLW003', port_ch: '科罗尔（帕劳）' },
    { port_code: 'PLW004', port_ch: '帕劳群岛（帕劳）' },
    { port_code: 'PNG000', port_ch: '巴布亚新几内亚' },
    { port_code: 'PNG001', port_ch: '布干维尔岛（巴布亚新几内亚）' },
    { port_code: 'PNG002', port_ch: '新爱尔兰（巴布亚新几内亚）' },
    { port_code: 'PNG003', port_ch: '艾塔佩（巴布亚新几内亚）' },
    { port_code: 'PNG006', port_ch: '阿洛陶（巴布亚新几内亚）' },
    { port_code: 'PNG009', port_ch: '阿内瓦湾（巴布亚新几内亚）' },
    { port_code: 'PNG012', port_ch: '布卡（巴布亚新几内亚）' },
    { port_code: 'PNG015', port_ch: '布纳（巴布亚新几内亚）' },
    { port_code: 'PNG018', port_ch: '霍斯金斯角（巴布亚新几内亚）' },
    { port_code: 'PNG021', port_ch: '达鲁（巴布亚新几内亚）' },
    { port_code: 'PNG024', port_ch: '芬什哈芬（巴布亚新几内亚）' },
    { port_code: 'PNG027', port_ch: '加斯马塔岛（巴布亚新几内亚）' },
    { port_code: 'PNG030', port_ch: '卡维恩（巴布亚新几内亚）' },
    { port_code: 'PNG033', port_ch: '基埃塔（巴布亚新几内亚）' },
    { port_code: 'PNG036', port_ch: '金贝（巴布亚新几内亚）' },
    { port_code: 'PNG039', port_ch: '莱城（巴布亚新几内亚）' },
    { port_code: 'PNG042', port_ch: '洛伦高（巴布亚新几内亚）' },
    { port_code: 'PNG045', port_ch: '马当（巴布亚新几内亚）' },
    { port_code: 'PNG048', port_ch: '莫罗贝（巴布亚新几内亚）' },
    { port_code: 'PNG051', port_ch: '奥鲁湾（巴布亚新几内亚）' },
    { port_code: 'PNG054', port_ch: '莫尔兹比港（巴布亚新几内亚）' },
    { port_code: 'PNG057', port_ch: '拉包尔（巴布亚新几内亚）' },
    { port_code: 'PNG060', port_ch: '萨拉毛亚（巴布亚新几内亚）' },
    { port_code: 'PNG063', port_ch: '萨马赖（巴布亚新几内亚）' },
    { port_code: 'PNG066', port_ch: '威瓦克（巴布亚新几内亚）' },
    { port_code: 'PNG069', port_ch: '伍德拉克岛（巴布亚新几内亚）' },
    { port_code: 'POL000', port_ch: '波兰' },
    { port_code: 'POL003', port_ch: '达尔沃沃（波兰）' },
    { port_code: 'POL006', port_ch: '格但斯克（波兰）' },
    { port_code: 'POL009', port_ch: '格丁尼亚（波兰）' },
    { port_code: 'POL012', port_ch: '海尔（波兰）' },
    { port_code: 'POL015', port_ch: '科沃布热格（波兰）' },
    { port_code: 'POL018', port_ch: '希维诺乌伊希切（波兰）' },
    { port_code: 'POL021', port_ch: '什切青（波兰）' },
    { port_code: 'POL024', port_ch: '乌斯特卡（波兰）' },
    { port_code: 'POL027', port_ch: '弗瓦迪斯瓦沃沃（波兰）' },
    { port_code: 'PRI000', port_ch: '波多黎各' },
    { port_code: 'PRI003', port_ch: '阿瓜迪亚（波多黎各）' },
    { port_code: 'PRI006', port_ch: '阿雷西沃（波多黎各）' },
    { port_code: 'PRI009', port_ch: '法哈多（波多黎各）' },
    { port_code: 'PRI012', port_ch: '瓜尼卡（波多黎各）' },
    { port_code: 'PRI015', port_ch: '拉斯马雷亚斯（波多黎各）' },
    { port_code: 'PRI018', port_ch: '瓜亚尼亚（波多黎各）' },
    { port_code: 'PRI021', port_ch: '乔布斯（波多黎各）' },
    { port_code: 'PRI024', port_ch: '马亚圭斯（波多黎各）' },
    { port_code: 'PRI027', port_ch: '蓬塞（波多黎各）' },
    { port_code: 'PRI030', port_ch: '圣胡安（波多黎各）' },
    { port_code: 'PRI033', port_ch: '亚武科阿（波多黎各）' },
    { port_code: 'PRI034', port_ch: '托斯马雷阿斯港（波多黎各）' },
    { port_code: 'PRI035', port_ch: '亚布夸港（波多黎各）' },
    { port_code: 'PRK000', port_ch: '朝鲜' },
    { port_code: 'PRK003', port_ch: '镇南浦（朝鲜）' },
    { port_code: 'PRK006', port_ch: '清津（朝鲜）' },
    { port_code: 'PRK009', port_ch: '海州（朝鲜）' },
    { port_code: 'PRK012', port_ch: '兴南（朝鲜）' },
    { port_code: 'PRK015', port_ch: '罗津（朝鲜）' },
    { port_code: 'PRK018', port_ch: '松林（朝鲜）' },
    { port_code: 'PRK021', port_ch: '元山（朝鲜）' },
    { port_code: 'PRK024', port_ch: '新浦（朝鲜）' },
    { port_code: 'PRK030', port_ch: '开城（朝鲜）' },
    { port_code: 'PRK901', port_ch: '平壤（朝鲜）' },
    { port_code: 'PRK902', port_ch: '普通江（朝鲜）' },
    { port_code: 'PRK903', port_ch: '新义州（朝鲜）' },
    { port_code: 'PRK904', port_ch: '西浦（朝鲜）' },
    { port_code: 'PRK905', port_ch: '南浦（朝鲜）' },
    { port_code: 'PRK906', port_ch: '会宁（朝鲜）' },
    { port_code: 'PRK907', port_ch: '七星里（朝鲜）' },
    { port_code: 'PRK908', port_ch: '赛别尔（朝鲜）' },
    { port_code: 'PRK909', port_ch: '沅丁（朝鲜）' },
    { port_code: 'PRK910', port_ch: '南阳（朝鲜）' },
    { port_code: 'PRK911', port_ch: '山峰（朝鲜）' },
    { port_code: 'PRK912', port_ch: '三长（朝鲜）' },
    { port_code: 'PRK913', port_ch: '满浦（朝鲜）' },
    { port_code: 'PRK914', port_ch: '渭源（朝鲜）' },
    { port_code: 'PRK915', port_ch: '中江（朝鲜）' },
    { port_code: 'PRK916', port_ch: '惠山（朝鲜）' },
    { port_code: 'PRT000', port_ch: '葡萄牙' },
    { port_code: 'PRT003', port_ch: '阿威罗（葡萄牙）' },
    { port_code: 'PRT004', port_ch: 'BANATICA（葡萄牙）' },
    { port_code: 'PRT006', port_ch: '巴雷鲁（葡萄牙）' },
    { port_code: 'PRT009', port_ch: '贝伦（葡萄牙）' },
    { port_code: 'PRT012', port_ch: '法鲁（葡萄牙）' },
    { port_code: 'PRT013', port_ch: '圣安东尼奥城（葡萄牙）' },
    { port_code: 'PRT014', port_ch: '英雄港（葡萄牙）' },
    { port_code: 'PRT015', port_ch: '菲盖拉（葡萄牙）' },
    { port_code: 'PRT016', port_ch: '丰沙尔（葡萄牙）' },
    { port_code: 'PRT017', port_ch: '奥尔塔（葡萄牙）' },
    { port_code: 'PRT018', port_ch: '雷克索斯（葡萄牙）' },
    { port_code: 'PRT021', port_ch: '里斯本（葡萄牙）' },
    { port_code: 'PRT024', port_ch: '奥良（葡萄牙）' },
    { port_code: 'PRT027', port_ch: '波尔图（葡萄牙）' },
    { port_code: 'PRT030', port_ch: '波马朗（葡萄牙）' },
    { port_code: 'PRT032', port_ch: '蓬塔德尔加达港（葡萄牙）' },
    { port_code: 'PRT033', port_ch: '波尔蒂芒（葡萄牙）' },
    { port_code: 'PRT036', port_ch: '塞图巴尔（葡萄牙）' },
    { port_code: 'PRT039', port_ch: '锡尼什（葡萄牙）' },
    { port_code: 'PRT042', port_ch: '维亚纳堡（葡萄牙）' },
    { port_code: 'PRT045', port_ch: '雷阿尔城（葡萄牙）' },
    { port_code: 'PRY000', port_ch: '巴拉圭' },
    { port_code: 'PRY003', port_ch: '亚松森（巴拉圭）' },
    { port_code: 'PSE000', port_ch: '巴勒斯坦' },
    { port_code: 'PSE003', port_ch: '阿什杜德（巴勒斯坦）' },
    { port_code: 'PSE006', port_ch: '埃拉特（巴勒斯坦）' },
    { port_code: 'PSE008', port_ch: '利达（巴勒斯坦）' },
    { port_code: 'PSE010', port_ch: '耶路撒冷（巴勒斯坦）' },
    { port_code: 'PYF000', port_ch: '法属波利尼西亚' },
    { port_code: 'PYF003', port_ch: '豪岛（法属波利尼西亚）' },
    { port_code: 'PYF006', port_ch: '麦卡梯（法属波利尼西亚）' },
    { port_code: 'PYF009', port_ch: '穆鲁路（法属波利尼西亚）' },
    { port_code: 'PYF011', port_ch: '波拉波拉（法属波利尼西亚）' },
    { port_code: 'PYF012', port_ch: '帕皮提（法属波利尼西亚）' },
    { port_code: 'PYF015', port_ch: '韦他佩（法属波利尼西亚）' },
    { port_code: 'PYF016', port_ch: '马克萨斯群岛（法属波利尼西亚）' },
    { port_code: 'PYF017', port_ch: '塔希提岛（法属波利尼西亚）' },
    { port_code: 'PYF018', port_ch: '土阿莫土群岛（法属波利尼西亚）' },
    { port_code: 'PYF019', port_ch: '土布艾群岛（法属波利尼西亚）' },
    { port_code: 'QAT000', port_ch: '卡塔尔' },
    { port_code: 'QAT003', port_ch: '多哈（卡塔尔）' },
    { port_code: 'QAT006', port_ch: '哈卢勒岛（卡塔尔）' },
    { port_code: 'QAT009', port_ch: '乌姆赛义德（卡塔尔）' },
    { port_code: 'REU000', port_ch: '留尼汪' },
    { port_code: 'REU002', port_ch: '勒波尔（留尼汪）' },
    { port_code: 'REU003', port_ch: '加勒茨角港（留尼汪）' },
    { port_code: 'REU006', port_ch: '圣但尼（留尼汪）' },
    { port_code: 'REU009', port_ch: '圣路易（留尼汪）' },
    { port_code: 'ROU000', port_ch: '罗马尼亚' },
    { port_code: 'ROU003', port_ch: '布勒伊拉（罗马尼亚）' },
    { port_code: 'ROU006', port_ch: '康斯坦察（罗马尼亚）' },
    { port_code: 'ROU009', port_ch: '加拉茨（罗马尼亚）' },
    { port_code: 'ROU012', port_ch: '曼加利亚（罗马尼亚）' },
    { port_code: 'ROU015', port_ch: '苏利纳（罗马尼亚）' },
    { port_code: 'ROU018', port_ch: '图耳恰（罗马尼亚）' },
    { port_code: 'ROU901', port_ch: '布加勒斯特（罗马尼亚）' },
    { port_code: 'RUS000', port_ch: '俄罗斯' },
    { port_code: 'RUS003', port_ch: '亚历山大罗夫斯克（俄罗斯）' },
    { port_code: 'RUS004', port_ch: '阿纳德尔（俄罗斯）' },
    { port_code: 'RUS006', port_ch: '阿尔汉格尔斯克（俄罗斯）' },
    { port_code: 'RUS009', port_ch: '德卡斯特莱（俄罗斯）' },
    { port_code: 'RUS012', port_ch: '加里宁格勒（俄罗斯）' },
    { port_code: 'RUS015', port_ch: '克烈季（俄罗斯）' },
    { port_code: 'RUS018', port_ch: '霍尔姆斯克（俄罗斯）' },
    { port_code: 'RUS021', port_ch: '科尔萨科夫（俄罗斯）' },
    { port_code: 'RUS024', port_ch: '拉扎烈夫（俄罗斯）' },
    { port_code: 'RUS027', port_ch: '马加丹（俄罗斯）' },
    { port_code: 'RUS030', port_ch: '马戈（俄罗斯）' },
    { port_code: 'RUS033', port_ch: '马卡洛夫（俄罗斯）' },
    { port_code: 'RUS036', port_ch: '美晋（俄罗斯）' },
    { port_code: 'RUS039', port_ch: '摩尔曼斯克（俄罗斯）' },
    { port_code: 'RUS042', port_ch: '纳霍德卡（俄罗斯）' },
    { port_code: 'RUS045', port_ch: '纳里扬马尔（俄罗斯）' },
    { port_code: 'RUS048', port_ch: '涅韦尔斯克（俄罗斯）' },
    { port_code: 'RUS051', port_ch: '尼古拉耶夫（俄罗斯）' },
    { port_code: 'RUS054', port_ch: '新罗西斯克（俄罗斯）' },
    { port_code: 'RUS057', port_ch: '奥哈（俄罗斯）' },
    { port_code: 'RUS060', port_ch: '鄂霍次克（俄罗斯）' },
    { port_code: 'RUS063', port_ch: '十月市（俄罗斯）' },
    { port_code: 'RUS066', port_ch: '奥涅加（俄罗斯）' },
    { port_code: 'RUS069', port_ch: '彼得罗巴甫洛夫斯克（俄罗斯）' },
    { port_code: 'RUS072', port_ch: '波罗奈斯克（俄罗斯）' },
    { port_code: 'RUS075', port_ch: '普里莫尔斯克（俄罗斯）' },
    { port_code: 'RUS078', port_ch: '罗斯托夫（俄罗斯）' },
    { port_code: 'RUS081', port_ch: '沙赫乔特斯克（俄罗斯）' },
    { port_code: 'RUS084', port_ch: '索契（俄罗斯）' },
    { port_code: 'RUS087', port_ch: '苏维埃港（俄罗斯）' },
    { port_code: 'RUS090', port_ch: '圣彼得堡（俄罗斯）' },
    { port_code: 'RUS093', port_ch: '斯伟特拉亚河（俄罗斯）' },
    { port_code: 'RUS096', port_ch: '塔甘罗格（俄罗斯）' },
    { port_code: 'RUS099', port_ch: '图阿普谢（俄罗斯）' },
    { port_code: 'RUS102', port_ch: '乌格里哥斯克（俄罗斯）' },
    { port_code: 'RUS104', port_ch: '乌斯季堪察茨克（俄罗斯）' },
    { port_code: 'RUS105', port_ch: '翁巴（俄罗斯）' },
    { port_code: 'RUS108', port_ch: '瓦尼诺（俄罗斯）' },
    { port_code: 'RUS111', port_ch: '符拉迪沃斯托克/海参葳（俄罗斯）' },
    { port_code: 'RUS114', port_ch: '东方港（俄罗斯）' },
    { port_code: 'RUS117', port_ch: '维堡（俄罗斯）' },
    { port_code: 'RUS120', port_ch: '维索茨克（俄罗斯）' },
    { port_code: 'RUS123', port_ch: '扎鲁比诺（俄罗斯）' },
    { port_code: 'RUS126', port_ch: '日丹诺夫（俄罗斯）' },
    { port_code: 'RUS901', port_ch: '莫斯科（俄罗斯）' },
    { port_code: 'RUS902', port_ch: '波格拉尼奇内（俄罗斯）' },
    { port_code: 'RUS903', port_ch: '别尔迪杨斯克（俄罗斯）' },
    { port_code: 'RUS904', port_ch: '波季（俄罗斯）' },
    { port_code: 'RUS905', port_ch: '都普西（俄罗斯）' },
    { port_code: 'RUS906', port_ch: '赫尔松（俄罗斯）' },
    { port_code: 'RUS907', port_ch: '基利亚（俄罗斯）' },
    { port_code: 'RUS908', port_ch: '克耒彼达（俄罗斯）' },
    { port_code: 'RUS910', port_ch: '温次匹尔斯（俄罗斯）' },
    { port_code: 'RUS911', port_ch: '伊加尔卡（俄罗斯）' },
    { port_code: 'RUS912', port_ch: '伊利切夫斯克（俄罗斯）' },
    { port_code: 'RUS913', port_ch: '伊兹马伊耳（俄罗斯）' },
    { port_code: 'RWA000', port_ch: '卢旺达' },
    { port_code: 'SAU000', port_ch: '沙特阿拉伯' },
    { port_code: 'SAU003', port_ch: '达曼（沙特阿拉伯）' },
    { port_code: 'SAU006', port_ch: '吉赞（沙特阿拉伯）' },
    { port_code: 'SAU009', port_ch: '吉达（沙特阿拉伯）' },
    { port_code: 'SAU012', port_ch: '朱阿马港（沙特阿拉伯）' },
    { port_code: 'SAU015', port_ch: '朱拜勒（沙特阿拉伯）' },
    { port_code: 'SAU018', port_ch: '拉斯海夫吉（沙特阿拉伯）' },
    { port_code: 'SAU021', port_ch: '米萨卜角（沙特阿拉伯）' },
    { port_code: 'SAU024', port_ch: '拉斯坦努拉（沙特阿拉伯）' },
    { port_code: 'SAU027', port_ch: '延布（沙特阿拉伯）' },
    { port_code: 'SAU030', port_ch: '利雅得（沙特阿拉伯）' },
    { port_code: 'SAU033', port_ch: '布赖代（沙特阿拉伯）' },
    { port_code: 'SAU039', port_ch: '麦加（沙特阿拉伯）' },
    { port_code: 'SDN000', port_ch: '苏丹' },
    { port_code: 'SDN003', port_ch: '苏丹港（苏丹）' },
    { port_code: 'SDN006', port_ch: '萨瓦金（苏丹）' },
    { port_code: 'SDN901', port_ch: '喀士穆（苏丹）' },
    { port_code: 'SEN000', port_ch: '塞内加尔' },
    { port_code: 'SEN003', port_ch: '达喀尔（塞内加尔）' },
    { port_code: 'SEN006', port_ch: '考拉克（塞内加尔）' },
    { port_code: 'SEN008', port_ch: '圣路易（塞内加尔）' },
    { port_code: 'SEN009', port_ch: '济金绍尔（塞内加尔）' },
    { port_code: 'SEN012', port_ch: '丰迪乌涅（塞内加尔）' },
    { port_code: 'SGP000', port_ch: '新加坡' },
    { port_code: 'SGP001', port_ch: '普劳艾亚却文（新加坡）' },
    { port_code: 'SGP003', port_ch: '裕廊（新加坡）' },
    { port_code: 'SGP004', port_ch: '普劳萨巴洛克（新加坡）' },
    { port_code: 'SGP005', port_ch: '丹戎巴葛（新加坡）' },
    { port_code: 'SGP006', port_ch: '普劳布科姆（新加坡）' },
    { port_code: 'SGP009', port_ch: '森巴旺（新加坡）' },
    { port_code: 'SGP012', port_ch: '新加坡（新加坡）' },
    { port_code: 'SGP015', port_ch: '丹章彭鲁（新加坡）' },
    { port_code: 'SGS000', port_ch: '南乔治亚岛和南桑德韦奇岛' },
    { port_code: 'SHN000', port_ch: '圣赫勒拿' },
    { port_code: 'SHN003', port_ch: '乔治敦（圣赫勒拿）' },
    { port_code: 'SHN006', port_ch: '詹姆斯敦（圣赫勒拿）' },
    { port_code: 'SJM000', port_ch: '斯瓦巴德群岛' },
    { port_code: 'SLB000', port_ch: '所罗门群岛' },
    { port_code: 'SLB001', port_ch: 'LOLAHO（所罗门群岛）' },
    { port_code: 'SLB002', port_ch: '安诺瓦湾（所罗门群岛）' },
    { port_code: 'SLB003', port_ch: '阿拉迪斯港（所罗门群岛）' },
    { port_code: 'SLB004', port_ch: '奥基（所罗门群岛）' },
    { port_code: 'SLB006', port_ch: '吉佐（所罗门群岛）' },
    { port_code: 'SLB009', port_ch: '霍尼亚拉（所罗门群岛）' },
    { port_code: 'SLB012', port_ch: '诺鲁（所罗门群岛）' },
    { port_code: 'SLB015', port_ch: '林吉科弗（所罗门群岛）' },
    { port_code: 'SLB018', port_ch: '肖特兰岛（所罗门群岛）' },
    { port_code: 'SLB021', port_ch: '图拉吉（所罗门群岛）' },
    { port_code: 'SLB024', port_ch: '扬迪纳（所罗门群岛）' },
    { port_code: 'SLE000', port_ch: '塞拉利昂' },
    { port_code: 'SLE002', port_ch: '邦特（塞拉利昂）' },
    { port_code: 'SLE003', port_ch: '弗里敦（塞拉利昂）' },
    { port_code: 'SLE006', port_ch: '佩佩尔（塞拉利昂）' },
    { port_code: 'SLE009', port_ch: '歇尔布罗岛（塞拉利昂）' },
    { port_code: 'SLV000', port_ch: '萨尔瓦多' },
    { port_code: 'SLV003', port_ch: '阿卡胡特拉（萨尔瓦多）' },
    { port_code: 'SLV006', port_ch: '库图科（萨尔瓦多）' },
    { port_code: 'SLV009', port_ch: '拉利贝塔德（萨尔瓦多）' },
    { port_code: 'SLV012', port_ch: '拉乌尼翁（萨尔瓦多）' },
    { port_code: 'SMR000', port_ch: '圣马力诺' },
    { port_code: 'SMR001', port_ch: '圣马力诺（圣马力诺）' },
    { port_code: 'SOM000', port_ch: '索马里' },
    { port_code: 'SOM003', port_ch: '阿鲁拉（索马里）' },
    { port_code: 'SOM006', port_ch: '柏培拉（索马里）' },
    { port_code: 'SOM009', port_ch: '博萨索（索马里）' },
    { port_code: 'SOM012', port_ch: '布拉瓦（索马里）' },
    { port_code: 'SOM015', port_ch: '丹特（索马里）' },
    { port_code: 'SOM018', port_ch: '基斯马尤（索马里）' },
    { port_code: 'SOM021', port_ch: '马尔卡（索马里）' },
    { port_code: 'SOM024', port_ch: '摩加迪沙（索马里）' },
    { port_code: 'SOM027', port_ch: '奥比亚（索马里）' },
    { port_code: 'SPM000', port_ch: '圣皮埃尔和密克隆' },
    { port_code: 'SPM003', port_ch: '圣皮埃尔（圣皮埃尔和密克隆）' },
    { port_code: 'SRB000', port_ch: '塞尔维亚共和国' },
    { port_code: 'SRB003', port_ch: '巴尔（塞尔维亚共和国）' },
    { port_code: 'SRB006', port_ch: '科托尔（塞尔维亚共和国）' },
    { port_code: 'SRB009', port_ch: '泽莱尼卡（塞尔维亚共和国）' },
    { port_code: 'SRB012', port_ch: '杰姆斯敦（塞尔维亚共和国）' },
    { port_code: 'SSD000', port_ch: '南苏丹' },
    { port_code: 'STP000', port_ch: '圣多美和普林西比' },
    { port_code: 'STP003', port_ch: '普林西比岛（圣多美和普林西比）' },
    { port_code: 'STP006', port_ch: '圣多美（圣多美和普林西比）' },
    { port_code: 'SUR000', port_ch: '苏里南' },
    { port_code: 'SUR003', port_ch: '蒙戈（苏里南）' },
    { port_code: 'SUR006', port_ch: '帕拉马里博（苏里南）' },
    { port_code: 'SUR009', port_ch: '帕拉南（苏里南）' },
    { port_code: 'SUR012', port_ch: '斯马卡尔登（苏里南）' },
    { port_code: 'SUR015', port_ch: '瓦黑宁恩（苏里南）' },
    { port_code: 'SUR016', port_ch: '新尼克里（苏里南）' },
    { port_code: 'SVK000', port_ch: '斯洛伐克' },
    { port_code: 'SVK001', port_ch: 'PRAHA（斯洛伐克）' },
    { port_code: 'SVN000', port_ch: '斯洛文尼亚' },
    { port_code: 'SVN002', port_ch: '卢布尔雅那（斯洛文尼亚）' },
    { port_code: 'SVN003', port_ch: '伊佐拉（斯洛文尼亚）' },
    { port_code: 'SVN006', port_ch: '科佩尔（斯洛文尼亚）' },
    { port_code: 'SVN009', port_ch: '皮兰（斯洛文尼亚）' },
    { port_code: 'SWE000', port_ch: '瑞典' },
    { port_code: 'SWE003', port_ch: '奥胡斯（瑞典）' },
    { port_code: 'SWE006', port_ch: '阿拉（瑞典）' },
    { port_code: 'SWE009', port_ch: '阿尔博加（瑞典）' },
    { port_code: 'SWE012', port_ch: '博里霍尔姆（瑞典）' },
    { port_code: 'SWE015', port_ch: '布罗夫约尔丹（瑞典）' },
    { port_code: 'SWE018', port_ch: '布雷奥（瑞典）' },
    { port_code: 'SWE021', port_ch: '达拉勒（瑞典）' },
    { port_code: 'SWE024', port_ch: '代格港（瑞典）' },
    { port_code: 'SWE027', port_ch: '杜姆舍（瑞典）' },
    { port_code: 'SWE030', port_ch: '恩雪平（瑞典）' },
    { port_code: 'SWE033', port_ch: '法尔肯贝里（瑞典）' },
    { port_code: 'SWE036', port_ch: '福勒松德（瑞典）' },
    { port_code: 'SWE039', port_ch: '耶夫勒（瑞典）' },
    { port_code: 'SWE042', port_ch: '哥德堡（瑞典）' },
    { port_code: 'SWE045', port_ch: '哈尔斯塔维克（瑞典）' },
    { port_code: 'SWE048', port_ch: '哈尔姆斯塔德（瑞典）' },
    { port_code: 'SWE051', port_ch: '哈帕兰达（瑞典）' },
    { port_code: 'SWE054', port_ch: '哈拉霍尔梅（瑞典）' },
    { port_code: 'SWE057', port_ch: '哈里港（瑞典）' },
    { port_code: 'SWE063', port_ch: '赫尔辛堡（瑞典）' },
    { port_code: 'SWE066', port_ch: '海讷桑德（瑞典）' },
    { port_code: 'SWE069', port_ch: '赫加奈斯（瑞典）' },
    { port_code: 'SWE072', port_ch: '霍尔姆松德（瑞典）' },
    { port_code: 'SWE075', port_ch: '霍讷福什（瑞典）' },
    { port_code: 'SWE078', port_ch: '胡迪克斯瓦尔（瑞典）' },
    { port_code: 'SWE081', port_ch: '胡苏姆（瑞典）' },
    { port_code: 'SWE084', port_ch: '伊格松德（瑞典）' },
    { port_code: 'SWE087', port_ch: '延雪平（瑞典）' },
    { port_code: 'SWE090', port_ch: '卡利克斯（瑞典）' },
    { port_code: 'SWE093', port_ch: '卡尔马（瑞典）' },
    { port_code: 'SWE096', port_ch: '卡尔斯堡（瑞典）' },
    { port_code: 'SWE099', port_ch: '卡尔斯港（瑞典）' },
    { port_code: 'SWE102', port_ch: '卡尔斯克鲁纳（瑞典）' },
    { port_code: 'SWE105', port_ch: '卡尔斯塔德（瑞典）' },
    { port_code: 'SWE108', port_ch: '卡斯卡（瑞典）' },
    { port_code: 'SWE111', port_ch: '克拉格斯港（瑞典）' },
    { port_code: 'SWE114', port_ch: '克林特港（瑞典）' },
    { port_code: 'SWE117', port_ch: '雪平（瑞典）' },
    { port_code: 'SWE120', port_ch: '克拉姆福什（瑞典）' },
    { port_code: 'SWE123', port_ch: '克里斯蒂娜港（瑞典）' },
    { port_code: 'SWE126', port_ch: '兰斯克鲁纳（瑞典）' },
    { port_code: 'SWE129', port_ch: '利德雪平（瑞典）' },
    { port_code: 'SWE132', port_ch: '利姆港（瑞典）' },
    { port_code: 'SWE135', port_ch: '于斯讷（瑞典）' },
    { port_code: 'SWE138', port_ch: '卢马（瑞典）' },
    { port_code: 'SWE141', port_ch: '吕勒奥（瑞典）' },
    { port_code: 'SWE144', port_ch: '吕瑟希尔（瑞典）' },
    { port_code: 'SWE147', port_ch: '马尔默（瑞典）' },
    { port_code: 'SWE150', port_ch: '马斯特兰德（瑞典）' },
    { port_code: 'SWE153', port_ch: '穆塔拉（瑞典）' },
    { port_code: 'SWE156', port_ch: '诺尔雪平（瑞典）' },
    { port_code: 'SWE159', port_ch: '诺尔松德（瑞典）' },
    { port_code: 'SWE162', port_ch: '尼雪平（瑞典）' },
    { port_code: 'SWE165', port_ch: '尼奈斯港（瑞典）' },
    { port_code: 'SWE168', port_ch: '瓦克森（瑞典）' },
    { port_code: 'SWE171', port_ch: '恩舍尔兹维克（瑞典）' },
    { port_code: 'SWE174', port_ch: '奥斯卡港（瑞典）' },
    { port_code: 'SWE177', port_ch: '乌特拜肯（瑞典）' },
    { port_code: 'SWE180', port_ch: '乌克瑟勒松德（瑞典）' },
    { port_code: 'SWE183', port_ch: '波斯卡拉维克（瑞典）' },
    { port_code: 'SWE186', port_ch: '帕塔霍尔姆（瑞典）' },
    { port_code: 'SWE189', port_ch: '皮特奥（瑞典）' },
    { port_code: 'SWE192', port_ch: '鲁讷港（瑞典）' },
    { port_code: 'SWE195', port_ch: '尤讷比港（瑞典）' },
    { port_code: 'SWE198', port_ch: '桑达讷（瑞典）' },
    { port_code: 'SWE201', port_ch: '桑德维肯（瑞典）' },
    { port_code: 'SWE204', port_ch: '锡克奥（瑞典）' },
    { port_code: 'SWE207', port_ch: '锡姆里斯港（瑞典）' },
    { port_code: 'SWE210', port_ch: '谢莱夫特奥（瑞典）' },
    { port_code: 'SWE213', port_ch: '谢莱夫特港（瑞典）' },
    { port_code: 'SWE216', port_ch: '斯库格哈尔（瑞典）' },
    { port_code: 'SWE219', port_ch: '斯克雷特维克（瑞典）' },
    { port_code: 'SWE222', port_ch: '斯屈特谢尔（瑞典）' },
    { port_code: 'SWE225', port_ch: '斯利特（瑞典）' },
    { port_code: 'SWE228', port_ch: '瑟德港（瑞典）' },
    { port_code: 'SWE231', port_ch: '南雪平（瑞典）' },
    { port_code: 'SWE234', port_ch: '南泰利耶（瑞典）' },
    { port_code: 'SWE237', port_ch: '瑟尔沃斯堡（瑞典）' },
    { port_code: 'SWE240', port_ch: '斯泰农松德（瑞典）' },
    { port_code: 'SWE243', port_ch: '斯德哥尔摩（瑞典）' },
    { port_code: 'SWE246', port_ch: '斯图龙恩斯（瑞典）' },
    { port_code: 'SWE249', port_ch: '斯特兰奈斯（瑞典）' },
    { port_code: 'SWE252', port_ch: '斯特伦斯塔德（瑞典）' },
    { port_code: 'SWE255', port_ch: '斯图格松德（瑞典）' },
    { port_code: 'SWE258', port_ch: '松兹瓦尔（瑞典）' },
    { port_code: 'SWE261', port_ch: '特勒（瑞典）' },
    { port_code: 'SWE264', port_ch: '特雷勒堡（瑞典）' },
    { port_code: 'SWE267', port_ch: '特罗尔海坦（瑞典）' },
    { port_code: 'SWE270', port_ch: '突亚多尔（瑞典）' },
    { port_code: 'SWE273', port_ch: '乌德瓦拉（瑞典）' },
    { port_code: 'SWE276', port_ch: '于默奥（瑞典）' },
    { port_code: 'SWE279', port_ch: '友丹佐（瑞典）' },
    { port_code: 'SWE282', port_ch: '瓦尔德马什维克（瑞典）' },
    { port_code: 'SWE285', port_ch: '瓦尔贝里（瑞典）' },
    { port_code: 'SWE288', port_ch: '维斯特拉斯（瑞典）' },
    { port_code: 'SWE291', port_ch: '维弗斯塔瓦夫（瑞典）' },
    { port_code: 'SWE294', port_ch: '维斯比（瑞典）' },
    { port_code: 'SWE297', port_ch: '瓦贾（瑞典）' },
    { port_code: 'SWE300', port_ch: '瓦尔港（瑞典）' },
    { port_code: 'SWE303', port_ch: '喔尔维尔（瑞典）' },
    { port_code: 'SWE306', port_ch: '韦斯特维克（瑞典）' },
    { port_code: 'SWE309', port_ch: '于斯塔德（瑞典）' },
    { port_code: 'SWE312', port_ch: 'HJO（瑞典）' },
    { port_code: 'SWE318', port_ch: '伦斯卡（瑞典）' },
    { port_code: 'SWE321', port_ch: '罗内比（瑞典）' },
    { port_code: 'SWE324', port_ch: '马里厄斯塔德（瑞典）' },
    { port_code: 'SWE330', port_ch: '散维克（瑞典）' },
    { port_code: 'SWE333', port_ch: '特罗尔黑特运河（瑞典）' },
    { port_code: 'SWE336', port_ch: '瓦尔维克（瑞典）' },
    { port_code: 'SWE339', port_ch: '韦纳斯堡（瑞典）' },
    { port_code: 'SWZ000', port_ch: '斯威士兰' },
    { port_code: 'SXM000', port_ch: '荷属圣马丁岛' },
    { port_code: 'SYC000', port_ch: '塞舌尔' },
    { port_code: 'SYC003', port_ch: '维多利亚港（塞舌尔）' },
    { port_code: 'SYC901', port_ch: '维多利亚（塞舌尔）' },
    { port_code: 'SYR000', port_ch: '叙利亚' },
    { port_code: 'SYR001', port_ch: '大马士革（叙利亚）' },
    { port_code: 'SYR003', port_ch: '巴尼亚斯（叙利亚）' },
    { port_code: 'SYR006', port_ch: '拉塔基亚（叙利亚）' },
    { port_code: 'SYR009', port_ch: '塔尔图斯（叙利亚）' },
    { port_code: 'TCA000', port_ch: '特克斯和凯科斯群岛' },
    { port_code: 'TCA003', port_ch: '大特克（特克斯和凯科斯群岛）' },
    { port_code: 'TCD000', port_ch: '乍得' },
    { port_code: 'TCD001', port_ch: 'ATI（乍得）' },
    { port_code: 'TGO000', port_ch: '多哥' },
    { port_code: 'TGO003', port_ch: '佩梅（多哥）' },
    { port_code: 'TGO006', port_ch: '洛美（多哥）' },
    { port_code: 'TGO009', port_ch: '小波波（多哥）' },
    { port_code: 'TGO012', port_ch: '阿内乔（多哥）' },
    { port_code: 'THA000', port_ch: '泰国' },
    { port_code: 'THA003', port_ch: '曼谷（泰国）' },
    { port_code: 'THA005', port_ch: '林查班（泰国）' },
    { port_code: 'THA006', port_ch: '干当（泰国）' },
    { port_code: 'THA009', port_ch: '锡昌岛（泰国）' },
    { port_code: 'THA012', port_ch: '那拉提瓦（泰国）' },
    { port_code: 'THA015', port_ch: '北榄（泰国）' },
    { port_code: 'THA018', port_ch: '北大年（泰国）' },
    { port_code: 'THA021', port_ch: '普吉（泰国）' },
    { port_code: 'THA024', port_ch: '棱桃邑（泰国）' },
    { port_code: 'THA027', port_ch: '是拉差（泰国）' },
    { port_code: 'THA030', port_ch: '宋卡（泰国）' },
    { port_code: 'THA033', port_ch: '斯瑞拉察（泰国）' },
    { port_code: 'THA036', port_ch: 'AYUTTHSYA（泰国）' },
    { port_code: 'TJK000', port_ch: '塔吉克斯坦' },
    { port_code: 'TJK901', port_ch: '卡拉苏（塔吉克斯坦）' },
    { port_code: 'TKL000', port_ch: '托克劳' },
    { port_code: 'TKL003', port_ch: '阿塔富（托克劳）' },
    { port_code: 'TKL004', port_ch: '托克劳群岛（托克劳）' },
    { port_code: 'TKM000', port_ch: '土库曼斯坦' },
    { port_code: 'TLS000', port_ch: '东帝汶' },
    { port_code: 'TLS003', port_ch: '帝力（东帝汶）' },
    { port_code: 'TON000', port_ch: '汤加' },
    { port_code: 'TON003', port_ch: '内亚富（汤加）' },
    { port_code: 'TON006', port_ch: '诺穆卡岛（汤加）' },
    { port_code: 'TON009', port_ch: '努库阿洛法（汤加）' },
    { port_code: 'TON012', port_ch: '庞艾（汤加）' },
    { port_code: 'TON015', port_ch: '瓦瓦乌岛（汤加）' },
    { port_code: 'TTO000', port_ch: '特立尼达和多巴哥' },
    { port_code: 'TTO003', port_ch: '布赖顿（特立尼达和多巴哥）' },
    { port_code: 'TTO006', port_ch: '查瓜拉马斯（特立尼达和多巴哥）' },
    { port_code: 'TTO009', port_ch: '加莱奥塔角（特立尼达和多巴哥）' },
    { port_code: 'TTO012', port_ch: '普利茅斯（特立尼达和多巴哥）' },
    { port_code: 'TTO015', port_ch: '福廷角（特立尼达和多巴哥）' },
    { port_code: 'TTO018', port_ch: '利萨斯角（特立尼达和多巴哥）' },
    { port_code: 'TTO021', port_ch: '皮埃尔角城（特立尼达和多巴哥）' },
    { port_code: 'TTO024', port_ch: '西班牙港（特立尼达和多巴哥）' },
    { port_code: 'TTO027', port_ch: '圣费尔南多（特立尼达和多巴哥）' },
    { port_code: 'TTO030', port_ch: '斯卡伯勒（特立尼达和多巴哥）' },
    { port_code: 'TTO033', port_ch: '滕布拉多腊（特立尼达和多巴哥）' },
    { port_code: 'TUN000', port_ch: '突尼斯' },
    { port_code: 'TUN003', port_ch: '阿什塔特码头（突尼斯）' },
    { port_code: 'TUN006', port_ch: '比塞大（突尼斯）' },
    { port_code: 'TUN009', port_ch: '杰尔巴岛（突尼斯）' },
    { port_code: 'TUN012', port_ch: '加贝斯（突尼斯）' },
    { port_code: 'TUN015', port_ch: '拉古莱特（突尼斯）' },
    { port_code: 'TUN018', port_ch: '拉斯基拉（突尼斯）' },
    { port_code: 'TUN021', port_ch: '斯法克斯（突尼斯）' },
    { port_code: 'TUN024', port_ch: '苏塞（突尼斯）' },
    { port_code: 'TUN027', port_ch: '突尼斯（突尼斯）' },
    { port_code: 'TUR000', port_ch: '土耳其' },
    { port_code: 'TUR003', port_ch: '阿拉尼亚（土耳其）' },
    { port_code: 'TUR006', port_ch: '阿利亚加（土耳其）' },
    { port_code: 'TUR009', port_ch: '阿马斯腊（土耳其）' },
    { port_code: 'TUR012', port_ch: '安塔利亚（土耳其）' },
    { port_code: 'TUR015', port_ch: '艾瓦勒克（土耳其）' },
    { port_code: 'TUR018', port_ch: '班德尔马（土耳其）' },
    { port_code: 'TUR021', port_ch: '恰纳卡莱（土耳其）' },
    { port_code: 'TUR024', port_ch: '吉代（土耳其）' },
    { port_code: 'TUR027', port_ch: '代林杰（土耳其）' },
    { port_code: 'TUR030', port_ch: '迪基利（土耳其）' },
    { port_code: 'TUR033', port_ch: '德尔特约尔（土耳其）' },
    { port_code: 'TUR036', port_ch: '埃丁吉克（土耳其）' },
    { port_code: 'TUR039', port_ch: '埃雷利（土耳其）' },
    { port_code: 'TUR042', port_ch: '法特萨（土耳其）' },
    { port_code: 'TUR045', port_ch: '费特希耶（土耳其）' },
    { port_code: 'TUR048', port_ch: '菲尼凯（土耳其）' },
    { port_code: 'TUR051', port_ch: '盖利博卢（土耳其）' },
    { port_code: 'TUR054', port_ch: '盖姆利克（土耳其）' },
    { port_code: 'TUR057', port_ch: '吉雷松（土耳其）' },
    { port_code: 'TUR060', port_ch: '戈西克（土耳其）' },
    { port_code: 'TUR063', port_ch: '格尔居克（土耳其）' },
    { port_code: 'TUR066', port_ch: '格雷莱（土耳其）' },
    { port_code: 'TUR069', port_ch: '居吕克（土耳其）' },
    { port_code: 'TUR072', port_ch: '海达尔帕夏（土耳其）' },
    { port_code: 'TUR075', port_ch: '海雷凯（土耳其）' },
    { port_code: 'TUR078', port_ch: '霍帕（土耳其）' },
    { port_code: 'TUR081', port_ch: '伊内博卢（土耳其）' },
    { port_code: 'TUR084', port_ch: '伊斯肯德伦（土耳其）' },
    { port_code: 'TUR087', port_ch: '伊斯坦布尔（土耳其）' },
    { port_code: 'TUR090', port_ch: '伊兹密尔（土耳其）' },
    { port_code: 'TUR093', port_ch: '伊兹米特（土耳其）' },
    { port_code: 'TUR096', port_ch: '库沙达瑟（土耳其）' },
    { port_code: 'TUR099', port_ch: '马尔马里斯（土耳其）' },
    { port_code: 'TUR102', port_ch: '梅尔辛（土耳其）' },
    { port_code: 'TUR105', port_ch: '穆达尼亚（土耳其）' },
    { port_code: 'TUR108', port_ch: '奥尔杜（土耳其）' },
    { port_code: 'TUR111', port_ch: '里泽（土耳其）' },
    { port_code: 'TUR114', port_ch: '萨姆松（土耳其）' },
    { port_code: 'TUR117', port_ch: '锡诺普（土耳其）' },
    { port_code: 'TUR120', port_ch: '塔舒朱（土耳其）' },
    { port_code: 'TUR123', port_ch: '泰基尔达（土耳其）' },
    { port_code: 'TUR126', port_ch: '蒂雷博卢（土耳其）' },
    { port_code: 'TUR129', port_ch: '特拉布宗（土耳其）' },
    { port_code: 'TUR132', port_ch: '图吞西夫特利克（土耳其）' },
    { port_code: 'TUR135', port_ch: '云耶（土耳其）' },
    { port_code: 'TUR138', port_ch: '于斯屈达尔（土耳其）' },
    { port_code: 'TUR141', port_ch: '亚勒姆贾（土耳其）' },
    { port_code: 'TUR144', port_ch: '宗古尔达克（土耳其）' },
    { port_code: 'TUR147', port_ch: '阿达比亚（土耳其）' },
    { port_code: 'TUR150', port_ch: '澳纳（土耳其）' },
    { port_code: 'TUR153', port_ch: '地里斯凯里斯（土耳其）' },
    { port_code: 'TUR156', port_ch: '卡拉（土耳其）' },
    { port_code: 'TUR159', port_ch: '开塞利（土耳其）' },
    { port_code: 'TUR162', port_ch: '特拉帕尼（土耳其）' },
    { port_code: 'TUV000', port_ch: '图瓦卢' },
    { port_code: 'TUV001', port_ch: '纳努梅阿岛（图瓦卢）' },
    { port_code: 'TUV002', port_ch: '努库费塔乌岛（图瓦卢）' },
    { port_code: 'TUV003', port_ch: '富纳富提（图瓦卢）' },
    { port_code: 'TWN000', port_ch: '中国台湾' },
    { port_code: 'TWN103', port_ch: '台北（中国台湾）' },
    { port_code: 'TWN107', port_ch: '基隆（中国台湾）' },
    { port_code: 'TWN114', port_ch: '苏奥（中国台湾）' },
    { port_code: 'TWN121', port_ch: '花莲（中国台湾）' },
    { port_code: 'TWN128', port_ch: '高雄（中国台湾）' },
    { port_code: 'TWN135', port_ch: '台南（中国台湾）' },
    { port_code: 'TWN142', port_ch: '澎湖（中国台湾）' },
    { port_code: 'TWN149', port_ch: '台中（中国台湾）' },
    { port_code: 'TZA000', port_ch: '坦桑尼亚' },
    { port_code: 'TZA003', port_ch: '达累斯萨拉姆（坦桑尼亚）' },
    { port_code: 'TZA006', port_ch: '基卢瓦基温杰（坦桑尼亚）' },
    { port_code: 'TZA009', port_ch: '基卢瓦马索科（坦桑尼亚）' },
    { port_code: 'TZA012', port_ch: '林迪（坦桑尼亚）' },
    { port_code: 'TZA015', port_ch: '米金达尼（坦桑尼亚）' },
    { port_code: 'TZA018', port_ch: '姆特瓦拉（坦桑尼亚）' },
    { port_code: 'TZA021', port_ch: '潘加尼（坦桑尼亚）' },
    { port_code: 'TZA024', port_ch: '奔巴岛（坦桑尼亚）' },
    { port_code: 'TZA027', port_ch: '坦噶（坦桑尼亚）' },
    { port_code: 'TZA030', port_ch: '桑给巴尔岛（坦桑尼亚）' },
    { port_code: 'UGA000', port_ch: '乌干达' },
    { port_code: 'UKR000', port_ch: '乌克兰' },
    { port_code: 'UKR003', port_ch: '别尔哥罗德德涅斯罗夫（乌克兰）' },
    { port_code: 'UKR006', port_ch: '别尔江斯克（乌克兰）' },
    { port_code: 'UKR009', port_ch: '伊利乔夫斯克（乌克兰）' },
    { port_code: 'UKR012', port_ch: '伊兹梅尔（乌克兰）' },
    { port_code: 'UKR015', port_ch: '刻赤（乌克兰）' },
    { port_code: 'UKR018', port_ch: '赫尔松（乌克兰）' },
    { port_code: 'UKR020', port_ch: '马里乌波尔（乌克兰）' },
    { port_code: 'UKR021', port_ch: '基里拉（乌克兰）' },
    { port_code: 'UKR024', port_ch: '尼古拉耶夫（乌克兰）' },
    { port_code: 'UKR027', port_ch: '敖德萨（乌克兰）' },
    { port_code: 'UKR030', port_ch: '烈尼（乌克兰）' },
    { port_code: 'UKR033', port_ch: '塞瓦斯托波尔（乌克兰）' },
    { port_code: 'UKR036', port_ch: '斯卡多夫斯克（乌克兰）' },
    { port_code: 'UKR039', port_ch: '费奥多西亚（乌克兰）' },
    { port_code: 'UKR042', port_ch: '乌斯列戈尔斯克（乌克兰）' },
    { port_code: 'UKR045', port_ch: '雅尔塔（乌克兰）' },
    { port_code: 'UKR048', port_ch: '尤日内（乌克兰）' },
    { port_code: 'UMI000', port_ch: '美国本土外小岛屿' },
    { port_code: 'UMI003', port_ch: '希洛（美国本土外小岛屿）' },
    { port_code: 'UMI006', port_ch: '火奴鲁鲁（美国本土外小岛屿）' },
    { port_code: 'UMI009', port_ch: '卡胡卢伊（美国本土外小岛屿）' },
    { port_code: 'UMI012', port_ch: '纳威利威利（美国本土外小岛屿）' },
    { port_code: 'UMI013', port_ch: '巴尔米拉岛（美国本土外小岛屿）' },
    { port_code: 'UMI014', port_ch: '威克岛（美国本土外小岛屿）' },
    { port_code: 'UMI015', port_ch: '约翰斯顿岛（美国本土外小岛屿）' },
    { port_code: 'UMI016', port_ch: '中途岛（美国本土外小岛屿）' },
    { port_code: 'URY000', port_ch: '乌拉圭' },
    { port_code: 'URY003', port_ch: '科洛尼亚（乌拉圭）' },
    { port_code: 'URY006', port_ch: '弗赖本托斯（乌拉圭）' },
    { port_code: 'URY009', port_ch: '何塞伊格纳西奥（乌拉圭）' },
    { port_code: 'URY012', port_ch: '马尔多纳多（乌拉圭）' },
    { port_code: 'URY015', port_ch: '蒙得维的亚（乌拉圭）' },
    { port_code: 'URY018', port_ch: '新帕尔米拉（乌拉圭）' },
    { port_code: 'URY021', port_ch: '派桑杜（乌拉圭）' },
    { port_code: 'URY024', port_ch: '埃斯特角（乌拉圭）' },
    { port_code: 'USA000', port_ch: '美国' },
    { port_code: 'USA003', port_ch: '阿伯丁（美国）' },
    { port_code: 'USA006', port_ch: '阿拉梅达（美国）' },
    { port_code: 'USA008', port_ch: '亚当斯顿（美国）' },
    { port_code: 'USA009', port_ch: '奥尔巴尼（美国）' },
    { port_code: 'USA012', port_ch: '亚历山德里亚（美国）' },
    { port_code: 'USA015', port_ch: '阿尔皮纳（美国）' },
    { port_code: 'USA018', port_ch: '阿纳科特斯（美国）' },
    { port_code: 'USA021', port_ch: '安科雷奇（美国）' },
    { port_code: 'USA024', port_ch: '阿巴拉契科拉（美国）' },
    { port_code: 'USA027', port_ch: '阿什兰（美国）' },
    { port_code: 'USA030', port_ch: '阿什塔比拉（美国）' },
    { port_code: 'USA033', port_ch: '阿斯托里亚（美国）' },
    { port_code: 'USA036', port_ch: '阿特雷科（美国）' },
    { port_code: 'USA039', port_ch: '巴尔的摩（美国）' },
    { port_code: 'USA042', port_ch: '班戈（美国）' },
    { port_code: 'USA045', port_ch: '巴斯（美国）' },
    { port_code: 'USA048', port_ch: '巴吞鲁日（美国）' },
    { port_code: 'USA051', port_ch: '贝敦（美国）' },
    { port_code: 'USA054', port_ch: '博蒙特（美国）' },
    { port_code: 'USA057', port_ch: '贝灵哈姆（美国）' },
    { port_code: 'USA060', port_ch: '伯克利（美国）' },
    { port_code: 'USA063', port_ch: '波卡洛兰德（美国）' },
    { port_code: 'USA066', port_ch: '波士顿（美国）' },
    { port_code: 'USA069', port_ch: '布雷默顿（美国）' },
    { port_code: 'USA072', port_ch: '布里奇波特（美国）' },
    { port_code: 'USA075', port_ch: '布朗斯维尔（美国）' },
    { port_code: 'USA078', port_ch: '不伦瑞克（美国）' },
    { port_code: 'USA081', port_ch: '布坎南（美国）' },
    { port_code: 'USA084', port_ch: '巴克斯波特（美国）' },
    { port_code: 'USA087', port_ch: '布法罗（美国）' },
    { port_code: 'USA090', port_ch: '伯恩斯港（美国）' },
    { port_code: 'USA093', port_ch: '伯恩赛德（美国）' },
    { port_code: 'USA096', port_ch: '剑桥（美国）' },
    { port_code: 'USA099', port_ch: '卡姆登（美国）' },
    { port_code: 'USA102', port_ch: '卡拉贝尔（美国）' },
    { port_code: 'USA105', port_ch: '查尔斯顿（美国）' },
    { port_code: 'USA108', port_ch: '希博伊甘（美国）' },
    { port_code: 'USA111', port_ch: '切萨皮克城（美国）' },
    { port_code: 'USA114', port_ch: '切斯特（美国）' },
    { port_code: 'USA117', port_ch: '芝加哥（美国）' },
    { port_code: 'USA120', port_ch: '克利夫兰（美国）' },
    { port_code: 'USA123', port_ch: '康尼奥特港（美国）' },
    { port_code: 'USA126', port_ch: '科尔多瓦（美国）' },
    { port_code: 'USA129', port_ch: '科珀斯克里斯蒂（美国）' },
    { port_code: 'USA132', port_ch: '德拉华湾（美国）' },
    { port_code: 'USA135', port_ch: '特斯特汉（美国）' },
    { port_code: 'USA138', port_ch: '底特律（美国）' },
    { port_code: 'USA141', port_ch: '唐纳森维尔（美国）' },
    { port_code: 'USA144', port_ch: '德卢斯（美国）' },
    { port_code: 'USA147', port_ch: '荷兰港（美国）' },
    { port_code: 'USA150', port_ch: '埃尔塞贡多（美国）' },
    { port_code: 'USA153', port_ch: '伊利（美国）' },
    { port_code: 'USA156', port_ch: '尤里卡（美国）' },
    { port_code: 'USA159', port_ch: '埃弗里特（美国）' },
    { port_code: 'USA162', port_ch: '福尔里弗（美国）' },
    { port_code: 'USA165', port_ch: '费南迪纳（美国）' },
    { port_code: 'USA168', port_ch: '芬代尔（美国）' },
    { port_code: 'USA171', port_ch: '弗里波特（美国）' },
    { port_code: 'USA174', port_ch: '加尔维斯顿（美国）' },
    { port_code: 'USA177', port_ch: '盖斯马（美国）' },
    { port_code: 'USA180', port_ch: '乔治敦（美国）' },
    { port_code: 'USA183', port_ch: '格洛斯特（美国）' },
    { port_code: 'USA186', port_ch: '好望角（美国）' },
    { port_code: 'USA189', port_ch: '格拉梅西（美国）' },
    { port_code: 'USA192', port_ch: '格兰德黑文（美国）' },
    { port_code: 'USA195', port_ch: '格雷斯港（美国）' },
    { port_code: 'USA198', port_ch: '格林贝（美国）' },
    { port_code: 'USA201', port_ch: '格尔夫波特（美国）' },
    { port_code: 'USA204', port_ch: '汉普顿港群（美国）' },
    { port_code: 'USA207', port_ch: '霍姆（美国）' },
    { port_code: 'USA210', port_ch: '荷马（美国）' },
    { port_code: 'USA213', port_ch: '霍普韦尔（美国）' },
    { port_code: 'USA215', port_ch: '火奴鲁路（美国）' },
    { port_code: 'USA216', port_ch: '休斯敦（美国）' },
    { port_code: 'USA219', port_ch: '休伦（美国）' },
    { port_code: 'USA222', port_ch: '杰克逊维尔（美国）' },
    { port_code: 'USA225', port_ch: '泽西城（美国）' },
    { port_code: 'USA228', port_ch: '朱诺（美国）' },
    { port_code: 'USA231', port_ch: '卡拉马（美国）' },
    { port_code: 'USA234', port_ch: '克奈（美国）' },
    { port_code: 'USA237', port_ch: '基诺沙（美国）' },
    { port_code: 'USA240', port_ch: '凯奇坎（美国）' },
    { port_code: 'USA243', port_ch: '基韦斯特（美国）' },
    { port_code: 'USA246', port_ch: '金斯湾（美国）' },
    { port_code: 'USA249', port_ch: '科迪亚克（美国）' },
    { port_code: 'USA251', port_ch: '简斯维尔（美国）' },
    { port_code: 'USA252', port_ch: '莱克查尔斯（美国）' },
    { port_code: 'USA255', port_ch: '长滩（美国）' },
    { port_code: 'USA258', port_ch: '隆维尤（美国）' },
    { port_code: 'USA261', port_ch: '洛雷恩（美国）' },
    { port_code: 'USA264', port_ch: '洛杉矶（美国）' },
    { port_code: 'USA267', port_ch: '马尼托沃克（美国）' },
    { port_code: 'USA270', port_ch: '梅特拉卡特拉（美国）' },
    { port_code: 'USA273', port_ch: '迈阿密（美国）' },
    { port_code: 'USA276', port_ch: '蜜尔沃基（美国）' },
    { port_code: 'USA279', port_ch: '莫比尔（美国）' },
    { port_code: 'USA282', port_ch: '门罗（美国）' },
    { port_code: 'USA285', port_ch: '莫尔黑德城（美国）' },
    { port_code: 'USA288', port_ch: '马斯基根（美国）' },
    { port_code: 'USA291', port_ch: '默特尔克里克（美国）' },
    { port_code: 'USA294', port_ch: '新贝德福德（美国）' },
    { port_code: 'USA297', port_ch: '纽卡斯尔（美国）' },
    { port_code: 'USA300', port_ch: '纽黑文（美国）' },
    { port_code: 'USA303', port_ch: '新伦敦（美国）' },
    { port_code: 'USA306', port_ch: '新奥尔良（美国）' },
    { port_code: 'USA309', port_ch: '纽约（美国）' },
    { port_code: 'USA312', port_ch: '纽瓦克（美国）' },
    { port_code: 'USA315', port_ch: '纽波特纽斯（美国）' },
    { port_code: 'USA318', port_ch: '纽波特（Oreg.）（美国）' },
    { port_code: 'USA321', port_ch: '纽波特（R.I.）（美国）' },
    { port_code: 'USA324', port_ch: '尼基斯基（美国）' },
    { port_code: 'USA327', port_ch: '诺姆（美国）' },
    { port_code: 'USA330', port_ch: '诺福克（美国）' },
    { port_code: 'USA333', port_ch: '诺思贝（美国）' },
    { port_code: 'USA336', port_ch: '奥克兰（美国）' },
    { port_code: 'USA339', port_ch: '奥林匹亚（美国）' },
    { port_code: 'USA342', port_ch: '奥兰治（美国）' },
    { port_code: 'USA345', port_ch: '奥斯特里卡（美国）' },
    { port_code: 'USA348', port_ch: '奥斯威戈（美国）' },
    { port_code: 'USA351', port_ch: '棕榈滩（美国）' },
    { port_code: 'USA354', port_ch: '巴拿马城（美国）' },
    { port_code: 'USA357', port_ch: '帕萨迪纳（美国）' },
    { port_code: 'USA360', port_ch: '帕斯卡古拉（美国）' },
    { port_code: 'USA363', port_ch: '保罗斯伯罗（美国）' },
    { port_code: 'USA366', port_ch: '彭萨科拉（美国）' },
    { port_code: 'USA369', port_ch: '彼得斯堡（美国）' },
    { port_code: 'USA372', port_ch: '费城（美国）' },
    { port_code: 'USA375', port_ch: '皮内角（美国）' },
    { port_code: 'USA378', port_ch: '普列茅斯（美国）' },
    { port_code: 'USA381', port_ch: '奥巴斯克斯港（美国）' },
    { port_code: 'USA384', port_ch: '亚当斯港（美国）' },
    { port_code: 'USA387', port_ch: '安吉利斯港（美国）' },
    { port_code: 'USA390', port_ch: '阿瑟港（美国）' },
    { port_code: 'USA393', port_ch: '卡纳维拉尔港（美国）' },
    { port_code: 'USA396', port_ch: '埃弗格雷斯港（美国）' },
    { port_code: 'USA399', port_ch: '怀尼米港（美国）' },
    { port_code: 'USA402', port_ch: '休伦港（美国）' },
    { port_code: 'USA405', port_ch: '伊萨贝尔港（美国）' },
    { port_code: 'USA408', port_ch: '拉瓦卡港（美国）' },
    { port_code: 'USA411', port_ch: '内奇斯港（美国）' },
    { port_code: 'USA414', port_ch: '罗亚尔港（美国）' },
    { port_code: 'USA417', port_ch: '圣路易斯港（美国）' },
    { port_code: 'USA420', port_ch: '圣乔港（美国）' },
    { port_code: 'USA423', port_ch: '萨尔弗港（美国）' },
    { port_code: 'USA426', port_ch: '汤森港（美国）' },
    { port_code: 'USA429', port_ch: '波特兰（Me.）（美国）' },
    { port_code: 'USA432', port_ch: '波特兰（Oreg.）（美国）' },
    { port_code: 'USA435', port_ch: '波次茅斯（美国）' },
    { port_code: 'USA438', port_ch: '普罗维登斯（美国）' },
    { port_code: 'USA441', port_ch: '拉辛（美国）' },
    { port_code: 'USA444', port_ch: '里士满（VA）（美国）' },
    { port_code: 'USA447', port_ch: '里士满（OH）（美国）' },
    { port_code: 'USA450', port_ch: '里弗黑德（美国）' },
    { port_code: 'USA453', port_ch: '罗切斯特（美国）' },
    { port_code: 'USA456', port_ch: '萨宾（美国）' },
    { port_code: 'USA459', port_ch: '萨克拉门托（美国）' },
    { port_code: 'USA462', port_ch: '圣迭戈（美国）' },
    { port_code: 'USA465', port_ch: '圣弗朗西斯科（美国）' },
    { port_code: 'USA468', port_ch: '圣佩德罗（美国）' },
    { port_code: 'USA471', port_ch: '圣巴巴拉（美国）' },
    { port_code: 'USA474', port_ch: '圣克鲁斯（美国）' },
    { port_code: 'USA477', port_ch: '萨凡纳（美国）' },
    { port_code: 'USA480', port_ch: '锡斯波特（美国）' },
    { port_code: 'USA483', port_ch: '西雅图（美国）' },
    { port_code: 'USA486', port_ch: '苏厄德（美国）' },
    { port_code: 'USA489', port_ch: '锡特卡（美国）' },
    { port_code: 'USA492', port_ch: '斯卡圭（美国）' },
    { port_code: 'USA495', port_ch: '斯密斯布卢夫（美国）' },
    { port_code: 'USA498', port_ch: '圣彼得斯堡（美国）' },
    { port_code: 'USA501', port_ch: '斯托克顿（美国）' },
    { port_code: 'USA504', port_ch: '塔科马（美国）' },
    { port_code: 'USA507', port_ch: '塔科尼特港（美国）' },
    { port_code: 'USA510', port_ch: '坦帕（美国）' },
    { port_code: 'USA513', port_ch: '得克萨斯城（美国）' },
    { port_code: 'USA516', port_ch: '托莱多（美国）' },
    { port_code: 'USA519', port_ch: '特伦顿（美国）' },
    { port_code: 'USA522', port_ch: '瓦尔迪兹（美国）' },
    { port_code: 'USA525', port_ch: '温哥华（美国）' },
    { port_code: 'USA528', port_ch: '华盛顿（美国）' },
    { port_code: 'USA531', port_ch: '威霍肯（美国）' },
    { port_code: 'USA534', port_ch: '威拉帕（美国）' },
    { port_code: 'USA543', port_ch: '威尔明顿（美国）' },
    { port_code: 'USA546', port_ch: '兰格尔（美国）' },
    { port_code: 'USA905', port_ch: '亚特兰大（美国）' },
    { port_code: 'USA906', port_ch: '伯明翰（美国）' },
    { port_code: 'USA907', port_ch: '威士康辛（美国）' },
    { port_code: 'USA908', port_ch: '奥马哈（美国）' },
    { port_code: 'USA909', port_ch: '达拉斯-沃斯堡（美国）' },
    { port_code: 'USA910', port_ch: '孟菲斯（美国）' },
    { port_code: 'USA911', port_ch: '韦斯特维戈（美国）' },
    { port_code: 'USA912', port_ch: '珍珠港（美国）' },
    { port_code: 'USA913', port_ch: '亚库塔特（美国）' },
    { port_code: 'USA914', port_ch: '摩斯贝（美国）' },
    { port_code: 'USA915', port_ch: '马尼斯蒂（美国）' },
    { port_code: 'USA916', port_ch: '奥格登斯堡（美国）' },
    { port_code: 'USA917', port_ch: '阿鲁克鲁（美国）' },
    { port_code: 'USA918', port_ch: 'VAN BC（美国）' },
    { port_code: 'USA919', port_ch: 'COOSAW RIVER（美国）' },
    { port_code: 'USA920', port_ch: 'CHEAPEAKE（美国）' },
    { port_code: 'UZB000', port_ch: '乌兹别克斯坦' },
    { port_code: 'UZB003', port_ch: '塔什干（乌兹别克斯坦）' },
    { port_code: 'VAT000', port_ch: '梵蒂冈' },
    { port_code: 'VCT000', port_ch: '圣文森特和格林纳丁斯' },
    { port_code: 'VCT003', port_ch: '乔治敦（圣文森特和格林纳丁斯）' },
    { port_code: 'VCT006', port_ch: '金斯敦（圣文森特和格林纳丁斯）' },
    { port_code: 'VEN000', port_ch: '委内瑞拉' },
    { port_code: 'VEN003', port_ch: '阿穆艾（委内瑞拉）' },
    { port_code: 'VEN006', port_ch: '阿拉亚（委内瑞拉）' },
    { port_code: 'VEN009', port_ch: '巴查克罗（委内瑞拉）' },
    { port_code: 'VEN012', port_ch: '巴霍格兰德（委内瑞拉）' },
    { port_code: 'VEN015', port_ch: '卡维马斯（委内瑞拉）' },
    { port_code: 'VEN018', port_ch: '卡里皮托（委内瑞拉）' },
    { port_code: 'VEN021', port_ch: '卡鲁帕诺（委内瑞拉）' },
    { port_code: 'VEN024', port_ch: '奇奇里维切（委内瑞拉）' },
    { port_code: 'VEN027', port_ch: '玻利瓦尔城（委内瑞拉）' },
    { port_code: 'VEN030', port_ch: '科隆查（委内瑞拉）' },
    { port_code: 'VEN033', port_ch: '库马纳（委内瑞拉）' },
    { port_code: 'VEN036', port_ch: '埃尔乔雷（委内瑞拉）' },
    { port_code: 'VEN039', port_ch: '埃尔瓜马切（委内瑞拉）' },
    { port_code: 'VEN042', port_ch: '埃尔巴利托（委内瑞拉）' },
    { port_code: 'VEN045', port_ch: '埃尔塔布拉齐奥（委内瑞拉）' },
    { port_code: 'VEN048', port_ch: '关塔（委内瑞拉）' },
    { port_code: 'VEN051', port_ch: '关腊关沃（委内瑞拉）' },
    { port_code: 'VEN054', port_ch: '圭里亚（委内瑞拉）' },
    { port_code: 'VEN057', port_ch: '拉斯塔加达（委内瑞拉）' },
    { port_code: 'VEN060', port_ch: '拉瓜伊拉（委内瑞拉）' },
    { port_code: 'VEN063', port_ch: '拉萨利纳（委内瑞拉）' },
    { port_code: 'VEN066', port_ch: '马拉开波（委内瑞拉）' },
    { port_code: 'VEN069', port_ch: '马坦萨斯（委内瑞拉）' },
    { port_code: 'VEN072', port_ch: '莫龙（委内瑞拉）' },
    { port_code: 'VEN075', port_ch: '帕卢亚（委内瑞拉）' },
    { port_code: 'VEN078', port_ch: '帕马塔克亚尔（委内瑞拉）' },
    { port_code: 'VEN081', port_ch: '潘帕塔尔（委内瑞拉）' },
    { port_code: 'VEN084', port_ch: '佩蒂格来特（委内瑞拉）' },
    { port_code: 'VEN087', port_ch: '波拉马尔（委内瑞拉）' },
    { port_code: 'VEN090', port_ch: '耶罗港（委内瑞拉）' },
    { port_code: 'VEN093', port_ch: '拉克鲁斯港（委内瑞拉）' },
    { port_code: 'VEN096', port_ch: '卡贝略港（委内瑞拉）' },
    { port_code: 'VEN099', port_ch: '米兰达港（委内瑞拉）' },
    { port_code: 'VEN102', port_ch: '奥尔达斯港（委内瑞拉）' },
    { port_code: 'VEN105', port_ch: '苏克里港（委内瑞拉）' },
    { port_code: 'VEN108', port_ch: '篷塔卡尔东（委内瑞拉）' },
    { port_code: 'VEN111', port_ch: '库希略角（委内瑞拉）' },
    { port_code: 'VEN114', port_ch: '南帕尔马斯角（委内瑞拉）' },
    { port_code: 'VEN116', port_ch: '蓬塔-德彼德拉斯（委内瑞拉）' },
    { port_code: 'VEN117', port_ch: '圣费利克斯（委内瑞拉）' },
    { port_code: 'VEN120', port_ch: '圣洛伦索（委内瑞拉）' },
    { port_code: 'VEN123', port_ch: '图卡卡斯（委内瑞拉）' },
    { port_code: 'VEN126', port_ch: '图里亚莫（委内瑞拉）' },
    { port_code: 'VEN901', port_ch: '加拉加斯（委内瑞拉）' },
    { port_code: 'VGB000', port_ch: '英属维尔京群岛' },
    { port_code: 'VGB001', port_ch: '阿内加达岛（英属维尔京群岛）' },
    { port_code: 'VGB002', port_ch: '毖尔京-戈达岛（英属维尔京群岛）' },
    { port_code: 'VGB003', port_ch: '托托拉岛（英属维尔京群岛）' },
    { port_code: 'VGB006', port_ch: '罗德城（英属维尔京群岛）' },
    { port_code: 'VIR000', port_ch: '维尔京群岛(美国)' },
    { port_code: 'VIR002', port_ch: '夏洛特阿马利亚（维尔京群岛(美国)）' },
    { port_code: 'VIR003', port_ch: '克里斯琴斯特德（维尔京群岛(美国)）' },
    { port_code: 'VIR006', port_ch: '弗雷德里克斯特德（维尔京群岛(美国)）' },
    { port_code: 'VIR007', port_ch: '圣约翰岛（维尔京群岛(美国)）' },
    { port_code: 'VIR008', port_ch: '圣托马（维尔京群岛(美国)）' },
    { port_code: 'VIR009', port_ch: '美属维尔京（维尔京群岛(美国)）' },
    { port_code: 'VIR010', port_ch: '莱姆特里贝（维尔京群岛(美国)）' },
    { port_code: 'VNM000', port_ch: '越南' },
    { port_code: 'VNM001', port_ch: '金兰（越南）' },
    { port_code: 'VNM003', port_ch: '边水（越南）' },
    { port_code: 'VNM006', port_ch: '岘港（越南）' },
    { port_code: 'VNM009', port_ch: '海防（越南）' },
    { port_code: 'VNM012', port_ch: '胡志明市（越南）' },
    { port_code: 'VNM015', port_ch: '鸿基（越南）' },
    { port_code: 'VNM018', port_ch: '顺化（越南）' },
    { port_code: 'VNM021', port_ch: '广义（越南）' },
    { port_code: 'VNM024', port_ch: '美富（越南）' },
    { port_code: 'VNM027', port_ch: '芽庄（越南）' },
    { port_code: 'VNM030', port_ch: '锦普港（越南）' },
    { port_code: 'VNM033', port_ch: '雷东港（越南）' },
    { port_code: 'VNM036', port_ch: '归仁（越南）' },
    { port_code: 'VNM039', port_ch: '荣市（越南）' },
    { port_code: 'VNM042', port_ch: '头顿（越南）' },
    { port_code: 'VNM901', port_ch: '河内（越南）' },
    { port_code: 'VNM902', port_ch: '金兰湾（越南）' },
    { port_code: 'VNM903', port_ch: '友谊关（越南）' },
    { port_code: 'VNM904', port_ch: '同登（越南）' },
    { port_code: 'VNM905', port_ch: '新青（越南）' },
    { port_code: 'VNM906', port_ch: '寺马（越南）' },
    { port_code: 'VNM907', port_ch: '驮龙（越南）' },
    { port_code: 'VNM908', port_ch: '茶岭（越南）' },
    { port_code: 'VNM909', port_ch: '朔江（越南）' },
    { port_code: 'VNM910', port_ch: '老街（越南）' },
    { port_code: 'VUT000', port_ch: '瓦努阿图' },
    { port_code: 'VUT001', port_ch: '马勒库拉岛（瓦努阿图）' },
    { port_code: 'VUT002', port_ch: '埃罗芒加岛（瓦努阿图）' },
    { port_code: 'VUT003', port_ch: '卢甘维尔港（瓦努阿图）' },
    { port_code: 'VUT004', port_ch: '圣埃斯皮里图岛（瓦努阿图）' },
    { port_code: 'VUT005', port_ch: '圣多明各（瓦努阿图）' },
    { port_code: 'VUT006', port_ch: '维拉港（瓦努阿图）' },
    { port_code: 'VUT007', port_ch: '塔纳岛（瓦努阿图）' },
    { port_code: 'VUT009', port_ch: '桑托（瓦努阿图）' },
    { port_code: 'WLF000', port_ch: '瓦利斯和富图纳群岛' },
    { port_code: 'WLF003', port_ch: '马塔乌图（瓦利斯和富图纳群岛）' },
    { port_code: 'WLF004', port_ch: '锡加维（瓦利斯和富图纳群岛）' },
    { port_code: 'WLF005', port_ch: '穆阿（瓦利斯和富图纳群岛）' },
    { port_code: 'WSM000', port_ch: '萨摩亚' },
    { port_code: 'WSM003', port_ch: '阿皮亚（萨摩亚）' },
    { port_code: 'WSM004', port_ch: '阿绍（萨摩亚）' },
    { port_code: 'WSM005', port_ch: '木利努乌（萨摩亚）' },
    { port_code: 'WSM006', port_ch: '萨瓦伊（萨摩亚）' },
    { port_code: 'WSM007', port_ch: '萨瓦伊岛（萨摩亚）' },
    { port_code: 'WSM008', port_ch: '乌波卢岛（萨摩亚）' },
    { port_code: 'YEM000', port_ch: '也门' },
    { port_code: 'YEM001', port_ch: '萨那（也门）' },
    { port_code: 'YEM003', port_ch: '亚丁（也门）' },
    { port_code: 'YEM006', port_ch: '荷台达（也门）' },
    { port_code: 'YEM009', port_ch: '穆哈（也门）' },
    { port_code: 'YEM012', port_ch: '穆卡拉（也门）' },
    { port_code: 'YEM013', port_ch: '萨利夫（也门）' },
    { port_code: 'YEM015', port_ch: '卡塞卜角（也门）' },
    { port_code: 'YEM021', port_ch: '索科特拉岛（也门）' },
    { port_code: 'ZAF000', port_ch: '南非' },
    { port_code: 'ZAO000', port_ch: '非洲其他国家(地区)' },
    { port_code: 'ZAF003', port_ch: '开普敦（南非）' },
    { port_code: 'ZAF006', port_ch: '德班（南非）' },
    { port_code: 'ZAF009', port_ch: '东伦敦（南非）' },
    { port_code: 'ZAF012', port_ch: '莫塞尔贝（南非）' },
    { port_code: 'ZAF015', port_ch: '伊丽莎白港（南非）' },
    { port_code: 'ZAF018', port_ch: '里查德湾（南非）' },
    { port_code: 'ZAF021', port_ch: '萨尔达尼亚湾（南非）' },
    { port_code: 'ZAF024', port_ch: '西蒙斯敦（南非）' },
    { port_code: 'ZAF027', port_ch: '诺洛斯港（南非）' },
    { port_code: 'ZAF901', port_ch: '约翰内斯堡（南非）' },
    { port_code: 'ZAS000', port_ch: '亚洲其他国家(地区)' },
    { port_code: 'ZEU000', port_ch: '欧洲其他国家(地区)' },
    { port_code: 'ZMB000', port_ch: '赞比亚' },
    { port_code: 'ZMB001', port_ch: '恩多拉（赞比亚）' },
    { port_code: 'ZNA000', port_ch: '北美洲其他国家(地区)' },
    { port_code: 'ZOC000', port_ch: '大洋洲其他国家(地区)' },
    { port_code: 'ZSA000', port_ch: '拉丁美洲其他国家(地区)' },
    { port_code: 'ZWE000', port_ch: '津巴布韦' },
    { port_code: 'ZZZ900', port_ch: '未列出的特殊监管区' },
    { port_code: 'ZZZ999', port_ch: '未列出的国家或地区贸易港' },
    { port_code: '991101', port_ch: '北京天竺综合保税区' },
    { port_code: '991201', port_ch: '天津出口加工区' },
    { port_code: '991202', port_ch: '天津保税物流园区' },
    { port_code: '991203', port_ch: '天津港保税区' },
    { port_code: '991204', port_ch: '天津东疆保税港区' },
    { port_code: '991205', port_ch: '天津滨海新区综合保税区' },
    { port_code: '991206', port_ch: '中国（天津）自由贸易试验区' },
    { port_code: '991301', port_ch: '石家庄综合保税区' },
    { port_code: '991302', port_ch: '曹妃甸综合保税区' },
    { port_code: '991303', port_ch: '秦皇岛出口加工区' },
    { port_code: '991304', port_ch: '廊坊出口加工区' },
    { port_code: '991401', port_ch: '太原武宿综合保税区' },
    { port_code: '991501', port_ch: '呼和浩特出口加工区' },
    { port_code: '991502', port_ch: '满洲里综合保税区' },
    { port_code: '992101', port_ch: '沈阳综合保税区' },
    { port_code: '992102', port_ch: '大连保税区' },
    { port_code: '992103', port_ch: '大连出口加工区' },
    { port_code: '992104', port_ch: '大连大窑湾保税港区' },
    { port_code: '992105', port_ch: '营口港保税物流园区' },
    { port_code: '992201', port_ch: '长春兴隆综合保税区' },
    { port_code: '992202', port_ch: '珲春出口加工区' },
    { port_code: '992301', port_ch: '绥芬河综合保税区' },
    { port_code: '993101', port_ch: '上海漕河泾出口加工区' },
    { port_code: '993102', port_ch: '上海闵行出口加工区' },
    { port_code: '993103', port_ch: '上海嘉定出口加工区' },
    { port_code: '993104', port_ch: '上海金桥出口加工区' },
    { port_code: '993105', port_ch: '上海浦东机场综合保税区' },
    { port_code: '993106', port_ch: '上海外高桥保税物流园区' },
    { port_code: '993107', port_ch: '上海外高桥保税区' },
    { port_code: '993108', port_ch: '上海松江出口加工区A区' },
    { port_code: '993109', port_ch: '上海松江出口加工区B区' },
    { port_code: '993110', port_ch: '上海青浦出口加工区' },
    { port_code: '993111', port_ch: '洋山保税港区' },
    { port_code: '993112', port_ch: '中国（上海）自由贸易试验区' },
    { port_code: '993201', port_ch: '南京出口加工区' },
    { port_code: '993202', port_ch: '南京综合保税区' },
    { port_code: '993203', port_ch: '无锡高新区综合保税区' },
    { port_code: '993204', port_ch: '无锡出口加工区' },
    { port_code: '993205', port_ch: '常州出口加工区' },
    { port_code: '993206', port_ch: '武进出口加工区' },
    { port_code: '993207', port_ch: '苏州工业园综合保税区' },
    { port_code: '993208', port_ch: '苏州高新技术产业开发区综合保税区' },
    { port_code: '993209', port_ch: '太仓港综合保税区' },
    { port_code: '993210', port_ch: '吴中出口加工区' },
    { port_code: '993211', port_ch: '常熟出口加工区' },
    { port_code: '993212', port_ch: '张家港保税港区' },
    { port_code: '993213', port_ch: '昆山综合保税区' },
    { port_code: '993214', port_ch: '吴江出口加工区' },
    { port_code: '993215', port_ch: '南通综合保税区' },
    { port_code: '993216', port_ch: '南通出口加工区' },
    { port_code: '993217', port_ch: '连云港出口加工区' },
    { port_code: '993218', port_ch: '淮安综合保税区' },
    { port_code: '993219', port_ch: '淮安出口加工区' },
    { port_code: '993220', port_ch: '盐城综合保税区' },
    { port_code: '993221', port_ch: '扬州出口加工区' },
    { port_code: '993222', port_ch: '镇江出口加工区' },
    { port_code: '993223', port_ch: '泰州出口加工区' },
    { port_code: '993301', port_ch: '杭州出口加工区' },
    { port_code: '993302', port_ch: '杭州保税物流园区（B型）' },
    { port_code: '993303', port_ch: '杭州中和保税区' },
    { port_code: '993304', port_ch: '舟山港综合保税区' },
    { port_code: '993305', port_ch: '嘉兴出口加工区A区' },
    { port_code: '993306', port_ch: '嘉兴出口加工区B区' },
    { port_code: '993307', port_ch: '金义综合保税区' },
    { port_code: '993401', port_ch: '合肥出口加工区' },
    { port_code: '993402', port_ch: '合肥综合保税区' },
    { port_code: '993403', port_ch: '芜湖出口加工区' },
    { port_code: '993501', port_ch: '福州保税港区' },
    { port_code: '993502', port_ch: '福州保税区' },
    { port_code: '993503', port_ch: '福州出口加工区' },
    { port_code: '993504', port_ch: '贵安综合保税区' },
    { port_code: '993505', port_ch: '泉州出口加工区' },
    { port_code: '993506', port_ch: '中国（福建）自由贸易试验区' },
    { port_code: '993601', port_ch: '南昌出口加工区' },
    { port_code: '993602', port_ch: '九江出口加工区' },
    { port_code: '993603', port_ch: '赣州出口加工区' },
    { port_code: '993604', port_ch: '赣州综合保税区' },
    { port_code: '993605', port_ch: '井冈山出口加工区' },
    { port_code: '993701', port_ch: '济南综合保税区' },
    { port_code: '993702', port_ch: '济南出口加工区' },
    { port_code: '993703', port_ch: '青岛出口加工区' },
    { port_code: '993704', port_ch: '青岛前湾保税港区' },
    { port_code: '993705', port_ch: '青岛西海岸出口加工区' },
    { port_code: '993706', port_ch: '东营综合保税区' },
    { port_code: '993707', port_ch: '烟台保税港区A区' },
    { port_code: '993708', port_ch: '烟台保税港区B区' },
    { port_code: '993709', port_ch: '潍坊综合保税区' },
    { port_code: '993710', port_ch: '威海出口加工区' },
    { port_code: '993711', port_ch: '临沂综合保税区' },
    { port_code: '993801', port_ch: '宁波出口加工区' },
    { port_code: '993802', port_ch: '宁波保税区' },
    { port_code: '993803', port_ch: '宁波梅山保税港区' },
    { port_code: '993804', port_ch: '慈溪出口加工区' },
    { port_code: '993901', port_ch: '厦门保税区' },
    { port_code: '993902', port_ch: '厦门海沧保税港区' },
    { port_code: '993903', port_ch: '厦门象屿保税物流园区' },
    { port_code: '993904', port_ch: '厦门翔安火炬保税物流园区' },
    { port_code: '994101', port_ch: '郑州出口加工区' },
    { port_code: '994102', port_ch: '郑州新郑综合保税区' },
    { port_code: '994103', port_ch: '南阳卧龙综合保税区' },
    { port_code: '994201', port_ch: '武汉出口加工区' },
    { port_code: '994202', port_ch: '武汉东西湖保税物流园区' },
    { port_code: '994203', port_ch: '武汉东湖综合保税区' },
    { port_code: '994204', port_ch: '武汉新港空港综合保税区' },
    { port_code: '994301', port_ch: '长沙金霞保税物流园区' },
    { port_code: '994302', port_ch: '湘潭综合保税区' },
    { port_code: '994303', port_ch: '衡阳综合保税区' },
    { port_code: '994304', port_ch: '岳阳城陵矶综合保税区' },
    { port_code: '994305', port_ch: '郴州出口加工区' },
    { port_code: '994306', port_ch: '长沙黄花综合保税区' },
    { port_code: '994401', port_ch: '广州保税物流园区' },
    { port_code: '994402', port_ch: '广州保税区' },
    { port_code: '994403', port_ch: '广州出口加工区' },
    { port_code: '994404', port_ch: '广州白云机场综合保税区' },
    { port_code: '994405', port_ch: '广州南沙保税港区' },
    { port_code: '994406', port_ch: '汕头保税区' },
    { port_code: '994407', port_ch: '中国（广东）自由贸易试验区' },
    { port_code: '994501', port_ch: '北海出口加工区' },
    { port_code: '994502', port_ch: '钦州保税港区' },
    { port_code: '994503', port_ch: '凭祥综合保税区' },
    { port_code: '994601', port_ch: '海口综合保税区' },
    { port_code: '994602', port_ch: '洋浦保税港区' },
    { port_code: '994701', port_ch: '深圳出口加工区' },
    { port_code: '994702', port_ch: '深圳福田保税区' },
    { port_code: '994703', port_ch: '深圳前海湾保税港区' },
    { port_code: '994704', port_ch: '深圳盐田保税物流园区' },
    { port_code: '994705', port_ch: '深圳盐田保税区' },
    { port_code: '994706', port_ch: '深圳沙头角保税区' },
    { port_code: '994801', port_ch: '珠海保税区加华码头' },
    { port_code: '994802', port_ch: '珠海保税区货场' },
    { port_code: '994803', port_ch: '珠澳跨境工业区（珠海园区）货场' },
    { port_code: '994804', port_ch: '珠澳跨境工业区（珠海园区）旅检通道' },
    { port_code: '995001', port_ch: '重庆两路寸滩保税港区水港' },
    { port_code: '995002', port_ch: '重庆两路寸滩保税港区空港' },
    { port_code: '995003', port_ch: '重庆西永综合保税区' },
    { port_code: '995101', port_ch: '成都高新综合保税区双流园区' },
    { port_code: '995102', port_ch: '成都高新综合保税区A区' },
    { port_code: '995103', port_ch: '成都高新综合保税区B区' },
    { port_code: '995104', port_ch: '成都高新综合保税区C区' },
    { port_code: '995105', port_ch: '绵阳出口加工区' },
    { port_code: '995201', port_ch: '贵阳综合保税区' },
    { port_code: '995301', port_ch: '昆明出口加工区' },
    { port_code: '995302', port_ch: '昆明综合保税区' },
    { port_code: '995303', port_ch: '红河综合保税区' },
    { port_code: '996101', port_ch: '西安综合保税区' },
    { port_code: '996102', port_ch: '西安出口加工区' },
    { port_code: '996103', port_ch: '西安高新综合保税区' },
    { port_code: '996201', port_ch: '兰州新区综合保税区' },
    { port_code: '996501', port_ch: '乌鲁木齐出口加工区' },
    { port_code: '996502', port_ch: '阿拉山口综合保税区' },
    { port_code: '996503', port_ch: '喀什综合保税区' },
    { port_code: '996504', port_ch: '霍尔果斯国际边境合作中心（中方配套区）' }
];

export default arr;


// WEBPACK FOOTER //
// ./static/js/entreport.js